window.jQuery || function(t, e) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
        if (!t.document)
            throw new Error("jQuery requires a window with a document");
        return e(t)
    }
    : e(t)
}("undefined" != typeof window ? window : this, function(t, e) {
    var n = []
      , i = t.document
      , r = n.slice
      , o = n.concat
      , s = n.push
      , a = n.indexOf
      , u = {}
      , l = u.toString
      , c = u.hasOwnProperty
      , d = {}
      , h = "2.2.3"
      , p = function(t, e) {
        return new p.fn.init(t,e)
    }
      , f = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
      , g = /^-ms-/
      , m = /-([\da-z])/gi
      , v = function(t, e) {
        return e.toUpperCase()
    };
    function y(t) {
        var e = !!t && "length"in t && t.length
          , n = p.type(t);
        return "function" !== n && !p.isWindow(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
    }
    p.fn = p.prototype = {
        jquery: h,
        constructor: p,
        selector: "",
        length: 0,
        toArray: function() {
            return r.call(this)
        },
        get: function(t) {
            return null != t ? 0 > t ? this[t + this.length] : this[t] : r.call(this)
        },
        pushStack: function(t) {
            var e = p.merge(this.constructor(), t);
            return e.prevObject = this,
            e.context = this.context,
            e
        },
        each: function(t) {
            return p.each(this, t)
        },
        map: function(t) {
            return this.pushStack(p.map(this, function(e, n) {
                return t.call(e, n, e)
            }))
        },
        slice: function() {
            return this.pushStack(r.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(t) {
            var e = this.length
              , n = +t + (0 > t ? e : 0);
            return this.pushStack(n >= 0 && e > n ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: s,
        sort: n.sort,
        splice: n.splice
    },
    p.extend = p.fn.extend = function() {
        var t, e, n, i, r, o, s = arguments[0] || {}, a = 1, u = arguments.length, l = !1;
        for ("boolean" == typeof s && (l = s,
        s = arguments[a] || {},
        a++),
        "object" == typeof s || p.isFunction(s) || (s = {}),
        a === u && (s = this,
        a--); u > a; a++)
            if (null != (t = arguments[a]))
                for (e in t)
                    n = s[e],
                    s !== (i = t[e]) && (l && i && (p.isPlainObject(i) || (r = p.isArray(i))) ? (r ? (r = !1,
                    o = n && p.isArray(n) ? n : []) : o = n && p.isPlainObject(n) ? n : {},
                    s[e] = p.extend(l, o, i)) : void 0 !== i && (s[e] = i));
        return s
    }
    ,
    p.extend({
        expando: "jQuery" + (h + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw new Error(t)
        },
        noop: function() {},
        isFunction: function(t) {
            return "function" === p.type(t)
        },
        isArray: Array.isArray,
        isWindow: function(t) {
            return null != t && t === t.window
        },
        isNumeric: function(t) {
            var e = t && t.toString();
            return !p.isArray(t) && e - parseFloat(e) + 1 >= 0
        },
        isPlainObject: function(t) {
            var e;
            if ("object" !== p.type(t) || t.nodeType || p.isWindow(t))
                return !1;
            if (t.constructor && !c.call(t, "constructor") && !c.call(t.constructor.prototype || {}, "isPrototypeOf"))
                return !1;
            for (e in t)
                ;
            return void 0 === e || c.call(t, e)
        },
        isEmptyObject: function(t) {
            var e;
            for (e in t)
                return !1;
            return !0
        },
        type: function(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? u[l.call(t)] || "object" : typeof t
        },
        globalEval: function(t) {
            var e, n = eval;
            (t = p.trim(t)) && (1 === t.indexOf("use strict") ? ((e = i.createElement("script")).text = t,
            i.head.appendChild(e).parentNode.removeChild(e)) : n(t))
        },
        camelCase: function(t) {
            return t.replace(g, "ms-").replace(m, v)
        },
        nodeName: function(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        },
        each: function(t, e) {
            var n, i = 0;
            if (y(t))
                for (n = t.length; n > i && !1 !== e.call(t[i], i, t[i]); i++)
                    ;
            else
                for (i in t)
                    if (!1 === e.call(t[i], i, t[i]))
                        break;
            return t
        },
        trim: function(t) {
            return null == t ? "" : (t + "").replace(f, "")
        },
        makeArray: function(t, e) {
            var n = e || [];
            return null != t && (y(Object(t)) ? p.merge(n, "string" == typeof t ? [t] : t) : s.call(n, t)),
            n
        },
        inArray: function(t, e, n) {
            return null == e ? -1 : a.call(e, t, n)
        },
        merge: function(t, e) {
            for (var n = +e.length, i = 0, r = t.length; n > i; i++)
                t[r++] = e[i];
            return t.length = r,
            t
        },
        grep: function(t, e, n) {
            for (var i = [], r = 0, o = t.length, s = !n; o > r; r++)
                !e(t[r], r) !== s && i.push(t[r]);
            return i
        },
        map: function(t, e, n) {
            var i, r, s = 0, a = [];
            if (y(t))
                for (i = t.length; i > s; s++)
                    null != (r = e(t[s], s, n)) && a.push(r);
            else
                for (s in t)
                    null != (r = e(t[s], s, n)) && a.push(r);
            return o.apply([], a)
        },
        guid: 1,
        proxy: function(t, e) {
            var n, i, o;
            return "string" == typeof e && (n = t[e],
            e = t,
            t = n),
            p.isFunction(t) ? (i = r.call(arguments, 2),
            (o = function() {
                return t.apply(e || this, i.concat(r.call(arguments)))
            }
            ).guid = t.guid = t.guid || p.guid++,
            o) : void 0
        },
        now: Date.now,
        support: d
    }),
    "function" == typeof Symbol && (p.fn[Symbol.iterator] = n[Symbol.iterator]),
    p.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
        u["[object " + e + "]"] = e.toLowerCase()
    });
    var x = function(t) {
        var e, n, i, r, o, s, a, u, l, c, d, h, p, f, g, m, v, y, x, w = "sizzle" + 1 * new Date, b = t.document, _ = 0, T = 0, C = ot(), S = ot(), L = ot(), q = function(t, e) {
            return t === e && (d = !0),
            0
        }, D = 1 << 31, k = {}.hasOwnProperty, E = [], j = E.pop, N = E.push, A = E.push, P = E.slice, G = function(t, e) {
            for (var n = 0, i = t.length; i > n; n++)
                if (t[n] === e)
                    return n;
            return -1
        }, $ = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", O = "[\\x20\\t\\r\\n\\f]", R = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", M = "\\[" + O + "*(" + R + ")(?:" + O + "*([*^$|!~]?=)" + O + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + O + "*\\]", B = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + M + ")*)|.*)\\)|)", F = new RegExp(O + "+","g"), z = new RegExp("^" + O + "+|((?:^|[^\\\\])(?:\\\\.)*)" + O + "+$","g"), I = new RegExp("^" + O + "*," + O + "*"), H = new RegExp("^" + O + "*([>+~]|" + O + ")" + O + "*"), W = new RegExp("=" + O + "*([^\\]'\"]*?)" + O + "*\\]","g"), U = new RegExp(B), V = new RegExp("^" + R + "$"), X = {
            ID: new RegExp("^#(" + R + ")"),
            CLASS: new RegExp("^\\.(" + R + ")"),
            TAG: new RegExp("^(" + R + "|[*])"),
            ATTR: new RegExp("^" + M),
            PSEUDO: new RegExp("^" + B),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + O + "*(even|odd|(([+-]|)(\\d*)n|)" + O + "*(?:([+-]|)" + O + "*(\\d+)|))" + O + "*\\)|)","i"),
            bool: new RegExp("^(?:" + $ + ")$","i"),
            needsContext: new RegExp("^" + O + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + O + "*((?:-\\d)?\\d*)" + O + "*\\)|)(?=[^-]|$)","i")
        }, Y = /^(?:input|select|textarea|button)$/i, J = /^h\d$/i, Q = /^[^{]+\{\s*\[native \w/, Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, K = /[+~]/, tt = /'|\\/g, et = new RegExp("\\\\([\\da-f]{1,6}" + O + "?|(" + O + ")|.)","ig"), nt = function(t, e, n) {
            var i = "0x" + e - 65536;
            return i != i || n ? e : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
        }, it = function() {
            h()
        };
        try {
            A.apply(E = P.call(b.childNodes), b.childNodes),
            E[b.childNodes.length].nodeType
        } catch (t) {
            A = {
                apply: E.length ? function(t, e) {
                    N.apply(t, P.call(e))
                }
                : function(t, e) {
                    for (var n = t.length, i = 0; t[n++] = e[i++]; )
                        ;
                    t.length = n - 1
                }
            }
        }
        function rt(t, e, i, r) {
            var o, a, l, c, d, f, v, y, _ = e && e.ownerDocument, T = e ? e.nodeType : 9;
            if (i = i || [],
            "string" != typeof t || !t || 1 !== T && 9 !== T && 11 !== T)
                return i;
            if (!r && ((e ? e.ownerDocument || e : b) !== p && h(e),
            e = e || p,
            g)) {
                if (11 !== T && (f = Z.exec(t)))
                    if (o = f[1]) {
                        if (9 === T) {
                            if (!(l = e.getElementById(o)))
                                return i;
                            if (l.id === o)
                                return i.push(l),
                                i
                        } else if (_ && (l = _.getElementById(o)) && x(e, l) && l.id === o)
                            return i.push(l),
                            i
                    } else {
                        if (f[2])
                            return A.apply(i, e.getElementsByTagName(t)),
                            i;
                        if ((o = f[3]) && n.getElementsByClassName && e.getElementsByClassName)
                            return A.apply(i, e.getElementsByClassName(o)),
                            i
                    }
                if (n.qsa && !L[t + " "] && (!m || !m.test(t))) {
                    if (1 !== T)
                        _ = e,
                        y = t;
                    else if ("object" !== e.nodeName.toLowerCase()) {
                        for ((c = e.getAttribute("id")) ? c = c.replace(tt, "\\$&") : e.setAttribute("id", c = w),
                        a = (v = s(t)).length,
                        d = V.test(c) ? "#" + c : "[id='" + c + "']"; a--; )
                            v[a] = d + " " + gt(v[a]);
                        y = v.join(","),
                        _ = K.test(t) && pt(e.parentNode) || e
                    }
                    if (y)
                        try {
                            return A.apply(i, _.querySelectorAll(y)),
                            i
                        } catch (t) {} finally {
                            c === w && e.removeAttribute("id")
                        }
                }
            }
            return u(t.replace(z, "$1"), e, i, r)
        }
        function ot() {
            var t = [];
            return function e(n, r) {
                return t.push(n + " ") > i.cacheLength && delete e[t.shift()],
                e[n + " "] = r
            }
        }
        function st(t) {
            return t[w] = !0,
            t
        }
        function at(t) {
            var e = p.createElement("div");
            try {
                return !!t(e)
            } catch (t) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e),
                e = null
            }
        }
        function ut(t, e) {
            for (var n = t.split("|"), r = n.length; r--; )
                i.attrHandle[n[r]] = e
        }
        function lt(t, e) {
            var n = e && t
              , i = n && 1 === t.nodeType && 1 === e.nodeType && (~e.sourceIndex || D) - (~t.sourceIndex || D);
            if (i)
                return i;
            if (n)
                for (; n = n.nextSibling; )
                    if (n === e)
                        return -1;
            return t ? 1 : -1
        }
        function ct(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }
        function dt(t) {
            return function(e) {
                var n = e.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && e.type === t
            }
        }
        function ht(t) {
            return st(function(e) {
                return e = +e,
                st(function(n, i) {
                    for (var r, o = t([], n.length, e), s = o.length; s--; )
                        n[r = o[s]] && (n[r] = !(i[r] = n[r]))
                })
            })
        }
        function pt(t) {
            return t && void 0 !== t.getElementsByTagName && t
        }
        for (e in n = rt.support = {},
        o = rt.isXML = function(t) {
            var e = t && (t.ownerDocument || t).documentElement;
            return !!e && "HTML" !== e.nodeName
        }
        ,
        h = rt.setDocument = function(t) {
            var e, r, s = t ? t.ownerDocument || t : b;
            return s !== p && 9 === s.nodeType && s.documentElement ? (f = (p = s).documentElement,
            g = !o(p),
            (r = p.defaultView) && r.top !== r && (r.addEventListener ? r.addEventListener("unload", it, !1) : r.attachEvent && r.attachEvent("onunload", it)),
            n.attributes = at(function(t) {
                return t.className = "i",
                !t.getAttribute("className")
            }),
            n.getElementsByTagName = at(function(t) {
                return t.appendChild(p.createComment("")),
                !t.getElementsByTagName("*").length
            }),
            n.getElementsByClassName = Q.test(p.getElementsByClassName),
            n.getById = at(function(t) {
                return f.appendChild(t).id = w,
                !p.getElementsByName || !p.getElementsByName(w).length
            }),
            n.getById ? (i.find.ID = function(t, e) {
                if (void 0 !== e.getElementById && g) {
                    var n = e.getElementById(t);
                    return n ? [n] : []
                }
            }
            ,
            i.filter.ID = function(t) {
                var e = t.replace(et, nt);
                return function(t) {
                    return t.getAttribute("id") === e
                }
            }
            ) : (delete i.find.ID,
            i.filter.ID = function(t) {
                var e = t.replace(et, nt);
                return function(t) {
                    var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                    return n && n.value === e
                }
            }
            ),
            i.find.TAG = n.getElementsByTagName ? function(t, e) {
                return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : n.qsa ? e.querySelectorAll(t) : void 0
            }
            : function(t, e) {
                var n, i = [], r = 0, o = e.getElementsByTagName(t);
                if ("*" === t) {
                    for (; n = o[r++]; )
                        1 === n.nodeType && i.push(n);
                    return i
                }
                return o
            }
            ,
            i.find.CLASS = n.getElementsByClassName && function(t, e) {
                return void 0 !== e.getElementsByClassName && g ? e.getElementsByClassName(t) : void 0
            }
            ,
            v = [],
            m = [],
            (n.qsa = Q.test(p.querySelectorAll)) && (at(function(t) {
                f.appendChild(t).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                t.querySelectorAll("[msallowcapture^='']").length && m.push("[*^$]=" + O + "*(?:''|\"\")"),
                t.querySelectorAll("[selected]").length || m.push("\\[" + O + "*(?:value|" + $ + ")"),
                t.querySelectorAll("[id~=" + w + "-]").length || m.push("~="),
                t.querySelectorAll(":checked").length || m.push(":checked"),
                t.querySelectorAll("a#" + w + "+*").length || m.push(".#.+[+~]")
            }),
            at(function(t) {
                var e = p.createElement("input");
                e.setAttribute("type", "hidden"),
                t.appendChild(e).setAttribute("name", "D"),
                t.querySelectorAll("[name=d]").length && m.push("name" + O + "*[*^$|!~]?="),
                t.querySelectorAll(":enabled").length || m.push(":enabled", ":disabled"),
                t.querySelectorAll("*,:x"),
                m.push(",.*:")
            })),
            (n.matchesSelector = Q.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && at(function(t) {
                n.disconnectedMatch = y.call(t, "div"),
                y.call(t, "[s!='']:x"),
                v.push("!=", B)
            }),
            m = m.length && new RegExp(m.join("|")),
            v = v.length && new RegExp(v.join("|")),
            e = Q.test(f.compareDocumentPosition),
            x = e || Q.test(f.contains) ? function(t, e) {
                var n = 9 === t.nodeType ? t.documentElement : t
                  , i = e && e.parentNode;
                return t === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i)))
            }
            : function(t, e) {
                if (e)
                    for (; e = e.parentNode; )
                        if (e === t)
                            return !0;
                return !1
            }
            ,
            q = e ? function(t, e) {
                if (t === e)
                    return d = !0,
                    0;
                var i = !t.compareDocumentPosition - !e.compareDocumentPosition;
                return i || (1 & (i = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !n.sortDetached && e.compareDocumentPosition(t) === i ? t === p || t.ownerDocument === b && x(b, t) ? -1 : e === p || e.ownerDocument === b && x(b, e) ? 1 : c ? G(c, t) - G(c, e) : 0 : 4 & i ? -1 : 1)
            }
            : function(t, e) {
                if (t === e)
                    return d = !0,
                    0;
                var n, i = 0, r = t.parentNode, o = e.parentNode, s = [t], a = [e];
                if (!r || !o)
                    return t === p ? -1 : e === p ? 1 : r ? -1 : o ? 1 : c ? G(c, t) - G(c, e) : 0;
                if (r === o)
                    return lt(t, e);
                for (n = t; n = n.parentNode; )
                    s.unshift(n);
                for (n = e; n = n.parentNode; )
                    a.unshift(n);
                for (; s[i] === a[i]; )
                    i++;
                return i ? lt(s[i], a[i]) : s[i] === b ? -1 : a[i] === b ? 1 : 0
            }
            ,
            p) : p
        }
        ,
        rt.matches = function(t, e) {
            return rt(t, null, null, e)
        }
        ,
        rt.matchesSelector = function(t, e) {
            if ((t.ownerDocument || t) !== p && h(t),
            e = e.replace(W, "='$1']"),
            n.matchesSelector && g && !L[e + " "] && (!v || !v.test(e)) && (!m || !m.test(e)))
                try {
                    var i = y.call(t, e);
                    if (i || n.disconnectedMatch || t.document && 11 !== t.document.nodeType)
                        return i
                } catch (t) {}
            return rt(e, p, null, [t]).length > 0
        }
        ,
        rt.contains = function(t, e) {
            return (t.ownerDocument || t) !== p && h(t),
            x(t, e)
        }
        ,
        rt.attr = function(t, e) {
            (t.ownerDocument || t) !== p && h(t);
            var r = i.attrHandle[e.toLowerCase()]
              , o = r && k.call(i.attrHandle, e.toLowerCase()) ? r(t, e, !g) : void 0;
            return void 0 !== o ? o : n.attributes || !g ? t.getAttribute(e) : (o = t.getAttributeNode(e)) && o.specified ? o.value : null
        }
        ,
        rt.error = function(t) {
            throw new Error("Syntax error, unrecognized expression: " + t)
        }
        ,
        rt.uniqueSort = function(t) {
            var e, i = [], r = 0, o = 0;
            if (d = !n.detectDuplicates,
            c = !n.sortStable && t.slice(0),
            t.sort(q),
            d) {
                for (; e = t[o++]; )
                    e === t[o] && (r = i.push(o));
                for (; r--; )
                    t.splice(i[r], 1)
            }
            return c = null,
            t
        }
        ,
        r = rt.getText = function(t) {
            var e, n = "", i = 0, o = t.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof t.textContent)
                        return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling)
                        n += r(t)
                } else if (3 === o || 4 === o)
                    return t.nodeValue
            } else
                for (; e = t[i++]; )
                    n += r(e);
            return n
        }
        ,
        (i = rt.selectors = {
            cacheLength: 50,
            createPseudo: st,
            match: X,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(t) {
                    return t[1] = t[1].replace(et, nt),
                    t[3] = (t[3] || t[4] || t[5] || "").replace(et, nt),
                    "~=" === t[2] && (t[3] = " " + t[3] + " "),
                    t.slice(0, 4)
                },
                CHILD: function(t) {
                    return t[1] = t[1].toLowerCase(),
                    "nth" === t[1].slice(0, 3) ? (t[3] || rt.error(t[0]),
                    t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])),
                    t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && rt.error(t[0]),
                    t
                },
                PSEUDO: function(t) {
                    var e, n = !t[6] && t[2];
                    return X.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && U.test(n) && (e = s(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e),
                    t[2] = n.slice(0, e)),
                    t.slice(0, 3))
                }
            },
            filter: {
                TAG: function(t) {
                    var e = t.replace(et, nt).toLowerCase();
                    return "*" === t ? function() {
                        return !0
                    }
                    : function(t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e
                    }
                },
                CLASS: function(t) {
                    var e = C[t + " "];
                    return e || (e = new RegExp("(^|" + O + ")" + t + "(" + O + "|$)")) && C(t, function(t) {
                        return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                    })
                },
                ATTR: function(t, e, n) {
                    return function(i) {
                        var r = rt.attr(i, t);
                        return null == r ? "!=" === e : !e || (r += "",
                        "=" === e ? r === n : "!=" === e ? r !== n : "^=" === e ? n && 0 === r.indexOf(n) : "*=" === e ? n && r.indexOf(n) > -1 : "$=" === e ? n && r.slice(-n.length) === n : "~=" === e ? (" " + r.replace(F, " ") + " ").indexOf(n) > -1 : "|=" === e && (r === n || r.slice(0, n.length + 1) === n + "-"))
                    }
                },
                CHILD: function(t, e, n, i, r) {
                    var o = "nth" !== t.slice(0, 3)
                      , s = "last" !== t.slice(-4)
                      , a = "of-type" === e;
                    return 1 === i && 0 === r ? function(t) {
                        return !!t.parentNode
                    }
                    : function(e, n, u) {
                        var l, c, d, h, p, f, g = o !== s ? "nextSibling" : "previousSibling", m = e.parentNode, v = a && e.nodeName.toLowerCase(), y = !u && !a, x = !1;
                        if (m) {
                            if (o) {
                                for (; g; ) {
                                    for (h = e; h = h[g]; )
                                        if (a ? h.nodeName.toLowerCase() === v : 1 === h.nodeType)
                                            return !1;
                                    f = g = "only" === t && !f && "nextSibling"
                                }
                                return !0
                            }
                            if (f = [s ? m.firstChild : m.lastChild],
                            s && y) {
                                for (x = (p = (l = (c = (d = (h = m)[w] || (h[w] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] || [])[0] === _ && l[1]) && l[2],
                                h = p && m.childNodes[p]; h = ++p && h && h[g] || (x = p = 0) || f.pop(); )
                                    if (1 === h.nodeType && ++x && h === e) {
                                        c[t] = [_, p, x];
                                        break
                                    }
                            } else if (y && (x = p = (l = (c = (d = (h = e)[w] || (h[w] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] || [])[0] === _ && l[1]),
                            !1 === x)
                                for (; (h = ++p && h && h[g] || (x = p = 0) || f.pop()) && ((a ? h.nodeName.toLowerCase() !== v : 1 !== h.nodeType) || !++x || (y && ((c = (d = h[w] || (h[w] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] = [_, x]),
                                h !== e)); )
                                    ;
                            return (x -= r) === i || x % i == 0 && x / i >= 0
                        }
                    }
                },
                PSEUDO: function(t, e) {
                    var n, r = i.pseudos[t] || i.setFilters[t.toLowerCase()] || rt.error("unsupported pseudo: " + t);
                    return r[w] ? r(e) : r.length > 1 ? (n = [t, t, "", e],
                    i.setFilters.hasOwnProperty(t.toLowerCase()) ? st(function(t, n) {
                        for (var i, o = r(t, e), s = o.length; s--; )
                            t[i = G(t, o[s])] = !(n[i] = o[s])
                    }) : function(t) {
                        return r(t, 0, n)
                    }
                    ) : r
                }
            },
            pseudos: {
                not: st(function(t) {
                    var e = []
                      , n = []
                      , i = a(t.replace(z, "$1"));
                    return i[w] ? st(function(t, e, n, r) {
                        for (var o, s = i(t, null, r, []), a = t.length; a--; )
                            (o = s[a]) && (t[a] = !(e[a] = o))
                    }) : function(t, r, o) {
                        return e[0] = t,
                        i(e, null, o, n),
                        e[0] = null,
                        !n.pop()
                    }
                }),
                has: st(function(t) {
                    return function(e) {
                        return rt(t, e).length > 0
                    }
                }),
                contains: st(function(t) {
                    return t = t.replace(et, nt),
                    function(e) {
                        return (e.textContent || e.innerText || r(e)).indexOf(t) > -1
                    }
                }),
                lang: st(function(t) {
                    return V.test(t || "") || rt.error("unsupported lang: " + t),
                    t = t.replace(et, nt).toLowerCase(),
                    function(e) {
                        var n;
                        do {
                            if (n = g ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                                return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-")
                        } while ((e = e.parentNode) && 1 === e.nodeType);
                        return !1
                    }
                }),
                target: function(e) {
                    var n = t.location && t.location.hash;
                    return n && n.slice(1) === e.id
                },
                root: function(t) {
                    return t === f
                },
                focus: function(t) {
                    return t === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                },
                enabled: function(t) {
                    return !1 === t.disabled
                },
                disabled: function(t) {
                    return !0 === t.disabled
                },
                checked: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && !!t.checked || "option" === e && !!t.selected
                },
                selected: function(t) {
                    return t.parentNode && t.parentNode.selectedIndex,
                    !0 === t.selected
                },
                empty: function(t) {
                    for (t = t.firstChild; t; t = t.nextSibling)
                        if (t.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(t) {
                    return !i.pseudos.empty(t)
                },
                header: function(t) {
                    return J.test(t.nodeName)
                },
                input: function(t) {
                    return Y.test(t.nodeName)
                },
                button: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && "button" === t.type || "button" === e
                },
                text: function(t) {
                    var e;
                    return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                },
                first: ht(function() {
                    return [0]
                }),
                last: ht(function(t, e) {
                    return [e - 1]
                }),
                eq: ht(function(t, e, n) {
                    return [0 > n ? n + e : n]
                }),
                even: ht(function(t, e) {
                    for (var n = 0; e > n; n += 2)
                        t.push(n);
                    return t
                }),
                odd: ht(function(t, e) {
                    for (var n = 1; e > n; n += 2)
                        t.push(n);
                    return t
                }),
                lt: ht(function(t, e, n) {
                    for (var i = 0 > n ? n + e : n; --i >= 0; )
                        t.push(i);
                    return t
                }),
                gt: ht(function(t, e, n) {
                    for (var i = 0 > n ? n + e : n; ++i < e; )
                        t.push(i);
                    return t
                })
            }
        }).pseudos.nth = i.pseudos.eq,
        {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            i.pseudos[e] = ct(e);
        for (e in {
            submit: !0,
            reset: !0
        })
            i.pseudos[e] = dt(e);
        function ft() {}
        function gt(t) {
            for (var e = 0, n = t.length, i = ""; n > e; e++)
                i += t[e].value;
            return i
        }
        function mt(t, e, n) {
            var i = e.dir
              , r = n && "parentNode" === i
              , o = T++;
            return e.first ? function(e, n, o) {
                for (; e = e[i]; )
                    if (1 === e.nodeType || r)
                        return t(e, n, o)
            }
            : function(e, n, s) {
                var a, u, l, c = [_, o];
                if (s) {
                    for (; e = e[i]; )
                        if ((1 === e.nodeType || r) && t(e, n, s))
                            return !0
                } else
                    for (; e = e[i]; )
                        if (1 === e.nodeType || r) {
                            if ((a = (u = (l = e[w] || (e[w] = {}))[e.uniqueID] || (l[e.uniqueID] = {}))[i]) && a[0] === _ && a[1] === o)
                                return c[2] = a[2];
                            if (u[i] = c,
                            c[2] = t(e, n, s))
                                return !0
                        }
            }
        }
        function vt(t) {
            return t.length > 1 ? function(e, n, i) {
                for (var r = t.length; r--; )
                    if (!t[r](e, n, i))
                        return !1;
                return !0
            }
            : t[0]
        }
        function yt(t, e, n, i, r) {
            for (var o, s = [], a = 0, u = t.length, l = null != e; u > a; a++)
                (o = t[a]) && (n && !n(o, i, r) || (s.push(o),
                l && e.push(a)));
            return s
        }
        function xt(t, e, n, i, r, o) {
            return i && !i[w] && (i = xt(i)),
            r && !r[w] && (r = xt(r, o)),
            st(function(o, s, a, u) {
                var l, c, d, h = [], p = [], f = s.length, g = o || function(t, e, n) {
                    for (var i = 0, r = e.length; r > i; i++)
                        rt(t, e[i], n);
                    return n
                }(e || "*", a.nodeType ? [a] : a, []), m = !t || !o && e ? g : yt(g, h, t, a, u), v = n ? r || (o ? t : f || i) ? [] : s : m;
                if (n && n(m, v, a, u),
                i)
                    for (l = yt(v, p),
                    i(l, [], a, u),
                    c = l.length; c--; )
                        (d = l[c]) && (v[p[c]] = !(m[p[c]] = d));
                if (o) {
                    if (r || t) {
                        if (r) {
                            for (l = [],
                            c = v.length; c--; )
                                (d = v[c]) && l.push(m[c] = d);
                            r(null, v = [], l, u)
                        }
                        for (c = v.length; c--; )
                            (d = v[c]) && (l = r ? G(o, d) : h[c]) > -1 && (o[l] = !(s[l] = d))
                    }
                } else
                    v = yt(v === s ? v.splice(f, v.length) : v),
                    r ? r(null, s, v, u) : A.apply(s, v)
            })
        }
        function wt(t) {
            for (var e, n, r, o = t.length, s = i.relative[t[0].type], a = s || i.relative[" "], u = s ? 1 : 0, c = mt(function(t) {
                return t === e
            }, a, !0), d = mt(function(t) {
                return G(e, t) > -1
            }, a, !0), h = [function(t, n, i) {
                var r = !s && (i || n !== l) || ((e = n).nodeType ? c(t, n, i) : d(t, n, i));
                return e = null,
                r
            }
            ]; o > u; u++)
                if (n = i.relative[t[u].type])
                    h = [mt(vt(h), n)];
                else {
                    if ((n = i.filter[t[u].type].apply(null, t[u].matches))[w]) {
                        for (r = ++u; o > r && !i.relative[t[r].type]; r++)
                            ;
                        return xt(u > 1 && vt(h), u > 1 && gt(t.slice(0, u - 1).concat({
                            value: " " === t[u - 2].type ? "*" : ""
                        })).replace(z, "$1"), n, r > u && wt(t.slice(u, r)), o > r && wt(t = t.slice(r)), o > r && gt(t))
                    }
                    h.push(n)
                }
            return vt(h)
        }
        function bt(t, e) {
            var n = e.length > 0
              , r = t.length > 0
              , o = function(o, s, a, u, c) {
                var d, f, m, v = 0, y = "0", x = o && [], w = [], b = l, T = o || r && i.find.TAG("*", c), C = _ += null == b ? 1 : Math.random() || .1, S = T.length;
                for (c && (l = s === p || s || c); y !== S && null != (d = T[y]); y++) {
                    if (r && d) {
                        for (f = 0,
                        s || d.ownerDocument === p || (h(d),
                        a = !g); m = t[f++]; )
                            if (m(d, s || p, a)) {
                                u.push(d);
                                break
                            }
                        c && (_ = C)
                    }
                    n && ((d = !m && d) && v--,
                    o && x.push(d))
                }
                if (v += y,
                n && y !== v) {
                    for (f = 0; m = e[f++]; )
                        m(x, w, s, a);
                    if (o) {
                        if (v > 0)
                            for (; y--; )
                                x[y] || w[y] || (w[y] = j.call(u));
                        w = yt(w)
                    }
                    A.apply(u, w),
                    c && !o && w.length > 0 && v + e.length > 1 && rt.uniqueSort(u)
                }
                return c && (_ = C,
                l = b),
                x
            };
            return n ? st(o) : o
        }
        return ft.prototype = i.filters = i.pseudos,
        i.setFilters = new ft,
        s = rt.tokenize = function(t, e) {
            var n, r, o, s, a, u, l, c = S[t + " "];
            if (c)
                return e ? 0 : c.slice(0);
            for (a = t,
            u = [],
            l = i.preFilter; a; ) {
                for (s in n && !(r = I.exec(a)) || (r && (a = a.slice(r[0].length) || a),
                u.push(o = [])),
                n = !1,
                (r = H.exec(a)) && (n = r.shift(),
                o.push({
                    value: n,
                    type: r[0].replace(z, " ")
                }),
                a = a.slice(n.length)),
                i.filter)
                    !(r = X[s].exec(a)) || l[s] && !(r = l[s](r)) || (n = r.shift(),
                    o.push({
                        value: n,
                        type: s,
                        matches: r
                    }),
                    a = a.slice(n.length));
                if (!n)
                    break
            }
            return e ? a.length : a ? rt.error(t) : S(t, u).slice(0)
        }
        ,
        a = rt.compile = function(t, e) {
            var n, i = [], r = [], o = L[t + " "];
            if (!o) {
                for (e || (e = s(t)),
                n = e.length; n--; )
                    (o = wt(e[n]))[w] ? i.push(o) : r.push(o);
                (o = L(t, bt(r, i))).selector = t
            }
            return o
        }
        ,
        u = rt.select = function(t, e, r, o) {
            var u, l, c, d, h, p = "function" == typeof t && t, f = !o && s(t = p.selector || t);
            if (r = r || [],
            1 === f.length) {
                if ((l = f[0] = f[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && n.getById && 9 === e.nodeType && g && i.relative[l[1].type]) {
                    if (!(e = (i.find.ID(c.matches[0].replace(et, nt), e) || [])[0]))
                        return r;
                    p && (e = e.parentNode),
                    t = t.slice(l.shift().value.length)
                }
                for (u = X.needsContext.test(t) ? 0 : l.length; u-- && (c = l[u],
                !i.relative[d = c.type]); )
                    if ((h = i.find[d]) && (o = h(c.matches[0].replace(et, nt), K.test(l[0].type) && pt(e.parentNode) || e))) {
                        if (l.splice(u, 1),
                        !(t = o.length && gt(l)))
                            return A.apply(r, o),
                            r;
                        break
                    }
            }
            return (p || a(t, f))(o, e, !g, r, !e || K.test(t) && pt(e.parentNode) || e),
            r
        }
        ,
        n.sortStable = w.split("").sort(q).join("") === w,
        n.detectDuplicates = !!d,
        h(),
        n.sortDetached = at(function(t) {
            return 1 & t.compareDocumentPosition(p.createElement("div"))
        }),
        at(function(t) {
            return t.innerHTML = "<a href='#'></a>",
            "#" === t.firstChild.getAttribute("href")
        }) || ut("type|href|height|width", function(t, e, n) {
            return n ? void 0 : t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }),
        n.attributes && at(function(t) {
            return t.innerHTML = "<input/>",
            t.firstChild.setAttribute("value", ""),
            "" === t.firstChild.getAttribute("value")
        }) || ut("value", function(t, e, n) {
            return n || "input" !== t.nodeName.toLowerCase() ? void 0 : t.defaultValue
        }),
        at(function(t) {
            return null == t.getAttribute("disabled")
        }) || ut($, function(t, e, n) {
            var i;
            return n ? void 0 : !0 === t[e] ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
        }),
        rt
    }(t);
    p.find = x,
    p.expr = x.selectors,
    p.expr[":"] = p.expr.pseudos,
    p.uniqueSort = p.unique = x.uniqueSort,
    p.text = x.getText,
    p.isXMLDoc = x.isXML,
    p.contains = x.contains;
    var w = function(t, e, n) {
        for (var i = [], r = void 0 !== n; (t = t[e]) && 9 !== t.nodeType; )
            if (1 === t.nodeType) {
                if (r && p(t).is(n))
                    break;
                i.push(t)
            }
        return i
    }
      , b = function(t, e) {
        for (var n = []; t; t = t.nextSibling)
            1 === t.nodeType && t !== e && n.push(t);
        return n
    }
      , _ = p.expr.match.needsContext
      , T = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/
      , C = /^.[^:#\[\.,]*$/;
    function S(t, e, n) {
        if (p.isFunction(e))
            return p.grep(t, function(t, i) {
                return !!e.call(t, i, t) !== n
            });
        if (e.nodeType)
            return p.grep(t, function(t) {
                return t === e !== n
            });
        if ("string" == typeof e) {
            if (C.test(e))
                return p.filter(e, t, n);
            e = p.filter(e, t)
        }
        return p.grep(t, function(t) {
            return a.call(e, t) > -1 !== n
        })
    }
    p.filter = function(t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"),
        1 === e.length && 1 === i.nodeType ? p.find.matchesSelector(i, t) ? [i] : [] : p.find.matches(t, p.grep(e, function(t) {
            return 1 === t.nodeType
        }))
    }
    ,
    p.fn.extend({
        find: function(t) {
            var e, n = this.length, i = [], r = this;
            if ("string" != typeof t)
                return this.pushStack(p(t).filter(function() {
                    for (e = 0; n > e; e++)
                        if (p.contains(r[e], this))
                            return !0
                }));
            for (e = 0; n > e; e++)
                p.find(t, r[e], i);
            return (i = this.pushStack(n > 1 ? p.unique(i) : i)).selector = this.selector ? this.selector + " " + t : t,
            i
        },
        filter: function(t) {
            return this.pushStack(S(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(S(this, t || [], !0))
        },
        is: function(t) {
            return !!S(this, "string" == typeof t && _.test(t) ? p(t) : t || [], !1).length
        }
    });
    var L, q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (p.fn.init = function(t, e, n) {
        var r, o;
        if (!t)
            return this;
        if (n = n || L,
        "string" == typeof t) {
            if (!(r = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : q.exec(t)) || !r[1] && e)
                return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
            if (r[1]) {
                if (e = e instanceof p ? e[0] : e,
                p.merge(this, p.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : i, !0)),
                T.test(r[1]) && p.isPlainObject(e))
                    for (r in e)
                        p.isFunction(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
                return this
            }
            return (o = i.getElementById(r[2])) && o.parentNode && (this.length = 1,
            this[0] = o),
            this.context = i,
            this.selector = t,
            this
        }
        return t.nodeType ? (this.context = this[0] = t,
        this.length = 1,
        this) : p.isFunction(t) ? void 0 !== n.ready ? n.ready(t) : t(p) : (void 0 !== t.selector && (this.selector = t.selector,
        this.context = t.context),
        p.makeArray(t, this))
    }
    ).prototype = p.fn,
    L = p(i);
    var D = /^(?:parents|prev(?:Until|All))/
      , k = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    function E(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType; )
            ;
        return t
    }
    p.fn.extend({
        has: function(t) {
            var e = p(t, this)
              , n = e.length;
            return this.filter(function() {
                for (var t = 0; n > t; t++)
                    if (p.contains(this, e[t]))
                        return !0
            })
        },
        closest: function(t, e) {
            for (var n, i = 0, r = this.length, o = [], s = _.test(t) || "string" != typeof t ? p(t, e || this.context) : 0; r > i; i++)
                for (n = this[i]; n && n !== e; n = n.parentNode)
                    if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && p.find.matchesSelector(n, t))) {
                        o.push(n);
                        break
                    }
            return this.pushStack(o.length > 1 ? p.uniqueSort(o) : o)
        },
        index: function(t) {
            return t ? "string" == typeof t ? a.call(p(t), this[0]) : a.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, e) {
            return this.pushStack(p.uniqueSort(p.merge(this.get(), p(t, e))))
        },
        addBack: function(t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }),
    p.each({
        parent: function(t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(t) {
            return w(t, "parentNode")
        },
        parentsUntil: function(t, e, n) {
            return w(t, "parentNode", n)
        },
        next: function(t) {
            return E(t, "nextSibling")
        },
        prev: function(t) {
            return E(t, "previousSibling")
        },
        nextAll: function(t) {
            return w(t, "nextSibling")
        },
        prevAll: function(t) {
            return w(t, "previousSibling")
        },
        nextUntil: function(t, e, n) {
            return w(t, "nextSibling", n)
        },
        prevUntil: function(t, e, n) {
            return w(t, "previousSibling", n)
        },
        siblings: function(t) {
            return b((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return b(t.firstChild)
        },
        contents: function(t) {
            return t.contentDocument || p.merge([], t.childNodes)
        }
    }, function(t, e) {
        p.fn[t] = function(n, i) {
            var r = p.map(this, e, n);
            return "Until" !== t.slice(-5) && (i = n),
            i && "string" == typeof i && (r = p.filter(i, r)),
            this.length > 1 && (k[t] || p.uniqueSort(r),
            D.test(t) && r.reverse()),
            this.pushStack(r)
        }
    });
    var j, N = /\S+/g;
    function A() {
        i.removeEventListener("DOMContentLoaded", A),
        t.removeEventListener("load", A),
        p.ready()
    }
    p.Callbacks = function(t) {
        t = "string" == typeof t ? function(t) {
            var e = {};
            return p.each(t.match(N) || [], function(t, n) {
                e[n] = !0
            }),
            e
        }(t) : p.extend({}, t);
        var e, n, i, r, o = [], s = [], a = -1, u = function() {
            for (r = t.once,
            i = e = !0; s.length; a = -1)
                for (n = s.shift(); ++a < o.length; )
                    !1 === o[a].apply(n[0], n[1]) && t.stopOnFalse && (a = o.length,
                    n = !1);
            t.memory || (n = !1),
            e = !1,
            r && (o = n ? [] : "")
        }, l = {
            add: function() {
                return o && (n && !e && (a = o.length - 1,
                s.push(n)),
                function e(n) {
                    p.each(n, function(n, i) {
                        p.isFunction(i) ? t.unique && l.has(i) || o.push(i) : i && i.length && "string" !== p.type(i) && e(i)
                    })
                }(arguments),
                n && !e && u()),
                this
            },
            remove: function() {
                return p.each(arguments, function(t, e) {
                    for (var n; (n = p.inArray(e, o, n)) > -1; )
                        o.splice(n, 1),
                        a >= n && a--
                }),
                this
            },
            has: function(t) {
                return t ? p.inArray(t, o) > -1 : o.length > 0
            },
            empty: function() {
                return o && (o = []),
                this
            },
            disable: function() {
                return r = s = [],
                o = n = "",
                this
            },
            disabled: function() {
                return !o
            },
            lock: function() {
                return r = s = [],
                n || (o = n = ""),
                this
            },
            locked: function() {
                return !!r
            },
            fireWith: function(t, n) {
                return r || (n = [t, (n = n || []).slice ? n.slice() : n],
                s.push(n),
                e || u()),
                this
            },
            fire: function() {
                return l.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!i
            }
        };
        return l
    }
    ,
    p.extend({
        Deferred: function(t) {
            var e = [["resolve", "done", p.Callbacks("once memory"), "resolved"], ["reject", "fail", p.Callbacks("once memory"), "rejected"], ["notify", "progress", p.Callbacks("memory")]]
              , n = "pending"
              , i = {
                state: function() {
                    return n
                },
                always: function() {
                    return r.done(arguments).fail(arguments),
                    this
                },
                then: function() {
                    var t = arguments;
                    return p.Deferred(function(n) {
                        p.each(e, function(e, o) {
                            var s = p.isFunction(t[e]) && t[e];
                            r[o[1]](function() {
                                var t = s && s.apply(this, arguments);
                                t && p.isFunction(t.promise) ? t.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[o[0] + "With"](this === i ? n.promise() : this, s ? [t] : arguments)
                            })
                        }),
                        t = null
                    }).promise()
                },
                promise: function(t) {
                    return null != t ? p.extend(t, i) : i
                }
            }
              , r = {};
            return i.pipe = i.then,
            p.each(e, function(t, o) {
                var s = o[2]
                  , a = o[3];
                i[o[1]] = s.add,
                a && s.add(function() {
                    n = a
                }, e[1 ^ t][2].disable, e[2][2].lock),
                r[o[0]] = function() {
                    return r[o[0] + "With"](this === r ? i : this, arguments),
                    this
                }
                ,
                r[o[0] + "With"] = s.fireWith
            }),
            i.promise(r),
            t && t.call(r, r),
            r
        },
        when: function(t) {
            var e, n, i, o = 0, s = r.call(arguments), a = s.length, u = 1 !== a || t && p.isFunction(t.promise) ? a : 0, l = 1 === u ? t : p.Deferred(), c = function(t, n, i) {
                return function(o) {
                    n[t] = this,
                    i[t] = arguments.length > 1 ? r.call(arguments) : o,
                    i === e ? l.notifyWith(n, i) : --u || l.resolveWith(n, i)
                }
            };
            if (a > 1)
                for (e = new Array(a),
                n = new Array(a),
                i = new Array(a); a > o; o++)
                    s[o] && p.isFunction(s[o].promise) ? s[o].promise().progress(c(o, n, e)).done(c(o, i, s)).fail(l.reject) : --u;
            return u || l.resolveWith(i, s),
            l.promise()
        }
    }),
    p.fn.ready = function(t) {
        return p.ready.promise().done(t),
        this
    }
    ,
    p.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(t) {
            t ? p.readyWait++ : p.ready(!0)
        },
        ready: function(t) {
            (!0 === t ? --p.readyWait : p.isReady) || (p.isReady = !0,
            !0 !== t && --p.readyWait > 0 || (j.resolveWith(i, [p]),
            p.fn.triggerHandler && (p(i).triggerHandler("ready"),
            p(i).off("ready"))))
        }
    }),
    p.ready.promise = function(e) {
        return j || (j = p.Deferred(),
        "complete" === i.readyState || "loading" !== i.readyState && !i.documentElement.doScroll ? t.setTimeout(p.ready) : (i.addEventListener("DOMContentLoaded", A),
        t.addEventListener("load", A))),
        j.promise(e)
    }
    ,
    p.ready.promise();
    var P = function(t, e, n, i, r, o, s) {
        var a = 0
          , u = t.length
          , l = null == n;
        if ("object" === p.type(n))
            for (a in r = !0,
            n)
                P(t, e, a, n[a], !0, o, s);
        else if (void 0 !== i && (r = !0,
        p.isFunction(i) || (s = !0),
        l && (s ? (e.call(t, i),
        e = null) : (l = e,
        e = function(t, e, n) {
            return l.call(p(t), n)
        }
        )),
        e))
            for (; u > a; a++)
                e(t[a], n, s ? i : i.call(t[a], a, e(t[a], n)));
        return r ? t : l ? e.call(t) : u ? e(t[0], n) : o
    }
      , G = function(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    };
    function $() {
        this.expando = p.expando + $.uid++
    }
    $.uid = 1,
    $.prototype = {
        register: function(t, e) {
            var n = e || {};
            return t.nodeType ? t[this.expando] = n : Object.defineProperty(t, this.expando, {
                value: n,
                writable: !0,
                configurable: !0
            }),
            t[this.expando]
        },
        cache: function(t) {
            if (!G(t))
                return {};
            var e = t[this.expando];
            return e || (e = {},
            G(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))),
            e
        },
        set: function(t, e, n) {
            var i, r = this.cache(t);
            if ("string" == typeof e)
                r[e] = n;
            else
                for (i in e)
                    r[i] = e[i];
            return r
        },
        get: function(t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][e]
        },
        access: function(t, e, n) {
            var i;
            return void 0 === e || e && "string" == typeof e && void 0 === n ? void 0 !== (i = this.get(t, e)) ? i : this.get(t, p.camelCase(e)) : (this.set(t, e, n),
            void 0 !== n ? n : e)
        },
        remove: function(t, e) {
            var n, i, r, o = t[this.expando];
            if (void 0 !== o) {
                if (void 0 === e)
                    this.register(t);
                else {
                    p.isArray(e) ? i = e.concat(e.map(p.camelCase)) : (r = p.camelCase(e),
                    e in o ? i = [e, r] : i = (i = r)in o ? [i] : i.match(N) || []),
                    n = i.length;
                    for (; n--; )
                        delete o[i[n]]
                }
                (void 0 === e || p.isEmptyObject(o)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var e = t[this.expando];
            return void 0 !== e && !p.isEmptyObject(e)
        }
    };
    var O = new $
      , R = new $
      , M = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , B = /[A-Z]/g;
    function F(t, e, n) {
        var i;
        if (void 0 === n && 1 === t.nodeType)
            if (i = "data-" + e.replace(B, "-$&").toLowerCase(),
            "string" == typeof (n = t.getAttribute(i))) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : M.test(n) ? p.parseJSON(n) : n)
                } catch (t) {}
                R.set(t, e, n)
            } else
                n = void 0;
        return n
    }
    p.extend({
        hasData: function(t) {
            return R.hasData(t) || O.hasData(t)
        },
        data: function(t, e, n) {
            return R.access(t, e, n)
        },
        removeData: function(t, e) {
            R.remove(t, e)
        },
        _data: function(t, e, n) {
            return O.access(t, e, n)
        },
        _removeData: function(t, e) {
            O.remove(t, e)
        }
    }),
    p.fn.extend({
        data: function(t, e) {
            var n, i, r, o = this[0], s = o && o.attributes;
            if (void 0 === t) {
                if (this.length && (r = R.get(o),
                1 === o.nodeType && !O.get(o, "hasDataAttrs"))) {
                    for (n = s.length; n--; )
                        s[n] && (0 === (i = s[n].name).indexOf("data-") && (i = p.camelCase(i.slice(5)),
                        F(o, i, r[i])));
                    O.set(o, "hasDataAttrs", !0)
                }
                return r
            }
            return "object" == typeof t ? this.each(function() {
                R.set(this, t)
            }) : P(this, function(e) {
                var n, i;
                if (o && void 0 === e) {
                    if (void 0 !== (n = R.get(o, t) || R.get(o, t.replace(B, "-$&").toLowerCase())))
                        return n;
                    if (i = p.camelCase(t),
                    void 0 !== (n = R.get(o, i)))
                        return n;
                    if (void 0 !== (n = F(o, i, void 0)))
                        return n
                } else
                    i = p.camelCase(t),
                    this.each(function() {
                        var n = R.get(this, i);
                        R.set(this, i, e),
                        t.indexOf("-") > -1 && void 0 !== n && R.set(this, t, e)
                    })
            }, null, e, arguments.length > 1, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                R.remove(this, t)
            })
        }
    }),
    p.extend({
        queue: function(t, e, n) {
            var i;
            return t ? (e = (e || "fx") + "queue",
            i = O.get(t, e),
            n && (!i || p.isArray(n) ? i = O.access(t, e, p.makeArray(n)) : i.push(n)),
            i || []) : void 0
        },
        dequeue: function(t, e) {
            e = e || "fx";
            var n = p.queue(t, e)
              , i = n.length
              , r = n.shift()
              , o = p._queueHooks(t, e);
            "inprogress" === r && (r = n.shift(),
            i--),
            r && ("fx" === e && n.unshift("inprogress"),
            delete o.stop,
            r.call(t, function() {
                p.dequeue(t, e)
            }, o)),
            !i && o && o.empty.fire()
        },
        _queueHooks: function(t, e) {
            var n = e + "queueHooks";
            return O.get(t, n) || O.access(t, n, {
                empty: p.Callbacks("once memory").add(function() {
                    O.remove(t, [e + "queue", n])
                })
            })
        }
    }),
    p.fn.extend({
        queue: function(t, e) {
            var n = 2;
            return "string" != typeof t && (e = t,
            t = "fx",
            n--),
            arguments.length < n ? p.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                var n = p.queue(this, t, e);
                p._queueHooks(this, t),
                "fx" === t && "inprogress" !== n[0] && p.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                p.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, e) {
            var n, i = 1, r = p.Deferred(), o = this, s = this.length, a = function() {
                --i || r.resolveWith(o, [o])
            };
            for ("string" != typeof t && (e = t,
            t = void 0),
            t = t || "fx"; s--; )
                (n = O.get(o[s], t + "queueHooks")) && n.empty && (i++,
                n.empty.add(a));
            return a(),
            r.promise(e)
        }
    });
    var z = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , I = new RegExp("^(?:([+-])=|)(" + z + ")([a-z%]*)$","i")
      , H = ["Top", "Right", "Bottom", "Left"]
      , W = function(t, e) {
        return t = e || t,
        "none" === p.css(t, "display") || !p.contains(t.ownerDocument, t)
    };
    function U(t, e, n, i) {
        var r, o = 1, s = 20, a = i ? function() {
            return i.cur()
        }
        : function() {
            return p.css(t, e, "")
        }
        , u = a(), l = n && n[3] || (p.cssNumber[e] ? "" : "px"), c = (p.cssNumber[e] || "px" !== l && +u) && I.exec(p.css(t, e));
        if (c && c[3] !== l) {
            l = l || c[3],
            n = n || [],
            c = +u || 1;
            do {
                c /= o = o || ".5",
                p.style(t, e, c + l)
            } while (o !== (o = a() / u) && 1 !== o && --s)
        }
        return n && (c = +c || +u || 0,
        r = n[1] ? c + (n[1] + 1) * n[2] : +n[2],
        i && (i.unit = l,
        i.start = c,
        i.end = r)),
        r
    }
    var V = /^(?:checkbox|radio)$/i
      , X = /<([\w:-]+)/
      , Y = /^$|\/(?:java|ecma)script/i
      , J = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    function Q(t, e) {
        var n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
        return void 0 === e || e && p.nodeName(t, e) ? p.merge([t], n) : n
    }
    function Z(t, e) {
        for (var n = 0, i = t.length; i > n; n++)
            O.set(t[n], "globalEval", !e || O.get(e[n], "globalEval"))
    }
    J.optgroup = J.option,
    J.tbody = J.tfoot = J.colgroup = J.caption = J.thead,
    J.th = J.td;
    var K = /<|&#?\w+;/;
    function tt(t, e, n, i, r) {
        for (var o, s, a, u, l, c, d = e.createDocumentFragment(), h = [], f = 0, g = t.length; g > f; f++)
            if ((o = t[f]) || 0 === o)
                if ("object" === p.type(o))
                    p.merge(h, o.nodeType ? [o] : o);
                else if (K.test(o)) {
                    for (s = s || d.appendChild(e.createElement("div")),
                    a = (X.exec(o) || ["", ""])[1].toLowerCase(),
                    u = J[a] || J._default,
                    s.innerHTML = u[1] + p.htmlPrefilter(o) + u[2],
                    c = u[0]; c--; )
                        s = s.lastChild;
                    p.merge(h, s.childNodes),
                    (s = d.firstChild).textContent = ""
                } else
                    h.push(e.createTextNode(o));
        for (d.textContent = "",
        f = 0; o = h[f++]; )
            if (i && p.inArray(o, i) > -1)
                r && r.push(o);
            else if (l = p.contains(o.ownerDocument, o),
            s = Q(d.appendChild(o), "script"),
            l && Z(s),
            n)
                for (c = 0; o = s[c++]; )
                    Y.test(o.type || "") && n.push(o);
        return d
    }
    !function() {
        var t = i.createDocumentFragment().appendChild(i.createElement("div"))
          , e = i.createElement("input");
        e.setAttribute("type", "radio"),
        e.setAttribute("checked", "checked"),
        e.setAttribute("name", "t"),
        t.appendChild(e),
        d.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked,
        t.innerHTML = "<textarea>x</textarea>",
        d.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue
    }();
    var et = /^key/
      , nt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , it = /^([^.]*)(?:\.(.+)|)/;
    function rt() {
        return !0
    }
    function ot() {
        return !1
    }
    function st() {
        try {
            return i.activeElement
        } catch (t) {}
    }
    function at(t, e, n, i, r, o) {
        var s, a;
        if ("object" == typeof e) {
            for (a in "string" != typeof n && (i = i || n,
            n = void 0),
            e)
                at(t, a, n, i, e[a], o);
            return t
        }
        if (null == i && null == r ? (r = n,
        i = n = void 0) : null == r && ("string" == typeof n ? (r = i,
        i = void 0) : (r = i,
        i = n,
        n = void 0)),
        !1 === r)
            r = ot;
        else if (!r)
            return t;
        return 1 === o && (s = r,
        (r = function(t) {
            return p().off(t),
            s.apply(this, arguments)
        }
        ).guid = s.guid || (s.guid = p.guid++)),
        t.each(function() {
            p.event.add(this, e, r, i, n)
        })
    }
    p.event = {
        global: {},
        add: function(t, e, n, i, r) {
            var o, s, a, u, l, c, d, h, f, g, m, v = O.get(t);
            if (v)
                for (n.handler && (n = (o = n).handler,
                r = o.selector),
                n.guid || (n.guid = p.guid++),
                (u = v.events) || (u = v.events = {}),
                (s = v.handle) || (s = v.handle = function(e) {
                    return void 0 !== p && p.event.triggered !== e.type ? p.event.dispatch.apply(t, arguments) : void 0
                }
                ),
                l = (e = (e || "").match(N) || [""]).length; l--; )
                    f = m = (a = it.exec(e[l]) || [])[1],
                    g = (a[2] || "").split(".").sort(),
                    f && (d = p.event.special[f] || {},
                    f = (r ? d.delegateType : d.bindType) || f,
                    d = p.event.special[f] || {},
                    c = p.extend({
                        type: f,
                        origType: m,
                        data: i,
                        handler: n,
                        guid: n.guid,
                        selector: r,
                        needsContext: r && p.expr.match.needsContext.test(r),
                        namespace: g.join(".")
                    }, o),
                    (h = u[f]) || ((h = u[f] = []).delegateCount = 0,
                    d.setup && !1 !== d.setup.call(t, i, g, s) || t.addEventListener && t.addEventListener(f, s)),
                    d.add && (d.add.call(t, c),
                    c.handler.guid || (c.handler.guid = n.guid)),
                    r ? h.splice(h.delegateCount++, 0, c) : h.push(c),
                    p.event.global[f] = !0)
        },
        remove: function(t, e, n, i, r) {
            var o, s, a, u, l, c, d, h, f, g, m, v = O.hasData(t) && O.get(t);
            if (v && (u = v.events)) {
                for (l = (e = (e || "").match(N) || [""]).length; l--; )
                    if (f = m = (a = it.exec(e[l]) || [])[1],
                    g = (a[2] || "").split(".").sort(),
                    f) {
                        for (d = p.event.special[f] || {},
                        h = u[f = (i ? d.delegateType : d.bindType) || f] || [],
                        a = a[2] && new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        s = o = h.length; o--; )
                            c = h[o],
                            !r && m !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (h.splice(o, 1),
                            c.selector && h.delegateCount--,
                            d.remove && d.remove.call(t, c));
                        s && !h.length && (d.teardown && !1 !== d.teardown.call(t, g, v.handle) || p.removeEvent(t, f, v.handle),
                        delete u[f])
                    } else
                        for (f in u)
                            p.event.remove(t, f + e[l], n, i, !0);
                p.isEmptyObject(u) && O.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            t = p.event.fix(t);
            var e, n, i, o, s, a = [], u = r.call(arguments), l = (O.get(this, "events") || {})[t.type] || [], c = p.event.special[t.type] || {};
            if (u[0] = t,
            t.delegateTarget = this,
            !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
                for (a = p.event.handlers.call(this, t, l),
                e = 0; (o = a[e++]) && !t.isPropagationStopped(); )
                    for (t.currentTarget = o.elem,
                    n = 0; (s = o.handlers[n++]) && !t.isImmediatePropagationStopped(); )
                        t.rnamespace && !t.rnamespace.test(s.namespace) || (t.handleObj = s,
                        t.data = s.data,
                        void 0 !== (i = ((p.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, u)) && !1 === (t.result = i) && (t.preventDefault(),
                        t.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, t),
                t.result
            }
        },
        handlers: function(t, e) {
            var n, i, r, o, s = [], a = e.delegateCount, u = t.target;
            if (a && u.nodeType && ("click" !== t.type || isNaN(t.button) || t.button < 1))
                for (; u !== this; u = u.parentNode || this)
                    if (1 === u.nodeType && (!0 !== u.disabled || "click" !== t.type)) {
                        for (i = [],
                        n = 0; a > n; n++)
                            void 0 === i[r = (o = e[n]).selector + " "] && (i[r] = o.needsContext ? p(r, this).index(u) > -1 : p.find(r, this, null, [u]).length),
                            i[r] && i.push(o);
                        i.length && s.push({
                            elem: u,
                            handlers: i
                        })
                    }
            return a < e.length && s.push({
                elem: this,
                handlers: e.slice(a)
            }),
            s
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(t, e) {
                return null == t.which && (t.which = null != e.charCode ? e.charCode : e.keyCode),
                t
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(t, e) {
                var n, r, o, s = e.button;
                return null == t.pageX && null != e.clientX && (r = (n = t.target.ownerDocument || i).documentElement,
                o = n.body,
                t.pageX = e.clientX + (r && r.scrollLeft || o && o.scrollLeft || 0) - (r && r.clientLeft || o && o.clientLeft || 0),
                t.pageY = e.clientY + (r && r.scrollTop || o && o.scrollTop || 0) - (r && r.clientTop || o && o.clientTop || 0)),
                t.which || void 0 === s || (t.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0),
                t
            }
        },
        fix: function(t) {
            if (t[p.expando])
                return t;
            var e, n, r, o = t.type, s = t, a = this.fixHooks[o];
            for (a || (this.fixHooks[o] = a = nt.test(o) ? this.mouseHooks : et.test(o) ? this.keyHooks : {}),
            r = a.props ? this.props.concat(a.props) : this.props,
            t = new p.Event(s),
            e = r.length; e--; )
                t[n = r[e]] = s[n];
            return t.target || (t.target = i),
            3 === t.target.nodeType && (t.target = t.target.parentNode),
            a.filter ? a.filter(t, s) : t
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== st() && this.focus ? (this.focus(),
                    !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === st() && this.blur ? (this.blur(),
                    !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && p.nodeName(this, "input") ? (this.click(),
                    !1) : void 0
                },
                _default: function(t) {
                    return p.nodeName(t.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    },
    p.removeEvent = function(t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n)
    }
    ,
    p.Event = function(t, e) {
        return this instanceof p.Event ? (t && t.type ? (this.originalEvent = t,
        this.type = t.type,
        this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? rt : ot) : this.type = t,
        e && p.extend(this, e),
        this.timeStamp = t && t.timeStamp || p.now(),
        void (this[p.expando] = !0)) : new p.Event(t,e)
    }
    ,
    p.Event.prototype = {
        constructor: p.Event,
        isDefaultPrevented: ot,
        isPropagationStopped: ot,
        isImmediatePropagationStopped: ot,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = rt,
            t && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = rt,
            t && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = rt,
            t && t.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    p.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, e) {
        p.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function(t) {
                var n, i = t.relatedTarget, r = t.handleObj;
                return i && (i === this || p.contains(this, i)) || (t.type = r.origType,
                n = r.handler.apply(this, arguments),
                t.type = e),
                n
            }
        }
    }),
    p.fn.extend({
        on: function(t, e, n, i) {
            return at(this, t, e, n, i)
        },
        one: function(t, e, n, i) {
            return at(this, t, e, n, i, 1)
        },
        off: function(t, e, n) {
            var i, r;
            if (t && t.preventDefault && t.handleObj)
                return i = t.handleObj,
                p(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler),
                this;
            if ("object" == typeof t) {
                for (r in t)
                    this.off(r, e, t[r]);
                return this
            }
            return !1 !== e && "function" != typeof e || (n = e,
            e = void 0),
            !1 === n && (n = ot),
            this.each(function() {
                p.event.remove(this, t, n, e)
            })
        }
    });
    var ut = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi
      , lt = /<script|<style|<link/i
      , ct = /checked\s*(?:[^=]|=\s*.checked.)/i
      , dt = /^true\/(.*)/
      , ht = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function pt(t, e) {
        return p.nodeName(t, "table") && p.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t.appendChild(t.ownerDocument.createElement("tbody")) : t
    }
    function ft(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type,
        t
    }
    function gt(t) {
        var e = dt.exec(t.type);
        return e ? t.type = e[1] : t.removeAttribute("type"),
        t
    }
    function mt(t, e) {
        var n, i, r, o, s, a, u, l;
        if (1 === e.nodeType) {
            if (O.hasData(t) && (o = O.access(t),
            s = O.set(e, o),
            l = o.events))
                for (r in delete s.handle,
                s.events = {},
                l)
                    for (n = 0,
                    i = l[r].length; i > n; n++)
                        p.event.add(e, r, l[r][n]);
            R.hasData(t) && (a = R.access(t),
            u = p.extend({}, a),
            R.set(e, u))
        }
    }
    function vt(t, e) {
        var n = e.nodeName.toLowerCase();
        "input" === n && V.test(t.type) ? e.checked = t.checked : "input" !== n && "textarea" !== n || (e.defaultValue = t.defaultValue)
    }
    function yt(t, e, n, i) {
        e = o.apply([], e);
        var r, s, a, u, l, c, h = 0, f = t.length, g = f - 1, m = e[0], v = p.isFunction(m);
        if (v || f > 1 && "string" == typeof m && !d.checkClone && ct.test(m))
            return t.each(function(r) {
                var o = t.eq(r);
                v && (e[0] = m.call(this, r, o.html())),
                yt(o, e, n, i)
            });
        if (f && (s = (r = tt(e, t[0].ownerDocument, !1, t, i)).firstChild,
        1 === r.childNodes.length && (r = s),
        s || i)) {
            for (u = (a = p.map(Q(r, "script"), ft)).length; f > h; h++)
                l = r,
                h !== g && (l = p.clone(l, !0, !0),
                u && p.merge(a, Q(l, "script"))),
                n.call(t[h], l, h);
            if (u)
                for (c = a[a.length - 1].ownerDocument,
                p.map(a, gt),
                h = 0; u > h; h++)
                    l = a[h],
                    Y.test(l.type || "") && !O.access(l, "globalEval") && p.contains(c, l) && (l.src ? p._evalUrl && p._evalUrl(l.src) : p.globalEval(l.textContent.replace(ht, "")))
        }
        return t
    }
    function xt(t, e, n) {
        for (var i, r = e ? p.filter(e, t) : t, o = 0; null != (i = r[o]); o++)
            n || 1 !== i.nodeType || p.cleanData(Q(i)),
            i.parentNode && (n && p.contains(i.ownerDocument, i) && Z(Q(i, "script")),
            i.parentNode.removeChild(i));
        return t
    }
    p.extend({
        htmlPrefilter: function(t) {
            return t.replace(ut, "<$1></$2>")
        },
        clone: function(t, e, n) {
            var i, r, o, s, a = t.cloneNode(!0), u = p.contains(t.ownerDocument, t);
            if (!(d.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || p.isXMLDoc(t)))
                for (s = Q(a),
                i = 0,
                r = (o = Q(t)).length; r > i; i++)
                    vt(o[i], s[i]);
            if (e)
                if (n)
                    for (o = o || Q(t),
                    s = s || Q(a),
                    i = 0,
                    r = o.length; r > i; i++)
                        mt(o[i], s[i]);
                else
                    mt(t, a);
            return (s = Q(a, "script")).length > 0 && Z(s, !u && Q(t, "script")),
            a
        },
        cleanData: function(t) {
            for (var e, n, i, r = p.event.special, o = 0; void 0 !== (n = t[o]); o++)
                if (G(n)) {
                    if (e = n[O.expando]) {
                        if (e.events)
                            for (i in e.events)
                                r[i] ? p.event.remove(n, i) : p.removeEvent(n, i, e.handle);
                        n[O.expando] = void 0
                    }
                    n[R.expando] && (n[R.expando] = void 0)
                }
        }
    }),
    p.fn.extend({
        domManip: yt,
        detach: function(t) {
            return xt(this, t, !0)
        },
        remove: function(t) {
            return xt(this, t)
        },
        text: function(t) {
            return P(this, function(t) {
                return void 0 === t ? p.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return yt(this, arguments, function(t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || pt(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return yt(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = pt(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        },
        before: function() {
            return yt(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return yt(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, e = 0; null != (t = this[e]); e++)
                1 === t.nodeType && (p.cleanData(Q(t, !1)),
                t.textContent = "");
            return this
        },
        clone: function(t, e) {
            return t = null != t && t,
            e = null == e ? t : e,
            this.map(function() {
                return p.clone(this, t, e)
            })
        },
        html: function(t) {
            return P(this, function(t) {
                var e = this[0] || {}
                  , n = 0
                  , i = this.length;
                if (void 0 === t && 1 === e.nodeType)
                    return e.innerHTML;
                if ("string" == typeof t && !lt.test(t) && !J[(X.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = p.htmlPrefilter(t);
                    try {
                        for (; i > n; n++)
                            1 === (e = this[n] || {}).nodeType && (p.cleanData(Q(e, !1)),
                            e.innerHTML = t);
                        e = 0
                    } catch (t) {}
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return yt(this, arguments, function(e) {
                var n = this.parentNode;
                p.inArray(this, t) < 0 && (p.cleanData(Q(this)),
                n && n.replaceChild(e, this))
            }, t)
        }
    }),
    p.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, e) {
        p.fn[t] = function(t) {
            for (var n, i = [], r = p(t), o = r.length - 1, a = 0; o >= a; a++)
                n = a === o ? this : this.clone(!0),
                p(r[a])[e](n),
                s.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var wt, bt = {
        HTML: "block",
        BODY: "block"
    };
    function _t(t, e) {
        var n = p(e.createElement(t)).appendTo(e.body)
          , i = p.css(n[0], "display");
        return n.detach(),
        i
    }
    function Tt(t) {
        var e = i
          , n = bt[t];
        return n || ("none" !== (n = _t(t, e)) && n || ((e = (wt = (wt || p("<iframe frameborder='0' width='0' height='0'/>")).appendTo(e.documentElement))[0].contentDocument).write(),
        e.close(),
        n = _t(t, e),
        wt.detach()),
        bt[t] = n),
        n
    }
    var Ct = /^margin/
      , St = new RegExp("^(" + z + ")(?!px)[a-z%]+$","i")
      , Lt = function(e) {
        var n = e.ownerDocument.defaultView;
        return n && n.opener || (n = t),
        n.getComputedStyle(e)
    }
      , qt = function(t, e, n, i) {
        var r, o, s = {};
        for (o in e)
            s[o] = t.style[o],
            t.style[o] = e[o];
        for (o in r = n.apply(t, i || []),
        e)
            t.style[o] = s[o];
        return r
    }
      , Dt = i.documentElement;
    function kt(t, e, n) {
        var i, r, o, s, a = t.style;
        return "" !== (s = (n = n || Lt(t)) ? n.getPropertyValue(e) || n[e] : void 0) && void 0 !== s || p.contains(t.ownerDocument, t) || (s = p.style(t, e)),
        n && !d.pixelMarginRight() && St.test(s) && Ct.test(e) && (i = a.width,
        r = a.minWidth,
        o = a.maxWidth,
        a.minWidth = a.maxWidth = a.width = s,
        s = n.width,
        a.width = i,
        a.minWidth = r,
        a.maxWidth = o),
        void 0 !== s ? s + "" : s
    }
    function Et(t, e) {
        return {
            get: function() {
                return t() ? void delete this.get : (this.get = e).apply(this, arguments)
            }
        }
    }
    !function() {
        var e, n, r, o, s = i.createElement("div"), a = i.createElement("div");
        if (a.style) {
            function u() {
                a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",
                a.innerHTML = "",
                Dt.appendChild(s);
                var i = t.getComputedStyle(a);
                e = "1%" !== i.top,
                o = "2px" === i.marginLeft,
                n = "4px" === i.width,
                a.style.marginRight = "50%",
                r = "4px" === i.marginRight,
                Dt.removeChild(s)
            }
            a.style.backgroundClip = "content-box",
            a.cloneNode(!0).style.backgroundClip = "",
            d.clearCloneStyle = "content-box" === a.style.backgroundClip,
            s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",
            s.appendChild(a),
            p.extend(d, {
                pixelPosition: function() {
                    return u(),
                    e
                },
                boxSizingReliable: function() {
                    return null == n && u(),
                    n
                },
                pixelMarginRight: function() {
                    return null == n && u(),
                    r
                },
                reliableMarginLeft: function() {
                    return null == n && u(),
                    o
                },
                reliableMarginRight: function() {
                    var e, n = a.appendChild(i.createElement("div"));
                    return n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",
                    n.style.marginRight = n.style.width = "0",
                    a.style.width = "1px",
                    Dt.appendChild(s),
                    e = !parseFloat(t.getComputedStyle(n).marginRight),
                    Dt.removeChild(s),
                    a.removeChild(n),
                    e
                }
            })
        }
    }();
    var jt = /^(none|table(?!-c[ea]).+)/
      , Nt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , At = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , Pt = ["Webkit", "O", "Moz", "ms"]
      , Gt = i.createElement("div").style;
    function $t(t) {
        if (t in Gt)
            return t;
        for (var e = t[0].toUpperCase() + t.slice(1), n = Pt.length; n--; )
            if ((t = Pt[n] + e)in Gt)
                return t
    }
    function Ot(t, e, n) {
        var i = I.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e
    }
    function Rt(t, e, n, i, r) {
        for (var o = n === (i ? "border" : "content") ? 4 : "width" === e ? 1 : 0, s = 0; 4 > o; o += 2)
            "margin" === n && (s += p.css(t, n + H[o], !0, r)),
            i ? ("content" === n && (s -= p.css(t, "padding" + H[o], !0, r)),
            "margin" !== n && (s -= p.css(t, "border" + H[o] + "Width", !0, r))) : (s += p.css(t, "padding" + H[o], !0, r),
            "padding" !== n && (s += p.css(t, "border" + H[o] + "Width", !0, r)));
        return s
    }
    function Mt(e, n, r) {
        var o = !0
          , s = "width" === n ? e.offsetWidth : e.offsetHeight
          , a = Lt(e)
          , u = "border-box" === p.css(e, "boxSizing", !1, a);
        if (i.msFullscreenElement && t.top !== t && e.getClientRects().length && (s = Math.round(100 * e.getBoundingClientRect()[n])),
        0 >= s || null == s) {
            if ((0 > (s = kt(e, n, a)) || null == s) && (s = e.style[n]),
            St.test(s))
                return s;
            o = u && (d.boxSizingReliable() || s === e.style[n]),
            s = parseFloat(s) || 0
        }
        return s + Rt(e, n, r || (u ? "border" : "content"), o, a) + "px"
    }
    function Bt(t, e) {
        for (var n, i, r, o = [], s = 0, a = t.length; a > s; s++)
            (i = t[s]).style && (o[s] = O.get(i, "olddisplay"),
            n = i.style.display,
            e ? (o[s] || "none" !== n || (i.style.display = ""),
            "" === i.style.display && W(i) && (o[s] = O.access(i, "olddisplay", Tt(i.nodeName)))) : (r = W(i),
            "none" === n && r || O.set(i, "olddisplay", r ? n : p.css(i, "display"))));
        for (s = 0; a > s; s++)
            (i = t[s]).style && (e && "none" !== i.style.display && "" !== i.style.display || (i.style.display = e ? o[s] || "" : "none"));
        return t
    }
    function Ft(t, e, n, i, r) {
        return new Ft.prototype.init(t,e,n,i,r)
    }
    p.extend({
        cssHooks: {
            opacity: {
                get: function(t, e) {
                    if (e) {
                        var n = kt(t, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: "cssFloat"
        },
        style: function(t, e, n, i) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var r, o, s, a = p.camelCase(e), u = t.style;
                return e = p.cssProps[a] || (p.cssProps[a] = $t(a) || a),
                s = p.cssHooks[e] || p.cssHooks[a],
                void 0 === n ? s && "get"in s && void 0 !== (r = s.get(t, !1, i)) ? r : u[e] : ("string" === (o = typeof n) && (r = I.exec(n)) && r[1] && (n = U(t, e, r),
                o = "number"),
                void (null != n && n == n && ("number" === o && (n += r && r[3] || (p.cssNumber[a] ? "" : "px")),
                d.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (u[e] = "inherit"),
                s && "set"in s && void 0 === (n = s.set(t, n, i)) || (u[e] = n))))
            }
        },
        css: function(t, e, n, i) {
            var r, o, s, a = p.camelCase(e);
            return e = p.cssProps[a] || (p.cssProps[a] = $t(a) || a),
            (s = p.cssHooks[e] || p.cssHooks[a]) && "get"in s && (r = s.get(t, !0, n)),
            void 0 === r && (r = kt(t, e, i)),
            "normal" === r && e in At && (r = At[e]),
            "" === n || n ? (o = parseFloat(r),
            !0 === n || isFinite(o) ? o || 0 : r) : r
        }
    }),
    p.each(["height", "width"], function(t, e) {
        p.cssHooks[e] = {
            get: function(t, n, i) {
                return n ? jt.test(p.css(t, "display")) && 0 === t.offsetWidth ? qt(t, Nt, function() {
                    return Mt(t, e, i)
                }) : Mt(t, e, i) : void 0
            },
            set: function(t, n, i) {
                var r, o = i && Lt(t), s = i && Rt(t, e, i, "border-box" === p.css(t, "boxSizing", !1, o), o);
                return s && (r = I.exec(n)) && "px" !== (r[3] || "px") && (t.style[e] = n,
                n = p.css(t, e)),
                Ot(0, n, s)
            }
        }
    }),
    p.cssHooks.marginLeft = Et(d.reliableMarginLeft, function(t, e) {
        return e ? (parseFloat(kt(t, "marginLeft")) || t.getBoundingClientRect().left - qt(t, {
            marginLeft: 0
        }, function() {
            return t.getBoundingClientRect().left
        })) + "px" : void 0
    }),
    p.cssHooks.marginRight = Et(d.reliableMarginRight, function(t, e) {
        return e ? qt(t, {
            display: "inline-block"
        }, kt, [t, "marginRight"]) : void 0
    }),
    p.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, e) {
        p.cssHooks[t + e] = {
            expand: function(n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++)
                    r[t + H[i] + e] = o[i] || o[i - 2] || o[0];
                return r
            }
        },
        Ct.test(t) || (p.cssHooks[t + e].set = Ot)
    }),
    p.fn.extend({
        css: function(t, e) {
            return P(this, function(t, e, n) {
                var i, r, o = {}, s = 0;
                if (p.isArray(e)) {
                    for (i = Lt(t),
                    r = e.length; r > s; s++)
                        o[e[s]] = p.css(t, e[s], !1, i);
                    return o
                }
                return void 0 !== n ? p.style(t, e, n) : p.css(t, e)
            }, t, e, arguments.length > 1)
        },
        show: function() {
            return Bt(this, !0)
        },
        hide: function() {
            return Bt(this)
        },
        toggle: function(t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                W(this) ? p(this).show() : p(this).hide()
            })
        }
    }),
    p.Tween = Ft,
    Ft.prototype = {
        constructor: Ft,
        init: function(t, e, n, i, r, o) {
            this.elem = t,
            this.prop = n,
            this.easing = r || p.easing._default,
            this.options = e,
            this.start = this.now = this.cur(),
            this.end = i,
            this.unit = o || (p.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var t = Ft.propHooks[this.prop];
            return t && t.get ? t.get(this) : Ft.propHooks._default.get(this)
        },
        run: function(t) {
            var e, n = Ft.propHooks[this.prop];
            return this.options.duration ? this.pos = e = p.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t,
            this.now = (this.end - this.start) * e + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : Ft.propHooks._default.set(this),
            this
        }
    },
    Ft.prototype.init.prototype = Ft.prototype,
    Ft.propHooks = {
        _default: {
            get: function(t) {
                var e;
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = p.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
            },
            set: function(t) {
                p.fx.step[t.prop] ? p.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[p.cssProps[t.prop]] && !p.cssHooks[t.prop] ? t.elem[t.prop] = t.now : p.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    },
    Ft.propHooks.scrollTop = Ft.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    },
    p.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    },
    p.fx = Ft.prototype.init,
    p.fx.step = {};
    var zt, It, Ht = /^(?:toggle|show|hide)$/, Wt = /queueHooks$/;
    function Ut() {
        return t.setTimeout(function() {
            zt = void 0
        }),
        zt = p.now()
    }
    function Vt(t, e) {
        var n, i = 0, r = {
            height: t
        };
        for (e = e ? 1 : 0; 4 > i; i += 2 - e)
            r["margin" + (n = H[i])] = r["padding" + n] = t;
        return e && (r.opacity = r.width = t),
        r
    }
    function Xt(t, e, n) {
        for (var i, r = (Yt.tweeners[e] || []).concat(Yt.tweeners["*"]), o = 0, s = r.length; s > o; o++)
            if (i = r[o].call(n, e, t))
                return i
    }
    function Yt(t, e, n) {
        var i, r, o = 0, s = Yt.prefilters.length, a = p.Deferred().always(function() {
            delete u.elem
        }), u = function() {
            if (r)
                return !1;
            for (var e = zt || Ut(), n = Math.max(0, l.startTime + l.duration - e), i = 1 - (n / l.duration || 0), o = 0, s = l.tweens.length; s > o; o++)
                l.tweens[o].run(i);
            return a.notifyWith(t, [l, i, n]),
            1 > i && s ? n : (a.resolveWith(t, [l]),
            !1)
        }, l = a.promise({
            elem: t,
            props: p.extend({}, e),
            opts: p.extend(!0, {
                specialEasing: {},
                easing: p.easing._default
            }, n),
            originalProperties: e,
            originalOptions: n,
            startTime: zt || Ut(),
            duration: n.duration,
            tweens: [],
            createTween: function(e, n) {
                var i = p.Tween(t, l.opts, e, n, l.opts.specialEasing[e] || l.opts.easing);
                return l.tweens.push(i),
                i
            },
            stop: function(e) {
                var n = 0
                  , i = e ? l.tweens.length : 0;
                if (r)
                    return this;
                for (r = !0; i > n; n++)
                    l.tweens[n].run(1);
                return e ? (a.notifyWith(t, [l, 1, 0]),
                a.resolveWith(t, [l, e])) : a.rejectWith(t, [l, e]),
                this
            }
        }), c = l.props;
        for (function(t, e) {
            var n, i, r, o, s;
            for (n in t)
                if (r = e[i = p.camelCase(n)],
                o = t[n],
                p.isArray(o) && (r = o[1],
                o = t[n] = o[0]),
                n !== i && (t[i] = o,
                delete t[n]),
                (s = p.cssHooks[i]) && "expand"in s)
                    for (n in o = s.expand(o),
                    delete t[i],
                    o)
                        n in t || (t[n] = o[n],
                        e[n] = r);
                else
                    e[i] = r
        }(c, l.opts.specialEasing); s > o; o++)
            if (i = Yt.prefilters[o].call(l, t, c, l.opts))
                return p.isFunction(i.stop) && (p._queueHooks(l.elem, l.opts.queue).stop = p.proxy(i.stop, i)),
                i;
        return p.map(c, Xt, l),
        p.isFunction(l.opts.start) && l.opts.start.call(t, l),
        p.fx.timer(p.extend(u, {
            elem: t,
            anim: l,
            queue: l.opts.queue
        })),
        l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always)
    }
    p.Animation = p.extend(Yt, {
        tweeners: {
            "*": [function(t, e) {
                var n = this.createTween(t, e);
                return U(n.elem, t, I.exec(e), n),
                n
            }
            ]
        },
        tweener: function(t, e) {
            p.isFunction(t) ? (e = t,
            t = ["*"]) : t = t.match(N);
            for (var n, i = 0, r = t.length; r > i; i++)
                n = t[i],
                Yt.tweeners[n] = Yt.tweeners[n] || [],
                Yt.tweeners[n].unshift(e)
        },
        prefilters: [function(t, e, n) {
            var i, r, o, s, a, u, l, c = this, d = {}, h = t.style, f = t.nodeType && W(t), g = O.get(t, "fxshow");
            for (i in n.queue || (null == (a = p._queueHooks(t, "fx")).unqueued && (a.unqueued = 0,
            u = a.empty.fire,
            a.empty.fire = function() {
                a.unqueued || u()
            }
            ),
            a.unqueued++,
            c.always(function() {
                c.always(function() {
                    a.unqueued--,
                    p.queue(t, "fx").length || a.empty.fire()
                })
            })),
            1 === t.nodeType && ("height"in e || "width"in e) && (n.overflow = [h.overflow, h.overflowX, h.overflowY],
            "inline" === ("none" === (l = p.css(t, "display")) ? O.get(t, "olddisplay") || Tt(t.nodeName) : l) && "none" === p.css(t, "float") && (h.display = "inline-block")),
            n.overflow && (h.overflow = "hidden",
            c.always(function() {
                h.overflow = n.overflow[0],
                h.overflowX = n.overflow[1],
                h.overflowY = n.overflow[2]
            })),
            e)
                if (r = e[i],
                Ht.exec(r)) {
                    if (delete e[i],
                    o = o || "toggle" === r,
                    r === (f ? "hide" : "show")) {
                        if ("show" !== r || !g || void 0 === g[i])
                            continue;
                        f = !0
                    }
                    d[i] = g && g[i] || p.style(t, i)
                } else
                    l = void 0;
            if (p.isEmptyObject(d))
                "inline" === ("none" === l ? Tt(t.nodeName) : l) && (h.display = l);
            else
                for (i in g ? "hidden"in g && (f = g.hidden) : g = O.access(t, "fxshow", {}),
                o && (g.hidden = !f),
                f ? p(t).show() : c.done(function() {
                    p(t).hide()
                }),
                c.done(function() {
                    var e;
                    for (e in O.remove(t, "fxshow"),
                    d)
                        p.style(t, e, d[e])
                }),
                d)
                    s = Xt(f ? g[i] : 0, i, c),
                    i in g || (g[i] = s.start,
                    f && (s.end = s.start,
                    s.start = "width" === i || "height" === i ? 1 : 0))
        }
        ],
        prefilter: function(t, e) {
            e ? Yt.prefilters.unshift(t) : Yt.prefilters.push(t)
        }
    }),
    p.speed = function(t, e, n) {
        var i = t && "object" == typeof t ? p.extend({}, t) : {
            complete: n || !n && e || p.isFunction(t) && t,
            duration: t,
            easing: n && e || e && !p.isFunction(e) && e
        };
        return i.duration = p.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in p.fx.speeds ? p.fx.speeds[i.duration] : p.fx.speeds._default,
        null != i.queue && !0 !== i.queue || (i.queue = "fx"),
        i.old = i.complete,
        i.complete = function() {
            p.isFunction(i.old) && i.old.call(this),
            i.queue && p.dequeue(this, i.queue)
        }
        ,
        i
    }
    ,
    p.fn.extend({
        fadeTo: function(t, e, n, i) {
            return this.filter(W).css("opacity", 0).show().end().animate({
                opacity: e
            }, t, n, i)
        },
        animate: function(t, e, n, i) {
            var r = p.isEmptyObject(t)
              , o = p.speed(e, n, i)
              , s = function() {
                var e = Yt(this, p.extend({}, t), o);
                (r || O.get(this, "finish")) && e.stop(!0)
            };
            return s.finish = s,
            r || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
        },
        stop: function(t, e, n) {
            var i = function(t) {
                var e = t.stop;
                delete t.stop,
                e(n)
            };
            return "string" != typeof t && (n = e,
            e = t,
            t = void 0),
            e && !1 !== t && this.queue(t || "fx", []),
            this.each(function() {
                var e = !0
                  , r = null != t && t + "queueHooks"
                  , o = p.timers
                  , s = O.get(this);
                if (r)
                    s[r] && s[r].stop && i(s[r]);
                else
                    for (r in s)
                        s[r] && s[r].stop && Wt.test(r) && i(s[r]);
                for (r = o.length; r--; )
                    o[r].elem !== this || null != t && o[r].queue !== t || (o[r].anim.stop(n),
                    e = !1,
                    o.splice(r, 1));
                !e && n || p.dequeue(this, t)
            })
        },
        finish: function(t) {
            return !1 !== t && (t = t || "fx"),
            this.each(function() {
                var e, n = O.get(this), i = n[t + "queue"], r = n[t + "queueHooks"], o = p.timers, s = i ? i.length : 0;
                for (n.finish = !0,
                p.queue(this, t, []),
                r && r.stop && r.stop.call(this, !0),
                e = o.length; e--; )
                    o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0),
                    o.splice(e, 1));
                for (e = 0; s > e; e++)
                    i[e] && i[e].finish && i[e].finish.call(this);
                delete n.finish
            })
        }
    }),
    p.each(["toggle", "show", "hide"], function(t, e) {
        var n = p.fn[e];
        p.fn[e] = function(t, i, r) {
            return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(Vt(e, !0), t, i, r)
        }
    }),
    p.each({
        slideDown: Vt("show"),
        slideUp: Vt("hide"),
        slideToggle: Vt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(t, e) {
        p.fn[t] = function(t, n, i) {
            return this.animate(e, t, n, i)
        }
    }),
    p.timers = [],
    p.fx.tick = function() {
        var t, e = 0, n = p.timers;
        for (zt = p.now(); e < n.length; e++)
            (t = n[e])() || n[e] !== t || n.splice(e--, 1);
        n.length || p.fx.stop(),
        zt = void 0
    }
    ,
    p.fx.timer = function(t) {
        p.timers.push(t),
        t() ? p.fx.start() : p.timers.pop()
    }
    ,
    p.fx.interval = 13,
    p.fx.start = function() {
        It || (It = t.setInterval(p.fx.tick, p.fx.interval))
    }
    ,
    p.fx.stop = function() {
        t.clearInterval(It),
        It = null
    }
    ,
    p.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    p.fn.delay = function(e, n) {
        return e = p.fx && p.fx.speeds[e] || e,
        n = n || "fx",
        this.queue(n, function(n, i) {
            var r = t.setTimeout(n, e);
            i.stop = function() {
                t.clearTimeout(r)
            }
        })
    }
    ,
    function() {
        var t = i.createElement("input")
          , e = i.createElement("select")
          , n = e.appendChild(i.createElement("option"));
        t.type = "checkbox",
        d.checkOn = "" !== t.value,
        d.optSelected = n.selected,
        e.disabled = !0,
        d.optDisabled = !n.disabled,
        (t = i.createElement("input")).value = "t",
        t.type = "radio",
        d.radioValue = "t" === t.value
    }();
    var Jt, Qt = p.expr.attrHandle;
    p.fn.extend({
        attr: function(t, e) {
            return P(this, p.attr, t, e, arguments.length > 1)
        },
        removeAttr: function(t) {
            return this.each(function() {
                p.removeAttr(this, t)
            })
        }
    }),
    p.extend({
        attr: function(t, e, n) {
            var i, r, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return void 0 === t.getAttribute ? p.prop(t, e, n) : (1 === o && p.isXMLDoc(t) || (e = e.toLowerCase(),
                r = p.attrHooks[e] || (p.expr.match.bool.test(e) ? Jt : void 0)),
                void 0 !== n ? null === n ? void p.removeAttr(t, e) : r && "set"in r && void 0 !== (i = r.set(t, n, e)) ? i : (t.setAttribute(e, n + ""),
                n) : r && "get"in r && null !== (i = r.get(t, e)) ? i : null == (i = p.find.attr(t, e)) ? void 0 : i)
        },
        attrHooks: {
            type: {
                set: function(t, e) {
                    if (!d.radioValue && "radio" === e && p.nodeName(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e),
                        n && (t.value = n),
                        e
                    }
                }
            }
        },
        removeAttr: function(t, e) {
            var n, i, r = 0, o = e && e.match(N);
            if (o && 1 === t.nodeType)
                for (; n = o[r++]; )
                    i = p.propFix[n] || n,
                    p.expr.match.bool.test(n) && (t[i] = !1),
                    t.removeAttribute(n)
        }
    }),
    Jt = {
        set: function(t, e, n) {
            return !1 === e ? p.removeAttr(t, n) : t.setAttribute(n, n),
            n
        }
    },
    p.each(p.expr.match.bool.source.match(/\w+/g), function(t, e) {
        var n = Qt[e] || p.find.attr;
        Qt[e] = function(t, e, i) {
            var r, o;
            return i || (o = Qt[e],
            Qt[e] = r,
            r = null != n(t, e, i) ? e.toLowerCase() : null,
            Qt[e] = o),
            r
        }
    });
    var Zt = /^(?:input|select|textarea|button)$/i
      , Kt = /^(?:a|area)$/i;
    p.fn.extend({
        prop: function(t, e) {
            return P(this, p.prop, t, e, arguments.length > 1)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[p.propFix[t] || t]
            })
        }
    }),
    p.extend({
        prop: function(t, e, n) {
            var i, r, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && p.isXMLDoc(t) || (e = p.propFix[e] || e,
                r = p.propHooks[e]),
                void 0 !== n ? r && "set"in r && void 0 !== (i = r.set(t, n, e)) ? i : t[e] = n : r && "get"in r && null !== (i = r.get(t, e)) ? i : t[e]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var e = p.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : Zt.test(t.nodeName) || Kt.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    d.optSelected || (p.propHooks.selected = {
        get: function(t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex,
            null
        },
        set: function(t) {
            var e = t.parentNode;
            e && (e.selectedIndex,
            e.parentNode && e.parentNode.selectedIndex)
        }
    }),
    p.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        p.propFix[this.toLowerCase()] = this
    });
    var te = /[\t\r\n\f]/g;
    function ee(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }
    p.fn.extend({
        addClass: function(t) {
            var e, n, i, r, o, s, a, u = 0;
            if (p.isFunction(t))
                return this.each(function(e) {
                    p(this).addClass(t.call(this, e, ee(this)))
                });
            if ("string" == typeof t && t)
                for (e = t.match(N) || []; n = this[u++]; )
                    if (r = ee(n),
                    i = 1 === n.nodeType && (" " + r + " ").replace(te, " ")) {
                        for (s = 0; o = e[s++]; )
                            i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                        r !== (a = p.trim(i)) && n.setAttribute("class", a)
                    }
            return this
        },
        removeClass: function(t) {
            var e, n, i, r, o, s, a, u = 0;
            if (p.isFunction(t))
                return this.each(function(e) {
                    p(this).removeClass(t.call(this, e, ee(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ("string" == typeof t && t)
                for (e = t.match(N) || []; n = this[u++]; )
                    if (r = ee(n),
                    i = 1 === n.nodeType && (" " + r + " ").replace(te, " ")) {
                        for (s = 0; o = e[s++]; )
                            for (; i.indexOf(" " + o + " ") > -1; )
                                i = i.replace(" " + o + " ", " ");
                        r !== (a = p.trim(i)) && n.setAttribute("class", a)
                    }
            return this
        },
        toggleClass: function(t, e) {
            var n = typeof t;
            return "boolean" == typeof e && "string" === n ? e ? this.addClass(t) : this.removeClass(t) : p.isFunction(t) ? this.each(function(n) {
                p(this).toggleClass(t.call(this, n, ee(this), e), e)
            }) : this.each(function() {
                var e, i, r, o;
                if ("string" === n)
                    for (i = 0,
                    r = p(this),
                    o = t.match(N) || []; e = o[i++]; )
                        r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                else
                    void 0 !== t && "boolean" !== n || ((e = ee(this)) && O.set(this, "__className__", e),
                    this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : O.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var e, n, i = 0;
            for (e = " " + t + " "; n = this[i++]; )
                if (1 === n.nodeType && (" " + ee(n) + " ").replace(te, " ").indexOf(e) > -1)
                    return !0;
            return !1
        }
    });
    var ne = /\r/g
      , ie = /[\x20\t\r\n\f]+/g;
    p.fn.extend({
        val: function(t) {
            var e, n, i, r = this[0];
            return arguments.length ? (i = p.isFunction(t),
            this.each(function(n) {
                var r;
                1 === this.nodeType && (null == (r = i ? t.call(this, n, p(this).val()) : t) ? r = "" : "number" == typeof r ? r += "" : p.isArray(r) && (r = p.map(r, function(t) {
                    return null == t ? "" : t + ""
                })),
                (e = p.valHooks[this.type] || p.valHooks[this.nodeName.toLowerCase()]) && "set"in e && void 0 !== e.set(this, r, "value") || (this.value = r))
            })) : r ? (e = p.valHooks[r.type] || p.valHooks[r.nodeName.toLowerCase()]) && "get"in e && void 0 !== (n = e.get(r, "value")) ? n : "string" == typeof (n = r.value) ? n.replace(ne, "") : null == n ? "" : n : void 0
        }
    }),
    p.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var e = p.find.attr(t, "value");
                    return null != e ? e : p.trim(p.text(t)).replace(ie, " ")
                }
            },
            select: {
                get: function(t) {
                    for (var e, n, i = t.options, r = t.selectedIndex, o = "select-one" === t.type || 0 > r, s = o ? null : [], a = o ? r + 1 : i.length, u = 0 > r ? a : o ? r : 0; a > u; u++)
                        if (((n = i[u]).selected || u === r) && (d.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !p.nodeName(n.parentNode, "optgroup"))) {
                            if (e = p(n).val(),
                            o)
                                return e;
                            s.push(e)
                        }
                    return s
                },
                set: function(t, e) {
                    for (var n, i, r = t.options, o = p.makeArray(e), s = r.length; s--; )
                        ((i = r[s]).selected = p.inArray(p.valHooks.option.get(i), o) > -1) && (n = !0);
                    return n || (t.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    p.each(["radio", "checkbox"], function() {
        p.valHooks[this] = {
            set: function(t, e) {
                return p.isArray(e) ? t.checked = p.inArray(p(t).val(), e) > -1 : void 0
            }
        },
        d.checkOn || (p.valHooks[this].get = function(t) {
            return null === t.getAttribute("value") ? "on" : t.value
        }
        )
    });
    var re = /^(?:focusinfocus|focusoutblur)$/;
    p.extend(p.event, {
        trigger: function(e, n, r, o) {
            var s, a, u, l, d, h, f, g = [r || i], m = c.call(e, "type") ? e.type : e, v = c.call(e, "namespace") ? e.namespace.split(".") : [];
            if (a = u = r = r || i,
            3 !== r.nodeType && 8 !== r.nodeType && !re.test(m + p.event.triggered) && (m.indexOf(".") > -1 && (v = m.split("."),
            m = v.shift(),
            v.sort()),
            d = m.indexOf(":") < 0 && "on" + m,
            (e = e[p.expando] ? e : new p.Event(m,"object" == typeof e && e)).isTrigger = o ? 2 : 3,
            e.namespace = v.join("."),
            e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            e.result = void 0,
            e.target || (e.target = r),
            n = null == n ? [e] : p.makeArray(n, [e]),
            f = p.event.special[m] || {},
            o || !f.trigger || !1 !== f.trigger.apply(r, n))) {
                if (!o && !f.noBubble && !p.isWindow(r)) {
                    for (l = f.delegateType || m,
                    re.test(l + m) || (a = a.parentNode); a; a = a.parentNode)
                        g.push(a),
                        u = a;
                    u === (r.ownerDocument || i) && g.push(u.defaultView || u.parentWindow || t)
                }
                for (s = 0; (a = g[s++]) && !e.isPropagationStopped(); )
                    e.type = s > 1 ? l : f.bindType || m,
                    (h = (O.get(a, "events") || {})[e.type] && O.get(a, "handle")) && h.apply(a, n),
                    (h = d && a[d]) && h.apply && G(a) && (e.result = h.apply(a, n),
                    !1 === e.result && e.preventDefault());
                return e.type = m,
                o || e.isDefaultPrevented() || f._default && !1 !== f._default.apply(g.pop(), n) || !G(r) || d && p.isFunction(r[m]) && !p.isWindow(r) && ((u = r[d]) && (r[d] = null),
                p.event.triggered = m,
                r[m](),
                p.event.triggered = void 0,
                u && (r[d] = u)),
                e.result
            }
        },
        simulate: function(t, e, n) {
            var i = p.extend(new p.Event, n, {
                type: t,
                isSimulated: !0
            });
            p.event.trigger(i, null, e),
            i.isDefaultPrevented() && n.preventDefault()
        }
    }),
    p.fn.extend({
        trigger: function(t, e) {
            return this.each(function() {
                p.event.trigger(t, e, this)
            })
        },
        triggerHandler: function(t, e) {
            var n = this[0];
            return n ? p.event.trigger(t, e, n, !0) : void 0
        }
    }),
    p.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(t, e) {
        p.fn[e] = function(t, n) {
            return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
        }
    }),
    p.fn.extend({
        hover: function(t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }),
    d.focusin = "onfocusin"in t,
    d.focusin || p.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        var n = function(t) {
            p.event.simulate(e, t.target, p.event.fix(t))
        };
        p.event.special[e] = {
            setup: function() {
                var i = this.ownerDocument || this
                  , r = O.access(i, e);
                r || i.addEventListener(t, n, !0),
                O.access(i, e, (r || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this
                  , r = O.access(i, e) - 1;
                r ? O.access(i, e, r) : (i.removeEventListener(t, n, !0),
                O.remove(i, e))
            }
        }
    });
    var oe = t.location
      , se = p.now()
      , ae = /\?/;
    p.parseJSON = function(t) {
        return JSON.parse(t + "")
    }
    ,
    p.parseXML = function(e) {
        var n;
        if (!e || "string" != typeof e)
            return null;
        try {
            n = (new t.DOMParser).parseFromString(e, "text/xml")
        } catch (t) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || p.error("Invalid XML: " + e),
        n
    }
    ;
    var ue = /#.*$/
      , le = /([?&])_=[^&]*/
      , ce = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , de = /^(?:GET|HEAD)$/
      , he = /^\/\//
      , pe = {}
      , fe = {}
      , ge = "*/".concat("*")
      , me = i.createElement("a");
    function ve(t) {
        return function(e, n) {
            "string" != typeof e && (n = e,
            e = "*");
            var i, r = 0, o = e.toLowerCase().match(N) || [];
            if (p.isFunction(n))
                for (; i = o[r++]; )
                    "+" === i[0] ? (i = i.slice(1) || "*",
                    (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n)
        }
    }
    function ye(t, e, n, i) {
        var r = {}
          , o = t === fe;
        function s(a) {
            var u;
            return r[a] = !0,
            p.each(t[a] || [], function(t, a) {
                var l = a(e, n, i);
                return "string" != typeof l || o || r[l] ? o ? !(u = l) : void 0 : (e.dataTypes.unshift(l),
                s(l),
                !1)
            }),
            u
        }
        return s(e.dataTypes[0]) || !r["*"] && s("*")
    }
    function xe(t, e) {
        var n, i, r = p.ajaxSettings.flatOptions || {};
        for (n in e)
            void 0 !== e[n] && ((r[n] ? t : i || (i = {}))[n] = e[n]);
        return i && p.extend(!0, t, i),
        t
    }
    me.href = oe.href,
    p.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: oe.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(oe.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": ge,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": p.parseJSON,
                "text xml": p.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, e) {
            return e ? xe(xe(t, p.ajaxSettings), e) : xe(p.ajaxSettings, t)
        },
        ajaxPrefilter: ve(pe),
        ajaxTransport: ve(fe),
        ajax: function(e, n) {
            "object" == typeof e && (n = e,
            e = void 0),
            n = n || {};
            var r, o, s, a, u, l, c, d, h = p.ajaxSetup({}, n), f = h.context || h, g = h.context && (f.nodeType || f.jquery) ? p(f) : p.event, m = p.Deferred(), v = p.Callbacks("once memory"), y = h.statusCode || {}, x = {}, w = {}, b = 0, _ = "canceled", T = {
                readyState: 0,
                getResponseHeader: function(t) {
                    var e;
                    if (2 === b) {
                        if (!a)
                            for (a = {}; e = ce.exec(s); )
                                a[e[1].toLowerCase()] = e[2];
                        e = a[t.toLowerCase()]
                    }
                    return null == e ? null : e
                },
                getAllResponseHeaders: function() {
                    return 2 === b ? s : null
                },
                setRequestHeader: function(t, e) {
                    var n = t.toLowerCase();
                    return b || (t = w[n] = w[n] || t,
                    x[t] = e),
                    this
                },
                overrideMimeType: function(t) {
                    return b || (h.mimeType = t),
                    this
                },
                statusCode: function(t) {
                    var e;
                    if (t)
                        if (2 > b)
                            for (e in t)
                                y[e] = [y[e], t[e]];
                        else
                            T.always(t[T.status]);
                    return this
                },
                abort: function(t) {
                    var e = t || _;
                    return r && r.abort(e),
                    C(0, e),
                    this
                }
            };
            if (m.promise(T).complete = v.add,
            T.success = T.done,
            T.error = T.fail,
            h.url = ((e || h.url || oe.href) + "").replace(ue, "").replace(he, oe.protocol + "//"),
            h.type = n.method || n.type || h.method || h.type,
            h.dataTypes = p.trim(h.dataType || "*").toLowerCase().match(N) || [""],
            null == h.crossDomain) {
                l = i.createElement("a");
                try {
                    l.href = h.url,
                    l.href = l.href,
                    h.crossDomain = me.protocol + "//" + me.host != l.protocol + "//" + l.host
                } catch (t) {
                    h.crossDomain = !0
                }
            }
            if (h.data && h.processData && "string" != typeof h.data && (h.data = p.param(h.data, h.traditional)),
            ye(pe, h, n, T),
            2 === b)
                return T;
            for (d in (c = p.event && h.global) && 0 == p.active++ && p.event.trigger("ajaxStart"),
            h.type = h.type.toUpperCase(),
            h.hasContent = !de.test(h.type),
            o = h.url,
            h.hasContent || (h.data && (o = h.url += (ae.test(o) ? "&" : "?") + h.data,
            delete h.data),
            !1 === h.cache && (h.url = le.test(o) ? o.replace(le, "$1_=" + se++) : o + (ae.test(o) ? "&" : "?") + "_=" + se++)),
            h.ifModified && (p.lastModified[o] && T.setRequestHeader("If-Modified-Since", p.lastModified[o]),
            p.etag[o] && T.setRequestHeader("If-None-Match", p.etag[o])),
            (h.data && h.hasContent && !1 !== h.contentType || n.contentType) && T.setRequestHeader("Content-Type", h.contentType),
            T.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + ge + "; q=0.01" : "") : h.accepts["*"]),
            h.headers)
                T.setRequestHeader(d, h.headers[d]);
            if (h.beforeSend && (!1 === h.beforeSend.call(f, T, h) || 2 === b))
                return T.abort();
            for (d in _ = "abort",
            {
                success: 1,
                error: 1,
                complete: 1
            })
                T[d](h[d]);
            if (r = ye(fe, h, n, T)) {
                if (T.readyState = 1,
                c && g.trigger("ajaxSend", [T, h]),
                2 === b)
                    return T;
                h.async && h.timeout > 0 && (u = t.setTimeout(function() {
                    T.abort("timeout")
                }, h.timeout));
                try {
                    b = 1,
                    r.send(x, C)
                } catch (t) {
                    if (!(2 > b))
                        throw t;
                    C(-1, t)
                }
            } else
                C(-1, "No Transport");
            function C(e, n, i, a) {
                var l, d, x, w, _, C = n;
                2 !== b && (b = 2,
                u && t.clearTimeout(u),
                r = void 0,
                s = a || "",
                T.readyState = e > 0 ? 4 : 0,
                l = e >= 200 && 300 > e || 304 === e,
                i && (w = function(t, e, n) {
                    for (var i, r, o, s, a = t.contents, u = t.dataTypes; "*" === u[0]; )
                        u.shift(),
                        void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (i)
                        for (r in a)
                            if (a[r] && a[r].test(i)) {
                                u.unshift(r);
                                break
                            }
                    if (u[0]in n)
                        o = u[0];
                    else {
                        for (r in n) {
                            if (!u[0] || t.converters[r + " " + u[0]]) {
                                o = r;
                                break
                            }
                            s || (s = r)
                        }
                        o = o || s
                    }
                    return o ? (o !== u[0] && u.unshift(o),
                    n[o]) : void 0
                }(h, T, i)),
                w = function(t, e, n, i) {
                    var r, o, s, a, u, l = {}, c = t.dataTypes.slice();
                    if (c[1])
                        for (s in t.converters)
                            l[s.toLowerCase()] = t.converters[s];
                    for (o = c.shift(); o; )
                        if (t.responseFields[o] && (n[t.responseFields[o]] = e),
                        !u && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
                        u = o,
                        o = c.shift())
                            if ("*" === o)
                                o = u;
                            else if ("*" !== u && u !== o) {
                                if (!(s = l[u + " " + o] || l["* " + o]))
                                    for (r in l)
                                        if ((a = r.split(" "))[1] === o && (s = l[u + " " + a[0]] || l["* " + a[0]])) {
                                            !0 === s ? s = l[r] : !0 !== l[r] && (o = a[0],
                                            c.unshift(a[1]));
                                            break
                                        }
                                if (!0 !== s)
                                    if (s && t.throws)
                                        e = s(e);
                                    else
                                        try {
                                            e = s(e)
                                        } catch (t) {
                                            return {
                                                state: "parsererror",
                                                error: s ? t : "No conversion from " + u + " to " + o
                                            }
                                        }
                            }
                    return {
                        state: "success",
                        data: e
                    }
                }(h, w, T, l),
                l ? (h.ifModified && ((_ = T.getResponseHeader("Last-Modified")) && (p.lastModified[o] = _),
                (_ = T.getResponseHeader("etag")) && (p.etag[o] = _)),
                204 === e || "HEAD" === h.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = w.state,
                d = w.data,
                l = !(x = w.error))) : (x = C,
                !e && C || (C = "error",
                0 > e && (e = 0))),
                T.status = e,
                T.statusText = (n || C) + "",
                l ? m.resolveWith(f, [d, C, T]) : m.rejectWith(f, [T, C, x]),
                T.statusCode(y),
                y = void 0,
                c && g.trigger(l ? "ajaxSuccess" : "ajaxError", [T, h, l ? d : x]),
                v.fireWith(f, [T, C]),
                c && (g.trigger("ajaxComplete", [T, h]),
                --p.active || p.event.trigger("ajaxStop")))
            }
            return T
        },
        getJSON: function(t, e, n) {
            return p.get(t, e, n, "json")
        },
        getScript: function(t, e) {
            return p.get(t, void 0, e, "script")
        }
    }),
    p.each(["get", "post"], function(t, e) {
        p[e] = function(t, n, i, r) {
            return p.isFunction(n) && (r = r || i,
            i = n,
            n = void 0),
            p.ajax(p.extend({
                url: t,
                type: e,
                dataType: r,
                data: n,
                success: i
            }, p.isPlainObject(t) && t))
        }
    }),
    p._evalUrl = function(t) {
        return p.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }
    ,
    p.fn.extend({
        wrapAll: function(t) {
            var e;
            return p.isFunction(t) ? this.each(function(e) {
                p(this).wrapAll(t.call(this, e))
            }) : (this[0] && (e = p(t, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && e.insertBefore(this[0]),
            e.map(function() {
                for (var t = this; t.firstElementChild; )
                    t = t.firstElementChild;
                return t
            }).append(this)),
            this)
        },
        wrapInner: function(t) {
            return p.isFunction(t) ? this.each(function(e) {
                p(this).wrapInner(t.call(this, e))
            }) : this.each(function() {
                var e = p(this)
                  , n = e.contents();
                n.length ? n.wrapAll(t) : e.append(t)
            })
        },
        wrap: function(t) {
            var e = p.isFunction(t);
            return this.each(function(n) {
                p(this).wrapAll(e ? t.call(this, n) : t)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                p.nodeName(this, "body") || p(this).replaceWith(this.childNodes)
            }).end()
        }
    }),
    p.expr.filters.hidden = function(t) {
        return !p.expr.filters.visible(t)
    }
    ,
    p.expr.filters.visible = function(t) {
        return t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0
    }
    ;
    var we = /%20/g
      , be = /\[\]$/
      , _e = /\r?\n/g
      , Te = /^(?:submit|button|image|reset|file)$/i
      , Ce = /^(?:input|select|textarea|keygen)/i;
    function Se(t, e, n, i) {
        var r;
        if (p.isArray(e))
            p.each(e, function(e, r) {
                n || be.test(t) ? i(t, r) : Se(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, n, i)
            });
        else if (n || "object" !== p.type(e))
            i(t, e);
        else
            for (r in e)
                Se(t + "[" + r + "]", e[r], n, i)
    }
    p.param = function(t, e) {
        var n, i = [], r = function(t, e) {
            e = p.isFunction(e) ? e() : null == e ? "" : e,
            i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
        };
        if (void 0 === e && (e = p.ajaxSettings && p.ajaxSettings.traditional),
        p.isArray(t) || t.jquery && !p.isPlainObject(t))
            p.each(t, function() {
                r(this.name, this.value)
            });
        else
            for (n in t)
                Se(n, t[n], e, r);
        return i.join("&").replace(we, "+")
    }
    ,
    p.fn.extend({
        serialize: function() {
            return p.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = p.prop(this, "elements");
                return t ? p.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !p(this).is(":disabled") && Ce.test(this.nodeName) && !Te.test(t) && (this.checked || !V.test(t))
            }).map(function(t, e) {
                var n = p(this).val();
                return null == n ? null : p.isArray(n) ? p.map(n, function(t) {
                    return {
                        name: e.name,
                        value: t.replace(_e, "\r\n")
                    }
                }) : {
                    name: e.name,
                    value: n.replace(_e, "\r\n")
                }
            }).get()
        }
    }),
    p.ajaxSettings.xhr = function() {
        try {
            return new t.XMLHttpRequest
        } catch (t) {}
    }
    ;
    var Le = {
        0: 200,
        1223: 204
    }
      , qe = p.ajaxSettings.xhr();
    d.cors = !!qe && "withCredentials"in qe,
    d.ajax = qe = !!qe,
    p.ajaxTransport(function(e) {
        var n, i;
        return d.cors || qe && !e.crossDomain ? {
            send: function(r, o) {
                var s, a = e.xhr();
                if (a.open(e.type, e.url, e.async, e.username, e.password),
                e.xhrFields)
                    for (s in e.xhrFields)
                        a[s] = e.xhrFields[s];
                for (s in e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType),
                e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"),
                r)
                    a.setRequestHeader(s, r[s]);
                n = function(t) {
                    return function() {
                        n && (n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null,
                        "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(Le[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }
                ,
                a.onload = n(),
                i = a.onerror = n("error"),
                void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
                    4 === a.readyState && t.setTimeout(function() {
                        n && i()
                    })
                }
                ,
                n = n("abort");
                try {
                    a.send(e.hasContent && e.data || null)
                } catch (t) {
                    if (n)
                        throw t
                }
            },
            abort: function() {
                n && n()
            }
        } : void 0
    }),
    p.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return p.globalEval(t),
                t
            }
        }
    }),
    p.ajaxPrefilter("script", function(t) {
        void 0 === t.cache && (t.cache = !1),
        t.crossDomain && (t.type = "GET")
    }),
    p.ajaxTransport("script", function(t) {
        var e, n;
        if (t.crossDomain)
            return {
                send: function(r, o) {
                    e = p("<script>").prop({
                        charset: t.scriptCharset,
                        src: t.url
                    }).on("load error", n = function(t) {
                        e.remove(),
                        n = null,
                        t && o("error" === t.type ? 404 : 200, t.type)
                    }
                    ),
                    i.head.appendChild(e[0])
                },
                abort: function() {
                    n && n()
                }
            }
    });
    var De = []
      , ke = /(=)\?(?=&|$)|\?\?/;
    p.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = De.pop() || p.expando + "_" + se++;
            return this[t] = !0,
            t
        }
    }),
    p.ajaxPrefilter("json jsonp", function(e, n, i) {
        var r, o, s, a = !1 !== e.jsonp && (ke.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && ke.test(e.data) && "data");
        return a || "jsonp" === e.dataTypes[0] ? (r = e.jsonpCallback = p.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
        a ? e[a] = e[a].replace(ke, "$1" + r) : !1 !== e.jsonp && (e.url += (ae.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
        e.converters["script json"] = function() {
            return s || p.error(r + " was not called"),
            s[0]
        }
        ,
        e.dataTypes[0] = "json",
        o = t[r],
        t[r] = function() {
            s = arguments
        }
        ,
        i.always(function() {
            void 0 === o ? p(t).removeProp(r) : t[r] = o,
            e[r] && (e.jsonpCallback = n.jsonpCallback,
            De.push(r)),
            s && p.isFunction(o) && o(s[0]),
            s = o = void 0
        }),
        "script") : void 0
    }),
    p.parseHTML = function(t, e, n) {
        if (!t || "string" != typeof t)
            return null;
        "boolean" == typeof e && (n = e,
        e = !1),
        e = e || i;
        var r = T.exec(t)
          , o = !n && [];
        return r ? [e.createElement(r[1])] : (r = tt([t], e, o),
        o && o.length && p(o).remove(),
        p.merge([], r.childNodes))
    }
    ;
    var Ee = p.fn.load;
    function je(t) {
        return p.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
    }
    p.fn.load = function(t, e, n) {
        if ("string" != typeof t && Ee)
            return Ee.apply(this, arguments);
        var i, r, o, s = this, a = t.indexOf(" ");
        return a > -1 && (i = p.trim(t.slice(a)),
        t = t.slice(0, a)),
        p.isFunction(e) ? (n = e,
        e = void 0) : e && "object" == typeof e && (r = "POST"),
        s.length > 0 && p.ajax({
            url: t,
            type: r || "GET",
            dataType: "html",
            data: e
        }).done(function(t) {
            o = arguments,
            s.html(i ? p("<div>").append(p.parseHTML(t)).find(i) : t)
        }).always(n && function(t, e) {
            s.each(function() {
                n.apply(this, o || [t.responseText, e, t])
            })
        }
        ),
        this
    }
    ,
    p.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
        p.fn[e] = function(t) {
            return this.on(e, t)
        }
    }),
    p.expr.filters.animated = function(t) {
        return p.grep(p.timers, function(e) {
            return t === e.elem
        }).length
    }
    ,
    p.offset = {
        setOffset: function(t, e, n) {
            var i, r, o, s, a, u, l = p.css(t, "position"), c = p(t), d = {};
            "static" === l && (t.style.position = "relative"),
            a = c.offset(),
            o = p.css(t, "top"),
            u = p.css(t, "left"),
            ("absolute" === l || "fixed" === l) && (o + u).indexOf("auto") > -1 ? (s = (i = c.position()).top,
            r = i.left) : (s = parseFloat(o) || 0,
            r = parseFloat(u) || 0),
            p.isFunction(e) && (e = e.call(t, n, p.extend({}, a))),
            null != e.top && (d.top = e.top - a.top + s),
            null != e.left && (d.left = e.left - a.left + r),
            "using"in e ? e.using.call(t, d) : c.css(d)
        }
    },
    p.fn.extend({
        offset: function(t) {
            if (arguments.length)
                return void 0 === t ? this : this.each(function(e) {
                    p.offset.setOffset(this, t, e)
                });
            var e, n, i = this[0], r = {
                top: 0,
                left: 0
            }, o = i && i.ownerDocument;
            return o ? (e = o.documentElement,
            p.contains(e, i) ? (r = i.getBoundingClientRect(),
            n = je(o),
            {
                top: r.top + n.pageYOffset - e.clientTop,
                left: r.left + n.pageXOffset - e.clientLeft
            }) : r) : void 0
        },
        position: function() {
            if (this[0]) {
                var t, e, n = this[0], i = {
                    top: 0,
                    left: 0
                };
                return "fixed" === p.css(n, "position") ? e = n.getBoundingClientRect() : (t = this.offsetParent(),
                e = this.offset(),
                p.nodeName(t[0], "html") || (i = t.offset()),
                i.top += p.css(t[0], "borderTopWidth", !0),
                i.left += p.css(t[0], "borderLeftWidth", !0)),
                {
                    top: e.top - i.top - p.css(n, "marginTop", !0),
                    left: e.left - i.left - p.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && "static" === p.css(t, "position"); )
                    t = t.offsetParent;
                return t || Dt
            })
        }
    }),
    p.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, e) {
        var n = "pageYOffset" === e;
        p.fn[t] = function(i) {
            return P(this, function(t, i, r) {
                var o = je(t);
                return void 0 === r ? o ? o[e] : t[i] : void (o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : t[i] = r)
            }, t, i, arguments.length)
        }
    }),
    p.each(["top", "left"], function(t, e) {
        p.cssHooks[e] = Et(d.pixelPosition, function(t, n) {
            return n ? (n = kt(t, e),
            St.test(n) ? p(t).position()[e] + "px" : n) : void 0
        })
    }),
    p.each({
        Height: "height",
        Width: "width"
    }, function(t, e) {
        p.each({
            padding: "inner" + t,
            content: e,
            "": "outer" + t
        }, function(n, i) {
            p.fn[i] = function(i, r) {
                var o = arguments.length && (n || "boolean" != typeof i)
                  , s = n || (!0 === i || !0 === r ? "margin" : "border");
                return P(this, function(e, n, i) {
                    var r;
                    return p.isWindow(e) ? e.document.documentElement["client" + t] : 9 === e.nodeType ? (r = e.documentElement,
                    Math.max(e.body["scroll" + t], r["scroll" + t], e.body["offset" + t], r["offset" + t], r["client" + t])) : void 0 === i ? p.css(e, n, s) : p.style(e, n, i, s)
                }, e, o ? i : void 0, o, null)
            }
        })
    }),
    p.fn.extend({
        bind: function(t, e, n) {
            return this.on(t, null, e, n)
        },
        unbind: function(t, e) {
            return this.off(t, null, e)
        },
        delegate: function(t, e, n, i) {
            return this.on(e, t, n, i)
        },
        undelegate: function(t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        },
        size: function() {
            return this.length
        }
    }),
    p.fn.andSelf = p.fn.addBack,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return p
    });
    var Ne = t.jQuery
      , Ae = t.$;
    return p.noConflict = function(e) {
        return t.$ === p && (t.$ = Ae),
        e && t.jQuery === p && (t.jQuery = Ne),
        p
    }
    ,
    e || (t.jQuery = t.$ = p),
    p
}),
function(t, e, n, i) {
    function r(e, n) {
        this.settings = null,
        this.options = t.extend({}, r.Defaults, n),
        this.$element = t(e),
        this._handlers = {},
        this._plugins = {},
        this._supress = {},
        this._current = null,
        this._speed = null,
        this._coordinates = [],
        this._breakpoint = null,
        this._width = null,
        this._items = [],
        this._clones = [],
        this._mergers = [],
        this._widths = [],
        this._invalidated = {},
        this._pipe = [],
        this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: {
                start: null,
                current: null
            },
            direction: null
        },
        this._states = {
            current: {},
            tags: {
                initializing: ["busy"],
                animating: ["busy"],
                dragging: ["interacting"]
            }
        },
        t.each(["onResize", "onThrottledResize"], t.proxy(function(e, n) {
            this._handlers[n] = t.proxy(this[n], this)
        }, this)),
        t.each(r.Plugins, t.proxy(function(t, e) {
            this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this)
        }, this)),
        t.each(r.Workers, t.proxy(function(e, n) {
            this._pipe.push({
                filter: n.filter,
                run: t.proxy(n.run, this)
            })
        }, this)),
        this.setup(),
        this.initialize()
    }
    r.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: e,
        fallbackEasing: "swing",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab"
    },
    r.Width = {
        Default: "default",
        Inner: "inner",
        Outer: "outer"
    },
    r.Type = {
        Event: "event",
        State: "state"
    },
    r.Plugins = {},
    r.Workers = [{
        filter: ["width", "settings"],
        run: function() {
            this._width = this.$element.width()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            t.current = this._items && this._items[this.relative(this._current)]
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            this.$stage.children(".cloned").remove()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            var e = this.settings.margin || ""
              , n = !this.settings.autoWidth
              , i = this.settings.rtl
              , r = {
                width: "auto",
                "margin-left": i ? e : "",
                "margin-right": i ? "" : e
            };
            !n && this.$stage.children().css(r),
            t.css = r
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            var e = (this.width() / this.settings.items).toFixed(3) - this.settings.margin
              , n = null
              , i = this._items.length
              , r = !this.settings.autoWidth
              , o = [];
            for (t.items = {
                merge: !1,
                width: e
            }; i--; )
                n = this._mergers[i],
                n = this.settings.mergeFit && Math.min(n, this.settings.items) || n,
                t.items.merge = n > 1 || t.items.merge,
                o[i] = r ? e * n : this._items[i].width();
            this._widths = o
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            var e = []
              , n = this._items
              , i = this.settings
              , r = Math.max(2 * i.items, 4)
              , o = 2 * Math.ceil(n.length / 2)
              , s = i.loop && n.length ? i.rewind ? r : Math.max(r, o) : 0
              , a = ""
              , u = "";
            for (s /= 2; s--; )
                e.push(this.normalize(e.length / 2, !0)),
                a += n[e[e.length - 1]][0].outerHTML,
                e.push(this.normalize(n.length - 1 - (e.length - 1) / 2, !0)),
                u = n[e[e.length - 1]][0].outerHTML + u;
            this._clones = e,
            t(a).addClass("cloned").appendTo(this.$stage),
            t(u).addClass("cloned").prependTo(this.$stage)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            for (var t = this.settings.rtl ? 1 : -1, e = this._clones.length + this._items.length, n = -1, i = 0, r = 0, o = []; ++n < e; )
                i = o[n - 1] || 0,
                r = this._widths[this.relative(n)] + this.settings.margin,
                o.push(i + r * t);
            this._coordinates = o
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            var t = this.settings.stagePadding
              , e = this._coordinates
              , n = {
                width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                "padding-left": t || "",
                "padding-right": t || ""
            };
            this.$stage.css(n)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            var e = this._coordinates.length
              , n = !this.settings.autoWidth
              , i = this.$stage.children();
            if (n && t.items.merge)
                for (; e--; )
                    t.css.width = this._widths[this.relative(e)],
                    i.eq(e).css(t.css);
            else
                n && (t.css.width = t.items.width,
                i.css(t.css))
        }
    }, {
        filter: ["items"],
        run: function() {
            this._coordinates.length < 1 && this.$stage.removeAttr("style")
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            t.current = t.current ? this.$stage.children().index(t.current) : 0,
            t.current = Math.max(this.minimum(), Math.min(this.maximum(), t.current)),
            this.reset(t.current)
        }
    }, {
        filter: ["position"],
        run: function() {
            this.animate(this.coordinates(this._current))
        }
    }, {
        filter: ["width", "position", "items", "settings"],
        run: function() {
            var t, e, n, i, r = this.settings.rtl ? 1 : -1, o = 2 * this.settings.stagePadding, s = this.coordinates(this.current()) + o, a = s + this.width() * r, u = [];
            for (n = 0,
            i = this._coordinates.length; n < i; n++)
                t = this._coordinates[n - 1] || 0,
                e = Math.abs(this._coordinates[n]) + o * r,
                (this.op(t, "<=", s) && this.op(t, ">", a) || this.op(e, "<", s) && this.op(e, ">", a)) && u.push(n);
            this.$stage.children(".active").removeClass("active"),
            this.$stage.children(":eq(" + u.join("), :eq(") + ")").addClass("active"),
            this.settings.center && (this.$stage.children(".center").removeClass("center"),
            this.$stage.children().eq(this.current()).addClass("center"))
        }
    }],
    r.prototype.initialize = function() {
        var e, n, r;
        (this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading")) && (e = this.$element.find("img"),
        n = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : i,
        r = this.$element.children(n).width(),
        e.length && r <= 0 && this.preloadAutoWidthImages(e));
        this.$element.addClass(this.options.loadingClass),
        this.$stage = t("<" + this.settings.stageElement + ' class="' + this.settings.stageClass + '"/>').wrap('<div class="' + this.settings.stageOuterClass + '"/>'),
        this.$element.append(this.$stage.parent()),
        this.replace(this.$element.children().not(this.$stage.parent())),
        this.$element.is(":visible") ? this.refresh() : this.invalidate("width"),
        this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass),
        this.registerEventHandlers(),
        this.leave("initializing"),
        this.trigger("initialized")
    }
    ,
    r.prototype.setup = function() {
        var e = this.viewport()
          , n = this.options.responsive
          , i = -1
          , r = null;
        n ? (t.each(n, function(t) {
            t <= e && t > i && (i = Number(t))
        }),
        "function" == typeof (r = t.extend({}, this.options, n[i])).stagePadding && (r.stagePadding = r.stagePadding()),
        delete r.responsive,
        r.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s","g"), "$1" + i))) : r = t.extend({}, this.options),
        this.trigger("change", {
            property: {
                name: "settings",
                value: r
            }
        }),
        this._breakpoint = i,
        this.settings = r,
        this.invalidate("settings"),
        this.trigger("changed", {
            property: {
                name: "settings",
                value: this.settings
            }
        })
    }
    ,
    r.prototype.optionsLogic = function() {
        this.settings.autoWidth && (this.settings.stagePadding = !1,
        this.settings.merge = !1)
    }
    ,
    r.prototype.prepare = function(e) {
        var n = this.trigger("prepare", {
            content: e
        });
        return n.data || (n.data = t("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(e)),
        this.trigger("prepared", {
            content: n.data
        }),
        n.data
    }
    ,
    r.prototype.update = function() {
        for (var e = 0, n = this._pipe.length, i = t.proxy(function(t) {
            return this[t]
        }, this._invalidated), r = {}; e < n; )
            (this._invalidated.all || t.grep(this._pipe[e].filter, i).length > 0) && this._pipe[e].run(r),
            e++;
        this._invalidated = {},
        !this.is("valid") && this.enter("valid")
    }
    ,
    r.prototype.width = function(t) {
        switch (t = t || r.Width.Default) {
        case r.Width.Inner:
        case r.Width.Outer:
            return this._width;
        default:
            return this._width - 2 * this.settings.stagePadding + this.settings.margin
        }
    }
    ,
    r.prototype.refresh = function() {
        this.enter("refreshing"),
        this.trigger("refresh"),
        this.setup(),
        this.optionsLogic(),
        this.$element.addClass(this.options.refreshClass),
        this.update(),
        this.$element.removeClass(this.options.refreshClass),
        this.leave("refreshing"),
        this.trigger("refreshed")
    }
    ,
    r.prototype.onThrottledResize = function() {
        e.clearTimeout(this.resizeTimer),
        this.resizeTimer = e.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
    }
    ,
    r.prototype.onResize = function() {
        return !!this._items.length && this._width !== this.$element.width() && !!this.$element.is(":visible") && (this.enter("resizing"),
        this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"),
        !1) : (this.invalidate("width"),
        this.refresh(),
        this.leave("resizing"),
        void this.trigger("resized")))
    }
    ,
    r.prototype.registerEventHandlers = function() {
        t.support.transition && this.$stage.on(t.support.transition.end + ".owl.core", t.proxy(this.onTransitionEnd, this)),
        !1 !== this.settings.responsive && this.on(e, "resize", this._handlers.onThrottledResize),
        this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass),
        this.$stage.on("mousedown.owl.core", t.proxy(this.onDragStart, this)),
        this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
            return !1
        })),
        this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", t.proxy(this.onDragStart, this)),
        this.$stage.on("touchcancel.owl.core", t.proxy(this.onDragEnd, this)))
    }
    ,
    r.prototype.onDragStart = function(e) {
        var i = null;
        3 !== e.which && (t.support.transform ? i = {
            x: (i = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === i.length ? 12 : 4],
            y: i[16 === i.length ? 13 : 5]
        } : (i = this.$stage.position(),
        i = {
            x: this.settings.rtl ? i.left + this.$stage.width() - this.width() + this.settings.margin : i.left,
            y: i.top
        }),
        this.is("animating") && (t.support.transform ? this.animate(i.x) : this.$stage.stop(),
        this.invalidate("position")),
        this.$element.toggleClass(this.options.grabClass, "mousedown" === e.type),
        this.speed(0),
        this._drag.time = (new Date).getTime(),
        this._drag.target = t(e.target),
        this._drag.stage.start = i,
        this._drag.stage.current = i,
        this._drag.pointer = this.pointer(e),
        t(n).on("mouseup.owl.core touchend.owl.core", t.proxy(this.onDragEnd, this)),
        t(n).one("mousemove.owl.core touchmove.owl.core", t.proxy(function(e) {
            var i = this.difference(this._drag.pointer, this.pointer(e));
            t(n).on("mousemove.owl.core touchmove.owl.core", t.proxy(this.onDragMove, this)),
            Math.abs(i.x) < Math.abs(i.y) && this.is("valid") || (e.preventDefault(),
            this.enter("dragging"),
            this.trigger("drag"))
        }, this)))
    }
    ,
    r.prototype.onDragMove = function(t) {
        var e = null
          , n = null
          , i = null
          , r = this.difference(this._drag.pointer, this.pointer(t))
          , o = this.difference(this._drag.stage.start, r);
        this.is("dragging") && (t.preventDefault(),
        this.settings.loop ? (e = this.coordinates(this.minimum()),
        n = this.coordinates(this.maximum() + 1) - e,
        o.x = ((o.x - e) % n + n) % n + e) : (e = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()),
        n = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()),
        i = this.settings.pullDrag ? -1 * r.x / 5 : 0,
        o.x = Math.max(Math.min(o.x, e + i), n + i)),
        this._drag.stage.current = o,
        this.animate(o.x))
    }
    ,
    r.prototype.onDragEnd = function(e) {
        var i = this.difference(this._drag.pointer, this.pointer(e))
          , r = this._drag.stage.current
          , o = i.x > 0 ^ this.settings.rtl ? "left" : "right";
        t(n).off(".owl.core"),
        this.$element.removeClass(this.options.grabClass),
        (0 !== i.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
        this.current(this.closest(r.x, 0 !== i.x ? o : this._drag.direction)),
        this.invalidate("position"),
        this.update(),
        this._drag.direction = o,
        (Math.abs(i.x) > 3 || (new Date).getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function() {
            return !1
        })),
        this.is("dragging") && (this.leave("dragging"),
        this.trigger("dragged"))
    }
    ,
    r.prototype.closest = function(e, n) {
        var i = -1
          , r = this.width()
          , o = this.coordinates();
        return this.settings.freeDrag || t.each(o, t.proxy(function(t, s) {
            return "left" === n && e > s - 30 && e < s + 30 ? i = t : "right" === n && e > s - r - 30 && e < s - r + 30 ? i = t + 1 : this.op(e, "<", s) && this.op(e, ">", o[t + 1] || s - r) && (i = "left" === n ? t + 1 : t),
            -1 === i
        }, this)),
        this.settings.loop || (this.op(e, ">", o[this.minimum()]) ? i = e = this.minimum() : this.op(e, "<", o[this.maximum()]) && (i = e = this.maximum())),
        i
    }
    ,
    r.prototype.animate = function(e) {
        var n = this.speed() > 0;
        this.is("animating") && this.onTransitionEnd(),
        n && (this.enter("animating"),
        this.trigger("translate")),
        t.support.transform3d && t.support.transition ? this.$stage.css({
            transform: "translate3d(" + e + "px,0px,0px)",
            transition: this.speed() / 1e3 + "s"
        }) : n ? this.$stage.animate({
            left: e + "px"
        }, this.speed(), this.settings.fallbackEasing, t.proxy(this.onTransitionEnd, this)) : this.$stage.css({
            left: e + "px"
        })
    }
    ,
    r.prototype.is = function(t) {
        return this._states.current[t] && this._states.current[t] > 0
    }
    ,
    r.prototype.current = function(t) {
        if (t === i)
            return this._current;
        if (0 === this._items.length)
            return i;
        if (t = this.normalize(t),
        this._current !== t) {
            var e = this.trigger("change", {
                property: {
                    name: "position",
                    value: t
                }
            });
            e.data !== i && (t = this.normalize(e.data)),
            this._current = t,
            this.invalidate("position"),
            this.trigger("changed", {
                property: {
                    name: "position",
                    value: this._current
                }
            })
        }
        return this._current
    }
    ,
    r.prototype.invalidate = function(e) {
        return "string" === t.type(e) && (this._invalidated[e] = !0,
        this.is("valid") && this.leave("valid")),
        t.map(this._invalidated, function(t, e) {
            return e
        })
    }
    ,
    r.prototype.reset = function(t) {
        (t = this.normalize(t)) !== i && (this._speed = 0,
        this._current = t,
        this.suppress(["translate", "translated"]),
        this.animate(this.coordinates(t)),
        this.release(["translate", "translated"]))
    }
    ,
    r.prototype.normalize = function(t, e) {
        var n = this._items.length
          , r = e ? 0 : this._clones.length;
        return !this.isNumeric(t) || n < 1 ? t = i : (t < 0 || t >= n + r) && (t = ((t - r / 2) % n + n) % n + r / 2),
        t
    }
    ,
    r.prototype.relative = function(t) {
        return t -= this._clones.length / 2,
        this.normalize(t, !0)
    }
    ,
    r.prototype.maximum = function(t) {
        var e, n, i, r = this.settings, o = this._coordinates.length;
        if (r.loop)
            o = this._clones.length / 2 + this._items.length - 1;
        else if (r.autoWidth || r.merge) {
            for (e = this._items.length,
            n = this._items[--e].width(),
            i = this.$element.width(); e-- && !((n += this._items[e].width() + this.settings.margin) > i); )
                ;
            o = e + 1
        } else
            o = r.center ? this._items.length - 1 : this._items.length - r.items;
        return t && (o -= this._clones.length / 2),
        Math.max(o, 0)
    }
    ,
    r.prototype.minimum = function(t) {
        return t ? 0 : this._clones.length / 2
    }
    ,
    r.prototype.items = function(t) {
        return t === i ? this._items.slice() : (t = this.normalize(t, !0),
        this._items[t])
    }
    ,
    r.prototype.mergers = function(t) {
        return t === i ? this._mergers.slice() : (t = this.normalize(t, !0),
        this._mergers[t])
    }
    ,
    r.prototype.clones = function(e) {
        var n = this._clones.length / 2
          , r = n + this._items.length
          , o = function(t) {
            return t % 2 == 0 ? r + t / 2 : n - (t + 1) / 2
        };
        return e === i ? t.map(this._clones, function(t, e) {
            return o(e)
        }) : t.map(this._clones, function(t, n) {
            return t === e ? o(n) : null
        })
    }
    ,
    r.prototype.speed = function(t) {
        return t !== i && (this._speed = t),
        this._speed
    }
    ,
    r.prototype.coordinates = function(e) {
        var n, r = 1, o = e - 1;
        return e === i ? t.map(this._coordinates, t.proxy(function(t, e) {
            return this.coordinates(e)
        }, this)) : (this.settings.center ? (this.settings.rtl && (r = -1,
        o = e + 1),
        n = this._coordinates[e],
        n += (this.width() - n + (this._coordinates[o] || 0)) / 2 * r) : n = this._coordinates[o] || 0,
        n = Math.ceil(n))
    }
    ,
    r.prototype.duration = function(t, e, n) {
        return 0 === n ? 0 : Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(n || this.settings.smartSpeed)
    }
    ,
    r.prototype.to = function(t, e) {
        var n = this.current()
          , i = null
          , r = t - this.relative(n)
          , o = (r > 0) - (r < 0)
          , s = this._items.length
          , a = this.minimum()
          , u = this.maximum();
        this.settings.loop ? (!this.settings.rewind && Math.abs(r) > s / 2 && (r += -1 * o * s),
        (i = (((t = n + r) - a) % s + s) % s + a) !== t && i - r <= u && i - r > 0 && (n = i - r,
        t = i,
        this.reset(n))) : this.settings.rewind ? t = (t % (u += 1) + u) % u : t = Math.max(a, Math.min(u, t)),
        this.speed(this.duration(n, t, e)),
        this.current(t),
        this.$element.is(":visible") && this.update()
    }
    ,
    r.prototype.next = function(t) {
        t = t || !1,
        this.to(this.relative(this.current()) + 1, t)
    }
    ,
    r.prototype.prev = function(t) {
        t = t || !1,
        this.to(this.relative(this.current()) - 1, t)
    }
    ,
    r.prototype.onTransitionEnd = function(t) {
        if (t !== i && (t.stopPropagation(),
        (t.target || t.srcElement || t.originalTarget) !== this.$stage.get(0)))
            return !1;
        this.leave("animating"),
        this.trigger("translated")
    }
    ,
    r.prototype.viewport = function() {
        var i;
        return this.options.responsiveBaseElement !== e ? i = t(this.options.responsiveBaseElement).width() : e.innerWidth ? i = e.innerWidth : n.documentElement && n.documentElement.clientWidth ? i = n.documentElement.clientWidth : console.warn("Can not detect viewport width."),
        i
    }
    ,
    r.prototype.replace = function(e) {
        this.$stage.empty(),
        this._items = [],
        e && (e = e instanceof jQuery ? e : t(e)),
        this.settings.nestedItemSelector && (e = e.find("." + this.settings.nestedItemSelector)),
        e.filter(function() {
            return 1 === this.nodeType
        }).each(t.proxy(function(t, e) {
            e = this.prepare(e),
            this.$stage.append(e),
            this._items.push(e),
            this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
        }, this)),
        this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
        this.invalidate("items")
    }
    ,
    r.prototype.add = function(e, n) {
        var r = this.relative(this._current);
        n = n === i ? this._items.length : this.normalize(n, !0),
        e = e instanceof jQuery ? e : t(e),
        this.trigger("add", {
            content: e,
            position: n
        }),
        e = this.prepare(e),
        0 === this._items.length || n === this._items.length ? (0 === this._items.length && this.$stage.append(e),
        0 !== this._items.length && this._items[n - 1].after(e),
        this._items.push(e),
        this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[n].before(e),
        this._items.splice(n, 0, e),
        this._mergers.splice(n, 0, 1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)),
        this._items[r] && this.reset(this._items[r].index()),
        this.invalidate("items"),
        this.trigger("added", {
            content: e,
            position: n
        })
    }
    ,
    r.prototype.remove = function(t) {
        (t = this.normalize(t, !0)) !== i && (this.trigger("remove", {
            content: this._items[t],
            position: t
        }),
        this._items[t].remove(),
        this._items.splice(t, 1),
        this._mergers.splice(t, 1),
        this.invalidate("items"),
        this.trigger("removed", {
            content: null,
            position: t
        }))
    }
    ,
    r.prototype.preloadAutoWidthImages = function(e) {
        e.each(t.proxy(function(e, n) {
            this.enter("pre-loading"),
            n = t(n),
            t(new Image).one("load", t.proxy(function(t) {
                n.attr("src", t.target.src),
                n.css("opacity", 1),
                this.leave("pre-loading"),
                !this.is("pre-loading") && !this.is("initializing") && this.refresh()
            }, this)).attr("src", n.attr("src") || n.attr("data-src") || n.attr("data-src-retina"))
        }, this))
    }
    ,
    r.prototype.destroy = function() {
        for (var i in this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        t(n).off(".owl.core"),
        !1 !== this.settings.responsive && (e.clearTimeout(this.resizeTimer),
        this.off(e, "resize", this._handlers.onThrottledResize)),
        this._plugins)
            this._plugins[i].destroy();
        this.$stage.children(".cloned").remove(),
        this.$stage.unwrap(),
        this.$stage.children().contents().unwrap(),
        this.$stage.children().unwrap(),
        this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s","g"), "")).removeData("owl.carousel")
    }
    ,
    r.prototype.op = function(t, e, n) {
        var i = this.settings.rtl;
        switch (e) {
        case "<":
            return i ? t > n : t < n;
        case ">":
            return i ? t < n : t > n;
        case ">=":
            return i ? t <= n : t >= n;
        case "<=":
            return i ? t >= n : t <= n
        }
    }
    ,
    r.prototype.on = function(t, e, n, i) {
        t.addEventListener ? t.addEventListener(e, n, i) : t.attachEvent && t.attachEvent("on" + e, n)
    }
    ,
    r.prototype.off = function(t, e, n, i) {
        t.removeEventListener ? t.removeEventListener(e, n, i) : t.detachEvent && t.detachEvent("on" + e, n)
    }
    ,
    r.prototype.trigger = function(e, n, i, o, s) {
        var a = {
            item: {
                count: this._items.length,
                index: this.current()
            }
        }
          , u = t.camelCase(t.grep(["on", e, i], function(t) {
            return t
        }).join("-").toLowerCase())
          , l = t.Event([e, "owl", i || "carousel"].join(".").toLowerCase(), t.extend({
            relatedTarget: this
        }, a, n));
        return this._supress[e] || (t.each(this._plugins, function(t, e) {
            e.onTrigger && e.onTrigger(l)
        }),
        this.register({
            type: r.Type.Event,
            name: e
        }),
        this.$element.trigger(l),
        this.settings && "function" == typeof this.settings[u] && this.settings[u].call(this, l)),
        l
    }
    ,
    r.prototype.enter = function(e) {
        t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
            this._states.current[e] === i && (this._states.current[e] = 0),
            this._states.current[e]++
        }, this))
    }
    ,
    r.prototype.leave = function(e) {
        t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
            this._states.current[e]--
        }, this))
    }
    ,
    r.prototype.register = function(e) {
        if (e.type === r.Type.Event) {
            if (t.event.special[e.name] || (t.event.special[e.name] = {}),
            !t.event.special[e.name].owl) {
                var n = t.event.special[e.name]._default;
                t.event.special[e.name]._default = function(t) {
                    return !n || !n.apply || t.namespace && -1 !== t.namespace.indexOf("owl") ? t.namespace && t.namespace.indexOf("owl") > -1 : n.apply(this, arguments)
                }
                ,
                t.event.special[e.name].owl = !0
            }
        } else
            e.type === r.Type.State && (this._states.tags[e.name] ? this._states.tags[e.name] = this._states.tags[e.name].concat(e.tags) : this._states.tags[e.name] = e.tags,
            this._states.tags[e.name] = t.grep(this._states.tags[e.name], t.proxy(function(n, i) {
                return t.inArray(n, this._states.tags[e.name]) === i
            }, this)))
    }
    ,
    r.prototype.suppress = function(e) {
        t.each(e, t.proxy(function(t, e) {
            this._supress[e] = !0
        }, this))
    }
    ,
    r.prototype.release = function(e) {
        t.each(e, t.proxy(function(t, e) {
            delete this._supress[e]
        }, this))
    }
    ,
    r.prototype.pointer = function(t) {
        var n = {
            x: null,
            y: null
        };
        return (t = (t = t.originalEvent || t || e.event).touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t).pageX ? (n.x = t.pageX,
        n.y = t.pageY) : (n.x = t.clientX,
        n.y = t.clientY),
        n
    }
    ,
    r.prototype.isNumeric = function(t) {
        return !isNaN(parseFloat(t))
    }
    ,
    r.prototype.difference = function(t, e) {
        return {
            x: t.x - e.x,
            y: t.y - e.y
        }
    }
    ,
    t.fn.gFOwlCarousel = function(e) {
        var n = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var i = t(this)
              , o = i.data("owl.carousel");
            o || (o = new r(this,"object" == typeof e && e),
            i.data("owl.carousel", o),
            t.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(e, n) {
                o.register({
                    type: r.Type.Event,
                    name: n
                }),
                o.$element.on(n + ".owl.carousel.core", t.proxy(function(t) {
                    t.namespace && t.relatedTarget !== this && (this.suppress([n]),
                    o[n].apply(this, [].slice.call(arguments, 1)),
                    this.release([n]))
                }, o))
            })),
            "string" == typeof e && "_" !== e.charAt(0) && o[e].apply(o, n)
        })
    }
    ,
    t.fn.gFOwlCarousel.Constructor = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var r = function(e) {
        this._core = e,
        this._interval = null,
        this._visible = null,
        this._handlers = {
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoRefresh && this.watch()
            }, this)
        },
        this._core.options = t.extend({}, r.Defaults, this._core.options),
        this._core.$element.on(this._handlers)
    };
    r.Defaults = {
        autoRefresh: !0,
        autoRefreshInterval: 500
    },
    r.prototype.watch = function() {
        this._interval || (this._visible = this._core.$element.is(":visible"),
        this._interval = e.setInterval(t.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
    }
    ,
    r.prototype.refresh = function() {
        this._core.$element.is(":visible") !== this._visible && (this._visible = !this._visible,
        this._core.$element.toggleClass("owl-hidden", !this._visible),
        this._visible && this._core.invalidate("width") && this._core.refresh())
    }
    ,
    r.prototype.destroy = function() {
        var t, n;
        for (t in e.clearInterval(this._interval),
        this._handlers)
            this._core.$element.off(t, this._handlers[t]);
        for (n in Object.getOwnPropertyNames(this))
            "function" != typeof this[n] && (this[n] = null)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.AutoRefresh = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var r = function(e) {
        this._core = e,
        this._loaded = [],
        this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel": t.proxy(function(e) {
                if (e.namespace && this._core.settings && this._core.settings.lazyLoad && (e.property && "position" == e.property.name || "initialized" == e.type))
                    for (var n = this._core.settings, i = n.center && Math.ceil(n.items / 2) || n.items, r = n.center && -1 * i || 0, o = (e.property && void 0 !== e.property.value ? e.property.value : this._core.current()) + r, s = this._core.clones().length, a = t.proxy(function(t, e) {
                        this.load(e)
                    }, this); r++ < i; )
                        this.load(s / 2 + this._core.relative(o)),
                        s && t.each(this._core.clones(this._core.relative(o)), a),
                        o++
            }, this)
        },
        this._core.options = t.extend({}, r.Defaults, this._core.options),
        this._core.$element.on(this._handlers)
    };
    r.Defaults = {
        lazyLoad: !1
    },
    r.prototype.load = function(n) {
        var i = this._core.$stage.children().eq(n)
          , r = i && i.find(".owl-lazy");
        !r || t.inArray(i.get(0), this._loaded) > -1 || (r.each(t.proxy(function(n, i) {
            var r, o = t(i), s = e.devicePixelRatio > 1 && o.attr("data-src-retina") || o.attr("data-src");
            this._core.trigger("load", {
                element: o,
                url: s
            }, "lazy"),
            o.is("img") ? o.one("load.owl.lazy", t.proxy(function() {
                o.css("opacity", 1),
                this._core.trigger("loaded", {
                    element: o,
                    url: s
                }, "lazy")
            }, this)).attr("src", s) : ((r = new Image).onload = t.proxy(function() {
                o.css({
                    "background-image": 'url("' + s + '")',
                    opacity: "1"
                }),
                this._core.trigger("loaded", {
                    element: o,
                    url: s
                }, "lazy")
            }, this),
            r.src = s)
        }, this)),
        this._loaded.push(i.get(0)))
    }
    ,
    r.prototype.destroy = function() {
        var t, e;
        for (t in this.handlers)
            this._core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
            "function" != typeof this[e] && (this[e] = null)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.Lazy = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var r = function(e) {
        this._core = e,
        this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoHeight && this.update()
            }, this),
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoHeight && "position" == t.property.name && this.update()
            }, this),
            "loaded.owl.lazy": t.proxy(function(t) {
                t.namespace && this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
            }, this)
        },
        this._core.options = t.extend({}, r.Defaults, this._core.options),
        this._core.$element.on(this._handlers)
    };
    r.Defaults = {
        autoHeight: !1,
        autoHeightClass: "owl-height"
    },
    r.prototype.update = function() {
        var e, n = this._core._current, i = n + this._core.settings.items, r = this._core.$stage.children().toArray().slice(n, i), o = [];
        t.each(r, function(e, n) {
            o.push(t(n).height())
        }),
        e = Math.max.apply(null, o),
        this._core.$stage.parent().height(e).addClass(this._core.settings.autoHeightClass)
    }
    ,
    r.prototype.destroy = function() {
        var t, e;
        for (t in this._handlers)
            this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
            "function" != typeof this[e] && (this[e] = null)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.AutoHeight = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var r = function(e) {
        this._core = e,
        this._videos = {},
        this._playing = null,
        this._handlers = {
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.register({
                    type: "state",
                    name: "playing",
                    tags: ["interacting"]
                })
            }, this),
            "resize.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.video && this.isInFullScreen() && t.preventDefault()
            }, this),
            "refreshed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
            }, this),
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && "position" === t.property.name && this._playing && this.stop()
            }, this),
            "prepared.owl.carousel": t.proxy(function(e) {
                if (e.namespace) {
                    var n = t(e.content).find(".owl-video");
                    n.length && (n.css("display", "none"),
                    this.fetch(n, t(e.content)))
                }
            }, this)
        },
        this._core.options = t.extend({}, r.Defaults, this._core.options),
        this._core.$element.on(this._handlers),
        this._core.$element.on("click.owl.video", ".owl-video-play-icon", t.proxy(function(t) {
            this.play(t)
        }, this))
    };
    r.Defaults = {
        video: !1,
        videoHeight: !1,
        videoWidth: !1
    },
    r.prototype.fetch = function(t, e) {
        var n = t.attr("data-vimeo-id") ? "vimeo" : t.attr("data-vzaar-id") ? "vzaar" : "youtube"
          , i = t.attr("data-vimeo-id") || t.attr("data-youtube-id") || t.attr("data-vzaar-id")
          , r = t.attr("data-width") || this._core.settings.videoWidth
          , o = t.attr("data-height") || this._core.settings.videoHeight
          , s = t.attr("href");
        if (!s)
            throw new Error("Missing video URL.");
        if ((i = s.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu") > -1)
            n = "youtube";
        else if (i[3].indexOf("vimeo") > -1)
            n = "vimeo";
        else {
            if (!(i[3].indexOf("vzaar") > -1))
                throw new Error("Video URL not supported.");
            n = "vzaar"
        }
        i = i[6],
        this._videos[s] = {
            type: n,
            id: i,
            width: r,
            height: o
        },
        e.attr("data-video", s),
        this.thumbnail(t, this._videos[s])
    }
    ,
    r.prototype.thumbnail = function(e, n) {
        var i, r, o = n.width && n.height ? 'style="width:' + n.width + "px;height:" + n.height + 'px;"' : "", s = e.find("img"), a = "src", u = "", l = this._core.settings, c = function(t) {
            '<div class="owl-video-play-icon"></div>',
            i = l.lazyLoad ? '<div class="owl-video-tn ' + u + '" ' + a + '="' + t + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + t + ')"></div>',
            e.after(i),
            e.after('<div class="owl-video-play-icon"></div>')
        };
        if (e.wrap('<div class="owl-video-wrapper"' + o + "></div>"),
        this._core.settings.lazyLoad && (a = "data-src",
        u = "owl-lazy"),
        s.length)
            return c(s.attr(a)),
            s.remove(),
            !1;
        "youtube" === n.type ? (r = "//img.youtube.com/vi/" + n.id + "/hqdefault.jpg",
        c(r)) : "vimeo" === n.type ? t.ajax({
            type: "GET",
            url: "//vimeo.com/api/v2/video/" + n.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(t) {
                r = t[0].thumbnail_large,
                c(r)
            }
        }) : "vzaar" === n.type && t.ajax({
            type: "GET",
            url: "//vzaar.com/api/videos/" + n.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(t) {
                r = t.framegrab_url,
                c(r)
            }
        })
    }
    ,
    r.prototype.stop = function() {
        this._core.trigger("stop", null, "video"),
        this._playing.find(".owl-video-frame").remove(),
        this._playing.removeClass("owl-video-playing"),
        this._playing = null,
        this._core.leave("playing"),
        this._core.trigger("stopped", null, "video")
    }
    ,
    r.prototype.play = function(e) {
        var n, i = t(e.target).closest("." + this._core.settings.itemClass), r = this._videos[i.attr("data-video")], o = r.width || "100%", s = r.height || this._core.$stage.height();
        this._playing || (this._core.enter("playing"),
        this._core.trigger("play", null, "video"),
        i = this._core.items(this._core.relative(i.index())),
        this._core.reset(i.index()),
        "youtube" === r.type ? n = '<iframe width="' + o + '" height="' + s + '" src="//www.youtube.com/embed/' + r.id + "?autoplay=1&rel=0&v=" + r.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === r.type ? n = '<iframe src="//player.vimeo.com/video/' + r.id + '?autoplay=1" width="' + o + '" height="' + s + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : "vzaar" === r.type && (n = '<iframe frameborder="0"height="' + s + '"width="' + o + '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' + r.id + '/player?autoplay=true"></iframe>'),
        t('<div class="owl-video-frame">' + n + "</div>").insertAfter(i.find(".owl-video")),
        this._playing = i.addClass("owl-video-playing"))
    }
    ,
    r.prototype.isInFullScreen = function() {
        var e = n.fullscreenElement || n.mozFullScreenElement || n.webkitFullscreenElement;
        return e && t(e).parent().hasClass("owl-video-frame")
    }
    ,
    r.prototype.destroy = function() {
        var t, e;
        for (t in this._core.$element.off("click.owl.video"),
        this._handlers)
            this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
            "function" != typeof this[e] && (this[e] = null)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.Video = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var r = function(e) {
        this.core = e,
        this.core.options = t.extend({}, r.Defaults, this.core.options),
        this.swapping = !0,
        this.previous = i,
        this.next = i,
        this.handlers = {
            "change.owl.carousel": t.proxy(function(t) {
                t.namespace && "position" == t.property.name && (this.previous = this.core.current(),
                this.next = t.property.value)
            }, this),
            "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": t.proxy(function(t) {
                t.namespace && (this.swapping = "translated" == t.type)
            }, this),
            "translate.owl.carousel": t.proxy(function(t) {
                t.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
            }, this)
        },
        this.core.$element.on(this.handlers)
    };
    r.Defaults = {
        animateOut: !1,
        animateIn: !1
    },
    r.prototype.swap = function() {
        if (1 === this.core.settings.items && t.support.animation && t.support.transition) {
            this.core.speed(0);
            var e, n = t.proxy(this.clear, this), i = this.core.$stage.children().eq(this.previous), r = this.core.$stage.children().eq(this.next), o = this.core.settings.animateIn, s = this.core.settings.animateOut;
            this.core.current() !== this.previous && (s && (e = this.core.coordinates(this.previous) - this.core.coordinates(this.next),
            i.one(t.support.animation.end, n).css({
                left: e + "px"
            }).addClass("animated owl-animated-out").addClass(s)),
            o && r.one(t.support.animation.end, n).addClass("animated owl-animated-in").addClass(o))
        }
    }
    ,
    r.prototype.clear = function(e) {
        t(e.target).css({
            left: ""
        }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),
        this.core.onTransitionEnd()
    }
    ,
    r.prototype.destroy = function() {
        var t, e;
        for (t in this.handlers)
            this.core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
            "function" != typeof this[e] && (this[e] = null)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.Animate = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var r = function(e) {
        this._core = e,
        this._timeout = null,
        this._paused = !1,
        this._handlers = {
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && "settings" === t.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : t.namespace && "position" === t.property.name && this._core.settings.autoplay && this._setAutoPlayInterval()
            }, this),
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoplay && this.play()
            }, this),
            "play.owl.autoplay": t.proxy(function(t, e, n) {
                t.namespace && this.play(e, n)
            }, this),
            "stop.owl.autoplay": t.proxy(function(t) {
                t.namespace && this.stop()
            }, this),
            "mouseover.owl.autoplay": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "mouseleave.owl.autoplay": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
            }, this),
            "touchstart.owl.core": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "touchend.owl.core": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this.play()
            }, this)
        },
        this._core.$element.on(this._handlers),
        this._core.options = t.extend({}, r.Defaults, this._core.options)
    };
    r.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    },
    r.prototype.play = function(t, e) {
        this._paused = !1,
        this._core.is("rotating") || (this._core.enter("rotating"),
        this._setAutoPlayInterval())
    }
    ,
    r.prototype._getNextTimeout = function(i, r) {
        return this._timeout && e.clearTimeout(this._timeout),
        e.setTimeout(t.proxy(function() {
            this._paused || this._core.is("busy") || this._core.is("interacting") || n.hidden || this._core.next(r || this._core.settings.autoplaySpeed)
        }, this), i || this._core.settings.autoplayTimeout)
    }
    ,
    r.prototype._setAutoPlayInterval = function() {
        this._timeout = this._getNextTimeout()
    }
    ,
    r.prototype.stop = function() {
        this._core.is("rotating") && (e.clearTimeout(this._timeout),
        this._core.leave("rotating"))
    }
    ,
    r.prototype.pause = function() {
        this._core.is("rotating") && (this._paused = !0)
    }
    ,
    r.prototype.destroy = function() {
        var t, e;
        for (t in this.stop(),
        this._handlers)
            this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
            "function" != typeof this[e] && (this[e] = null)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.autoplay = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    "use strict";
    var r = function(e) {
        this._core = e,
        this._initialized = !1,
        this._pages = [],
        this._controls = {},
        this._templates = [],
        this.$element = this._core.$element,
        this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to
        },
        this._handlers = {
            "prepared.owl.carousel": t.proxy(function(e) {
                e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + t(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
            }, this),
            "added.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 0, this._templates.pop())
            }, this),
            "remove.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 1)
            }, this),
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && "position" == t.property.name && this.draw()
            }, this),
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"),
                this.initialize(),
                this.update(),
                this.draw(),
                this._initialized = !0,
                this._core.trigger("initialized", null, "navigation"))
            }, this),
            "refreshed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"),
                this.update(),
                this.draw(),
                this._core.trigger("refreshed", null, "navigation"))
            }, this)
        },
        this._core.options = t.extend({}, r.Defaults, this._core.options),
        this.$element.on(this._handlers)
    };
    r.Defaults = {
        nav: !1,
        navText: ["prev", "next"],
        navSpeed: !1,
        navElement: "div",
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: ["owl-prev", "owl-next"],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1
    },
    r.prototype.initialize = function() {
        var e, n = this._core.settings;
        for (e in this._controls.$relative = (n.navContainer ? t(n.navContainer) : t("<div>").addClass(n.navContainerClass).appendTo(this.$element)).addClass("disabled"),
        this._controls.$previous = t("<" + n.navElement + ">").addClass(n.navClass[0]).html(n.navText[0]).prependTo(this._controls.$relative).on("click", t.proxy(function(t) {
            this.prev(n.navSpeed)
        }, this)),
        this._controls.$next = t("<" + n.navElement + ">").addClass(n.navClass[1]).html(n.navText[1]).appendTo(this._controls.$relative).on("click", t.proxy(function(t) {
            this.next(n.navSpeed)
        }, this)),
        n.dotsData || (this._templates = [t("<div>").addClass(n.dotClass).append(t("<span>")).prop("outerHTML")]),
        this._controls.$absolute = (n.dotsContainer ? t(n.dotsContainer) : t("<div>").addClass(n.dotsClass).appendTo(this.$element)).addClass("disabled"),
        this._controls.$absolute.on("click", "div", t.proxy(function(e) {
            var i = t(e.target).parent().is(this._controls.$absolute) ? t(e.target).index() : t(e.target).parent().index();
            e.preventDefault(),
            this.to(i, n.dotsSpeed)
        }, this)),
        this._overrides)
            this._core[e] = t.proxy(this[e], this)
    }
    ,
    r.prototype.destroy = function() {
        var t, e, n, i;
        for (t in this._handlers)
            this.$element.off(t, this._handlers[t]);
        for (e in this._controls)
            this._controls[e].remove();
        for (i in this.overides)
            this._core[i] = this._overrides[i];
        for (n in Object.getOwnPropertyNames(this))
            "function" != typeof this[n] && (this[n] = null)
    }
    ,
    r.prototype.update = function() {
        var t, e, n = this._core.clones().length / 2, i = n + this._core.items().length, r = this._core.maximum(!0), o = this._core.settings, s = o.center || o.autoWidth || o.dotsData ? 1 : o.dotsEach || o.items;
        if ("page" !== o.slideBy && (o.slideBy = Math.min(o.slideBy, o.items)),
        o.dots || "page" == o.slideBy)
            for (this._pages = [],
            t = n,
            e = 0,
            0; t < i; t++) {
                if (e >= s || 0 === e) {
                    if (this._pages.push({
                        start: Math.min(r, t - n),
                        end: t - n + s - 1
                    }),
                    Math.min(r, t - n) === r)
                        break;
                    e = 0,
                    0
                }
                e += this._core.mergers(this._core.relative(t))
            }
    }
    ,
    r.prototype.draw = function() {
        var e, n = this._core.settings, i = this._core.items().length <= n.items, r = this._core.relative(this._core.current()), o = n.loop || n.rewind;
        this._controls.$relative.toggleClass("disabled", !n.nav || i),
        n.nav && (this._controls.$previous.toggleClass("disabled", !o && r <= this._core.minimum(!0)),
        this._controls.$next.toggleClass("disabled", !o && r >= this._core.maximum(!0))),
        this._controls.$absolute.toggleClass("disabled", !n.dots || i),
        n.dots && (e = this._pages.length - this._controls.$absolute.children().length,
        n.dotsData && 0 !== e ? this._controls.$absolute.html(this._templates.join("")) : e > 0 ? this._controls.$absolute.append(new Array(e + 1).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(),
        this._controls.$absolute.find(".active").removeClass("active"),
        this._controls.$absolute.children().eq(t.inArray(this.current(), this._pages)).addClass("active"))
    }
    ,
    r.prototype.onTrigger = function(e) {
        var n = this._core.settings;
        e.page = {
            index: t.inArray(this.current(), this._pages),
            count: this._pages.length,
            size: n && (n.center || n.autoWidth || n.dotsData ? 1 : n.dotsEach || n.items)
        }
    }
    ,
    r.prototype.current = function() {
        var e = this._core.relative(this._core.current());
        return t.grep(this._pages, t.proxy(function(t, n) {
            return t.start <= e && t.end >= e
        }, this)).pop()
    }
    ,
    r.prototype.getPosition = function(e) {
        var n, i, r = this._core.settings;
        return "page" == r.slideBy ? (n = t.inArray(this.current(), this._pages),
        i = this._pages.length,
        e ? ++n : --n,
        n = this._pages[(n % i + i) % i].start) : (n = this._core.relative(this._core.current()),
        i = this._core.items().length,
        e ? n += r.slideBy : n -= r.slideBy),
        n
    }
    ,
    r.prototype.next = function(e) {
        t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e)
    }
    ,
    r.prototype.prev = function(e) {
        t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e)
    }
    ,
    r.prototype.to = function(e, n, i) {
        var r;
        !i && this._pages.length ? (r = this._pages.length,
        t.proxy(this._overrides.to, this._core)(this._pages[(e % r + r) % r].start, n)) : t.proxy(this._overrides.to, this._core)(e, n)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.Navigation = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    "use strict";
    var r = function(n) {
        this._core = n,
        this._hashes = {},
        this.$element = this._core.$element,
        this._handlers = {
            "initialized.owl.carousel": t.proxy(function(n) {
                n.namespace && "URLHash" === this._core.settings.startPosition && t(e).trigger("hashchange.owl.navigation")
            }, this),
            "prepared.owl.carousel": t.proxy(function(e) {
                if (e.namespace) {
                    var n = t(e.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                    if (!n)
                        return;
                    this._hashes[n] = e.content
                }
            }, this),
            "changed.owl.carousel": t.proxy(function(n) {
                if (n.namespace && "position" === n.property.name) {
                    var i = this._core.items(this._core.relative(this._core.current()))
                      , r = t.map(this._hashes, function(t, e) {
                        return t === i ? e : null
                    }).join();
                    if (!r || e.location.hash.slice(1) === r)
                        return;
                    e.location.hash = r
                }
            }, this)
        },
        this._core.options = t.extend({}, r.Defaults, this._core.options),
        this.$element.on(this._handlers),
        t(e).on("hashchange.owl.navigation", t.proxy(function(t) {
            var n = e.location.hash.substring(1)
              , i = this._core.$stage.children()
              , r = this._hashes[n] && i.index(this._hashes[n]);
            void 0 !== r && r !== this._core.current() && this._core.to(this._core.relative(r), !1, !0)
        }, this))
    };
    r.Defaults = {
        URLhashListener: !1
    },
    r.prototype.destroy = function() {
        var n, i;
        for (n in t(e).off("hashchange.owl.navigation"),
        this._handlers)
            this._core.$element.off(n, this._handlers[n]);
        for (i in Object.getOwnPropertyNames(this))
            "function" != typeof this[i] && (this[i] = null)
    }
    ,
    t.fn.gFOwlCarousel.Constructor.Plugins.Hash = r
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    function r(e, n) {
        var r = !1
          , o = e.charAt(0).toUpperCase() + e.slice(1);
        return t.each((e + " " + a.join(o + " ") + o).split(" "), function(t, e) {
            if (s[e] !== i)
                return r = !n || e,
                !1
        }),
        r
    }
    function o(t) {
        return r(t, !0)
    }
    var s = t("<support>").get(0).style
      , a = "Webkit Moz O ms".split(" ")
      , u = {
        transition: {
            end: {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd",
                transition: "transitionend"
            }
        },
        animation: {
            end: {
                WebkitAnimation: "webkitAnimationEnd",
                MozAnimation: "animationend",
                OAnimation: "oAnimationEnd",
                animation: "animationend"
            }
        }
    }
      , l = function() {
        return !!r("transform")
    }
      , c = function() {
        return !!r("perspective")
    }
      , d = function() {
        return !!r("animation")
    };
    (function() {
        return !!r("transition")
    }
    )() && (t.support.transition = new String(o("transition")),
    t.support.transition.end = u.transition.end[t.support.transition]),
    d() && (t.support.animation = new String(o("animation")),
    t.support.animation.end = u.animation.end[t.support.animation]),
    l() && (t.support.transform = new String(o("transform")),
    t.support.transform3d = c())
}(window.Zepto || window.jQuery, window, document);
var GurLiquid = {
    author: "Matt McCray <darthapo@gmail.com>",
    version: "1.3.2",
    readTemplateFile: function(t) {
        throw "This GurLiquid context does not allow includes."
    },
    registerFilters: function(t) {
        GurLiquid.Template.registerFilter(t)
    },
    parse: function(t) {
        return GurLiquid.Template.parse(t)
    },
    extensions: {}
};
GurLiquid.extensions.object = {},
GurLiquid.extensions.object.update = function(t) {
    for (var e in t)
        this[e] = t[e];
    return this
}
,
GurLiquid.extensions.object.hasKey = function(t) {
    return !!this[t]
}
,
GurLiquid.extensions.object.hasValue = function(t) {
    for (var e in this)
        if (this[e] == t)
            return !0;
    return !1
}
,
GurLiquid.extensions.object.isEmpty = function(t) {
    if (!t || "" === GurLiquid.extensions.stringTools.strip(t.toString()))
        return !0;
    if (t.length && t.length > 0)
        return !1;
    if ("number" == typeof t)
        return !1;
    for (var e in t)
        if (t[e])
            return !1;
    return !0
}
,
GurLiquid.extensions.stringTools = {},
GurLiquid.extensions.stringTools.capitalize = function(t) {
    return t.charAt(0).toUpperCase() + t.substring(1).toLowerCase()
}
,
GurLiquid.extensions.stringTools.strip = function(t) {
    return t.replace(/^\s+/, "").replace(/\s+$/, "")
}
,
GurLiquid.extensions.arrayTools = {},
GurLiquid.extensions.arrayTools.last = function(t) {
    return t[t.length - 1]
}
,
GurLiquid.extensions.arrayTools.indexOf = function(t, e) {
    for (var n = 0; n < t.length; n++)
        if (t[n] == e)
            return n;
    return -1
}
,
GurLiquid.extensions.arrayTools.map = function(t, e) {
    var n = t.length;
    if ("function" != typeof e)
        throw "GurLiquid.extensions.arrayTools.map requires first argument to be a function";
    for (var i = new Array(n), r = arguments[2], o = 0; o < n; o++)
        o in t && (i[o] = e.call(r, t[o], o, t));
    return i
}
,
GurLiquid.extensions.arrayTools.flatten = function(t) {
    for (var e = t.length, n = [], i = 0; i < e; i++)
        t[i]instanceof Array ? n = n.concat(t[i]) : n.push(t[i]);
    return n
}
,
GurLiquid.extensions.arrayTools.each = function(t, e) {
    var n = t.length;
    if ("function" != typeof e)
        throw "GurLiquid.extensions.arrayTools.each requires first argument to be a function";
    for (var i = arguments[2], r = 0; r < n; r++)
        r in t && e.call(i, t[r], r, t);
    return null
}
,
GurLiquid.extensions.arrayTools.include = function(t, e) {
    return t.length,
    GurLiquid.extensions.arrayTools.indexOf(t, e) >= 0
}
,
function() {
    var t = !1
      , e = /xyz/.test(function() {
        xyz
    }) ? /\b_super\b/ : /.*/;
    this.Class = function() {}
    ,
    this.Class.extend = function(n) {
        var i = this.prototype;
        t = !0;
        var r = new this;
        for (var o in t = !1,
        n)
            r[o] = "function" == typeof n[o] && "function" == typeof i[o] && e.test(n[o]) ? function(t, e) {
                return function() {
                    var n = this._super;
                    this._super = i[t];
                    var r = e.apply(this, arguments);
                    return this._super = n,
                    r
                }
            }(o, n[o]) : n[o];
        function s() {
            !t && this.init && this.init.apply(this, arguments)
        }
        return s.prototype = r,
        s.prototype.constructor = s,
        s.extend = arguments.callee,
        s
    }
}
.call(GurLiquid),
GurLiquid.Tag = GurLiquid.Class.extend({
    init: function(t, e, n) {
        this.tagName = t,
        this.markup = e,
        this.nodelist = this.nodelist || [],
        this.parse(n)
    },
    parse: function(t) {},
    render: function(t) {
        return ""
    }
}),
GurLiquid.Block = GurLiquid.Tag.extend({
    init: function(t, e, n) {
        this.blockName = t,
        this.blockDelimiter = "end" + this.blockName,
        this._super(t, e, n)
    },
    parse: function(t) {
        this.nodelist || (this.nodelist = []),
        this.nodelist.length = 0;
        var e = t.shift();
        for (t.push(""); t.length; ) {
            if (/^\{\%/.test(e)) {
                var n = e.match(/^\{\%\s*(\w+)\s*(.*)?\%\}$/);
                if (!n)
                    throw "Tag '" + e + "' was not properly terminated with: %}";
                if (this.blockDelimiter == n[1])
                    return void this.endTag();
                n[1]in GurLiquid.Template.tags ? this.nodelist.push(new GurLiquid.Template.tags[n[1]](n[1],n[2],t)) : this.unknownTag(n[1], n[2], t)
            } else
                /^\{\{/.test(e) ? this.nodelist.push(this.createVariable(e)) : this.nodelist.push(e);
            e = t.shift()
        }
        this.assertMissingDelimitation()
    },
    endTag: function() {},
    unknownTag: function(t, e, n) {
        switch (t) {
        case "else":
            throw this.blockName + " tag does not expect else tag";
        case "end":
            throw "'end' is not a valid delimiter for " + this.blockName + " tags. use " + this.blockDelimiter;
        default:
            throw "Unknown tag: " + t
        }
    },
    createVariable: function(t) {
        var e = t.match(/^\{\{(.*)\}\}$/);
        if (e)
            return new GurLiquid.Variable(e[1]);
        throw "Variable '" + t + "' was not properly terminated with: }}"
    },
    render: function(t) {
        return this.renderAll(this.nodelist, t)
    },
    renderAll: function(t, e) {
        return GurLiquid.extensions.arrayTools.map(t || [], function(t, n) {
            var i = "";
            try {
                i = t.render ? t.render(e) : t
            } catch (t) {
                i = e.handleError(t)
            }
            return i
        })
    },
    assertMissingDelimitation: function() {
        throw this.blockName + " tag was never closed"
    }
}),
GurLiquid.Document = GurLiquid.Block.extend({
    init: function(t) {
        this.blockDelimiter = [],
        this.parse(t)
    },
    assertMissingDelimitation: function() {}
}),
GurLiquid.Strainer = GurLiquid.Class.extend({
    init: function(t) {
        this.context = t
    },
    respondTo: function(t) {
        return !(t = t.toString()).match(/^__/) && !GurLiquid.extensions.arrayTools.include(GurLiquid.Strainer.requiredMethods, t) && t in this
    }
}),
GurLiquid.Strainer.filters = {},
GurLiquid.Strainer.globalFilter = function(t) {
    for (var e in t)
        GurLiquid.Strainer.filters[e] = t[e]
}
,
GurLiquid.Strainer.requiredMethods = ["respondTo", "context"],
GurLiquid.Strainer.create = function(t) {
    var e = new GurLiquid.Strainer(t);
    for (var n in GurLiquid.Strainer.filters)
        e[n] = GurLiquid.Strainer.filters[n];
    return e
}
,
GurLiquid.Context = GurLiquid.Class.extend({
    init: function(t, e, n) {
        this.scopes = [t || {}],
        this.registers = e || {},
        this.errors = [],
        this.rethrowErrors = n,
        this.strainer = GurLiquid.Strainer.create(this)
    },
    get: function(t) {
        return this.resolve(t)
    },
    set: function(t, e) {
        this.scopes[0][t] = e
    },
    hasKey: function(t) {
        return !!this.resolve(t)
    },
    push: function() {
        var t = {};
        return this.scopes.unshift(t),
        t
    },
    merge: function(t) {
        return GurLiquid.extensions.object.update.call(this.scopes[0], t)
    },
    pop: function() {
        if (1 == this.scopes.length)
            throw "Context stack error";
        return this.scopes.shift()
    },
    stack: function(t, e) {
        var n = null;
        this.push();
        try {
            n = t.apply(e || this.strainer)
        } finally {
            this.pop()
        }
        return n
    },
    invoke: function(t, e) {
        return this.strainer.respondTo(t) ? this.strainer[t].apply(this.strainer, e) : 0 == e.length ? null : e[0]
    },
    resolve: function(t) {
        switch (t) {
        case null:
        case "nil":
        case "null":
        case "":
            return null;
        case "true":
            return !0;
        case "false":
            return !1;
        case "blank":
        case "empty":
            return "";
        default:
            if (/^'(.*)'$/.test(t))
                return t.replace(/^'(.*)'$/, "$1");
            if (/^"(.*)"$/.test(t))
                return t.replace(/^"(.*)"$/, "$1");
            if (/^(\d+)$/.test(t))
                return parseInt(t.replace(/^(\d+)$/, "$1"));
            if (/^(\d[\d\.]+)$/.test(t))
                return parseFloat(t.replace(/^(\d[\d\.]+)$/, "$1"));
            if (/^\((\S+)\.\.(\S+)\)$/.test(t)) {
                var e = t.match(/^\((\S+)\.\.(\S+)\)$/)
                  , n = parseInt(e[1])
                  , i = parseInt(e[2])
                  , r = [];
                if (isNaN(n) || isNaN(i)) {
                    n = e[1].charCodeAt(0);
                    for (var o = (i = e[2].charCodeAt(0)) - n + 1, s = 0; s < o; s++)
                        r.push(String.fromCharCode(s + n))
                } else
                    for (o = i - n + 1,
                    s = 0; s < o; s++)
                        r.push(s + n);
                return r
            }
            return this.variable(t)
        }
    },
    findVariable: function(t) {
        for (var e = 0; e < this.scopes.length; e++) {
            var n = this.scopes[e];
            if (n && void 0 !== n[t]) {
                var i = n[t];
                return "function" == typeof i && (i = i.apply(this),
                n[t] = i),
                i && this._isObject(i) && "toGurLiquid"in i && (i = i.toGurLiquid()),
                i && this._isObject(i) && "setContext"in i && i.setContext(self),
                i
            }
        }
        return null
    },
    variable: function(t) {
        if ("string" != typeof t)
            return null;
        var e = t.match(/\[[^\]]+\]|(?:[\w\-]\??)+/g)
          , n = e.shift()
          , i = n.match(/^\[(.*)\]$/);
        i && (n = this.resolve(i[1]));
        var r = this.findVariable(n)
          , o = this;
        return r && GurLiquid.extensions.arrayTools.each(e, function(t) {
            var e = t.match(/^\[(.*)\]$/);
            if (e)
                t = o.resolve(e[1]),
                "function" == typeof r[t] && (r[t] = r[t].apply(this)),
                r = r[t],
                o._isObject(r) && "toGurLiquid"in r && (r = r.toGurLiquid());
            else {
                if ((o._isObject(r) || "hash" == typeof r) && t in r) {
                    var n = r[t];
                    "function" == typeof n && (n = r[t] = n.apply(o)),
                    r = o._isObject(n) && "toGurLiquid"in n ? n.toGurLiquid() : n
                } else if (/^\d+$/.test(t)) {
                    var i = parseInt(t);
                    "function" == typeof r[i] && (r[i] = r[i].apply(o)),
                    r = o._isObject(r) && o._isObject(r[i]) && "toGurLiquid"in r[i] ? r[i].toGurLiquid() : r[i]
                } else {
                    if (!r || "function" != typeof r[t] || !GurLiquid.extensions.arrayTools.include(["length", "size", "first", "last"], t))
                        return r = null;
                    "toGurLiquid"in (r = r[t].apply(t)) && (r = r.toGurLiquid())
                }
                o._isObject(r) && "setContext"in r && r.setContext(o)
            }
        }),
        r
    },
    addFilters: function(t) {
        t = GurLiquid.extensions.arrayTools.flatten(t),
        GurLiquid.extensions.arrayTools.each(t, function(t) {
            if (!this._isObject(t))
                throw "Expected object but got: " + typeof t;
            this.strainer.addMethods(t)
        })
    },
    handleError: function(t) {
        if (this.errors.push(t),
        this.rethrowErrors)
            throw t;
        return "GurLiquid error: " + (t.message ? t.message : t.description ? t.description : t)
    },
    _isObject: function(t) {
        return null != t && "object" == typeof t
    }
}),
GurLiquid.Template = GurLiquid.Class.extend({
    init: function() {
        this.root = null,
        this.registers = {},
        this.assigns = {},
        this.errors = [],
        this.rethrowErrors = !1
    },
    parse: function(t) {
        return this.root = new GurLiquid.Document(GurLiquid.Template.tokenize(t)),
        this
    },
    render: function() {
        if (!this.root)
            return "";
        var t = {
            ctx: arguments[0],
            filters: arguments[1],
            registers: arguments[2]
        }
          , e = null;
        t.ctx instanceof GurLiquid.Context ? (e = t.ctx,
        this.assigns = e.assigns,
        this.registers = e.registers) : (t.ctx && GurLiquid.extensions.object.update.call(this.assigns, t.ctx),
        t.registers && GurLiquid.extensions.object.update.call(this.registers, t.registers),
        e = new GurLiquid.Context(this.assigns,this.registers,this.rethrowErrors)),
        t.filters && e.addFilters(arg.filters);
        try {
            return this.root.render(e).join("")
        } finally {
            this.errors = e.errors
        }
    },
    renderWithErrors: function() {
        var t = this.rethrowErrors;
        this.rethrowErrors = !0;
        var e = this.render.apply(this, arguments);
        return this.rethrowErrors = t,
        e
    }
}),
GurLiquid.Template.tags = {},
GurLiquid.Template.registerTag = function(t, e) {
    GurLiquid.Template.tags[t] = e
}
,
GurLiquid.Template.registerFilter = function(t) {
    GurLiquid.Strainer.globalFilter(t)
}
,
GurLiquid.Template.tokenize = function(t) {
    var e = t.split(/(\{\%.*?\%\}|\{\{.*?\}\}?)/);
    return "" == e[0] && e.shift(),
    e
}
,
GurLiquid.Template.parse = function(t) {
    return (new GurLiquid.Template).parse(t)
}
,
GurLiquid.Variable = GurLiquid.Class.extend({
    init: function(t) {
        this.markup = t,
        this.name = null,
        this.filters = [];
        var e = this
          , n = t.match(/\s*("[^"]+"|'[^']+'|[^\s,|]+)/);
        if (n) {
            this.name = n[1];
            var i = t.match(/\|\s*(.*)/);
            if (i) {
                var r = i[1].split(/\|/);
                GurLiquid.extensions.arrayTools.each(r, function(t) {
                    var n = t.match(/\s*(\w+)/);
                    if (n) {
                        var i = n[1]
                          , r = [];
                        GurLiquid.extensions.arrayTools.each(GurLiquid.extensions.arrayTools.flatten(t.match(/(?:[:|,]\s*)("[^"]+"|'[^']+'|[^\s,|]+)/g) || []), function(t) {
                            var e = t.match(/^[\s|:|,]*(.*?)[\s]*$/);
                            e && r.push(e[1])
                        }),
                        e.filters.push([i, r])
                    }
                })
            }
        }
    },
    render: function(t) {
        if (null == this.name)
            return "";
        var e = t.get(this.name);
        return GurLiquid.extensions.arrayTools.each(this.filters, function(n) {
            var i = n[0]
              , r = GurLiquid.extensions.arrayTools.map(n[1] || [], function(e) {
                return t.get(e)
            });
            r.unshift(e),
            e = t.invoke(i, r)
        }),
        e
    }
}),
GurLiquid.Condition = GurLiquid.Class.extend({
    init: function(t, e, n) {
        this.left = t,
        this.operator = e,
        this.right = n,
        this.childRelation = null,
        this.childCondition = null,
        this.attachment = null
    },
    evaluate: function(t) {
        t = t || new GurLiquid.Context;
        var e = this.interpretCondition(this.left, this.right, this.operator, t);
        switch (this.childRelation) {
        case "or":
            return e || this.childCondition.evaluate(t);
        case "and":
            return e && this.childCondition.evaluate(t);
        default:
            return e
        }
    },
    or: function(t) {
        this.childRelation = "or",
        this.childCondition = t
    },
    and: function(t) {
        this.childRelation = "and",
        this.childCondition = t
    },
    attach: function(t) {
        return this.attachment = t,
        this.attachment
    },
    isElse: !1,
    interpretCondition: function(t, e, n, i) {
        if (!n)
            return i.get(t);
        if (t = i.get(t),
        e = i.get(e),
        !(n = GurLiquid.Condition.operators[n]))
            throw "Unknown operator " + n;
        return n(t, e)
    },
    toString: function() {
        return "<Condition " + this.left + " " + this.operator + " " + this.right + ">"
    }
}),
GurLiquid.Condition.operators = {
    "==": function(t, e) {
        return t == e
    },
    "=": function(t, e) {
        return t == e
    },
    "!=": function(t, e) {
        return t != e
    },
    "<>": function(t, e) {
        return t != e
    },
    "<": function(t, e) {
        return t < e
    },
    ">": function(t, e) {
        return t > e
    },
    "<=": function(t, e) {
        return t <= e
    },
    ">=": function(t, e) {
        return t >= e
    },
    contains: function(t, e) {
        return "[object Array]" === Object.prototype.toString.call(t) ? GurLiquid.extensions.arrayTools.indexOf(t, e) >= 0 : t.match(e)
    },
    hasKey: function(t, e) {
        return GurLiquid.extensions.object.hasKey.call(t, e)
    },
    hasValue: function(t, e) {
        return GurLiquid.extensions.object.hasValue.call(t, e)
    }
},
GurLiquid.ElseCondition = GurLiquid.Condition.extend({
    isElse: !0,
    evaluate: function(t) {
        return !0
    },
    toString: function() {
        return "<ElseCondition>"
    }
}),
GurLiquid.Drop = GurLiquid.Class.extend({
    setContext: function(t) {
        this.context = t
    },
    beforeMethod: function(t) {},
    invokeDrop: function(t) {
        var e = this.beforeMethod();
        return !e && t in this && (e = this[t].apply(this)),
        e
    },
    hasKey: function(t) {
        return !0
    }
});
var split, hackObjectEach = function(t) {
    if ("function" != typeof t)
        throw "Object.each requires first argument to be a function";
    var e = 0
      , n = arguments[1];
    for (var i in this) {
        var r = this[i]
          , o = [i, r];
        o.key = i,
        o.value = r,
        t.call(n, o, e, this),
        e++
    }
    return null
};
GurLiquid.Template.registerTag("assign", GurLiquid.Tag.extend({
    tagSyntax: /((?:\(?[\w\-\.\[\]]\)?)+)\s*=\s*(.+)/,
    init: function(t, e, n) {
        var i = e.match(this.tagSyntax);
        if (!i)
            throw "Syntax error in 'assign' - Valid syntax: assign [var] = [source]";
        this.to = i[1],
        this.from = i[2],
        this._super(t, e, n)
    },
    render: function(t) {
        var e = new GurLiquid.Variable(this.from);
        return GurLiquid.extensions.arrayTools.last(t.scopes)[this.to.toString()] = e.render(t),
        ""
    }
})),
GurLiquid.Template.registerTag("cache", GurLiquid.Block.extend({
    tagSyntax: /(\w+)/,
    init: function(t, e, n) {
        var i = e.match(this.tagSyntax);
        if (!i)
            throw "Syntax error in 'cache' - Valid syntax: cache [var]";
        this.to = i[1],
        this._super(t, e, n)
    },
    render: function(t) {
        var e = this._super(t);
        return GurLiquid.extensions.arrayTools.last(t.scopes)[this.to] = GurLiquid.extensions.arrayTools.flatten([e]).join(""),
        ""
    }
})),
GurLiquid.Template.registerTag("capture", GurLiquid.Block.extend({
    tagSyntax: /(\w+)/,
    init: function(t, e, n) {
        var i = e.match(this.tagSyntax);
        if (!i)
            throw "Syntax error in 'capture' - Valid syntax: capture [var]";
        this.to = i[1],
        this._super(t, e, n)
    },
    render: function(t) {
        var e = this._super(t);
        return GurLiquid.extensions.arrayTools.last(t.scopes)[this.to.toString()] = GurLiquid.extensions.arrayTools.flatten([e]).join(""),
        ""
    }
})),
GurLiquid.Template.registerTag("case", GurLiquid.Block.extend({
    tagSyntax: /("[^"]+"|'[^']+'|[^\s,|]+)/,
    tagWhenSyntax: /("[^"]+"|'[^']+'|[^\s,|]+)(?:(?:\s+or\s+|\s*\,\s*)("[^"]+"|'[^']+'|[^\s,|]+.*))?/,
    init: function(t, e, n) {
        this.blocks = [],
        this.nodelist = [];
        var i = e.match(this.tagSyntax);
        if (!i)
            throw "Syntax error in 'case' - Valid syntax: case [condition]";
        this.left = i[1],
        this._super(t, e, n)
    },
    unknownTag: function(t, e, n) {
        switch (t) {
        case "when":
            this.recordWhenCondition(e);
            break;
        case "else":
            this.recordElseCondition(e);
            break;
        default:
            this._super(t, e, n)
        }
    },
    render: function(t) {
        var e = this
          , n = []
          , i = !0;
        return t.stack(function() {
            for (var r = 0; r < e.blocks.length; r++) {
                var o = e.blocks[r];
                if (o.isElse)
                    return 1 == i && (n = GurLiquid.extensions.arrayTools.flatten([n, e.renderAll(o.attachment, t)])),
                    n;
                o.evaluate(t) && (i = !1,
                n = GurLiquid.extensions.arrayTools.flatten([n, e.renderAll(o.attachment, t)]))
            }
        }),
        n
    },
    recordWhenCondition: function(t) {
        for (; t; ) {
            var e = t.match(this.tagWhenSyntax);
            if (!e)
                throw "Syntax error in tag 'case' - Valid when condition: {% when [condition] [or condition2...] %} ";
            t = e[2];
            var n = new GurLiquid.Condition(this.left,"==",e[1]);
            this.blocks.push(n),
            this.nodelist = n.attach([])
        }
    },
    recordElseCondition: function(t) {
        if ("" != GurLiquid.extensions.stringTools.strip(t || ""))
            throw "Syntax error in tag 'case' - Valid else condition: {% else %} (no parameters) ";
        var e = new GurLiquid.ElseCondition;
        this.blocks.push(e),
        this.nodelist = e.attach([])
    }
})),
GurLiquid.Template.registerTag("comment", GurLiquid.Block.extend({
    render: function(t) {
        return ""
    }
})),
GurLiquid.Template.registerTag("cycle", GurLiquid.Tag.extend({
    tagSimpleSyntax: /"[^"]+"|'[^']+'|[^\s,|]+/,
    tagNamedSyntax: /("[^"]+"|'[^']+'|[^\s,|]+)\s*\:\s*(.*)/,
    init: function(t, e, n) {
        var i;
        if (i = e.match(this.tagNamedSyntax))
            this.variables = this.variablesFromString(i[2]),
            this.name = i[1];
        else {
            if (!(i = e.match(this.tagSimpleSyntax)))
                throw "Syntax error in 'cycle' - Valid syntax: cycle [name :] var [, var2, var3 ...]";
            this.variables = this.variablesFromString(e),
            this.name = "'" + this.variables.toString() + "'"
        }
        this._super(t, e, n)
    },
    render: function(t) {
        var e = this
          , n = t.get(e.name)
          , i = "";
        return t.registers.cycle || (t.registers.cycle = {}),
        t.registers.cycle[n] || (t.registers.cycle[n] = 0),
        t.stack(function() {
            var r = t.registers.cycle[n]
              , o = t.get(e.variables[r]);
            (r += 1) == e.variables.length && (r = 0),
            t.registers.cycle[n] = r,
            i = o
        }),
        i
    },
    variablesFromString: function(t) {
        return GurLiquid.extensions.arrayTools.map(t.split(","), function(t) {
            var e = t.match(/\s*("[^"]+"|'[^']+'|[^\s,|]+)\s*/);
            return e[1] ? e[1] : null
        })
    }
})),
GurLiquid.Template.registerTag("for", GurLiquid.Block.extend({
    tagSyntax: /(\w+)\s+in\s+((?:\(?[\w\-\.\[\]]\)?)+)/,
    init: function(t, e, n) {
        var i = e.match(this.tagSyntax);
        if (!i)
            throw "Syntax error in 'for loop' - Valid syntax: for [item] in [collection]";
        this.variableName = i[1],
        this.collectionName = i[2],
        this.name = this.variableName + "-" + this.collectionName,
        this.attributes = {},
        e.replace(this.tagSyntax, "");
        var r = e.match(/(\w*?)\s*\:\s*("[^"]+"|'[^']+'|[^\s,|]+)/g);
        r && GurLiquid.extensions.arrayTools.each(r, function(t) {
            t = t.split(":"),
            this.attributes[GurLiquid.extensions.stringTools.strip(t[0])] = GurLiquid.extensions.stringTools.strip(t[1])
        }, this),
        this._super(t, e, n)
    },
    render: function(t) {
        var e = this
          , n = []
          , i = t.get(this.collectionName) || []
          , r = [0, i.length];
        if (t.registers.for || (t.registers.for = {}),
        this.attributes.limit || this.attributes.offset) {
            var o, s, a, u = null;
            r = [a = "continue" == this.attributes.offset ? t.registers.for[this.name] : t.get(this.attributes.offset) || 0, (s = (o = t.get(this.attributes.limit)) ? a + o + 1 : i.length) - 1],
            t.registers.for[this.name] = s
        }
        return (u = i.slice(r[0], r[1])) && 0 != u.length ? (t.stack(function() {
            var i = u.length;
            GurLiquid.extensions.arrayTools.each(u, function(r, o) {
                t.set(e.variableName, r),
                t.set("forloop", {
                    name: e.name,
                    length: i,
                    index: o + 1,
                    index0: o,
                    rindex: i - o,
                    rindex0: i - o - 1,
                    first: 0 == o,
                    last: o == i - 1
                }),
                n.push((e.renderAll(e.nodelist, t) || []).join(""))
            })
        }),
        GurLiquid.extensions.arrayTools.flatten([n]).join("")) : ""
    }
})),
GurLiquid.Template.registerTag("if", GurLiquid.Block.extend({
    tagSyntax: /("[^"]+"|'[^']+'|[^\s,|]+)\s*([=!<>a-z_]+)?\s*("[^"]+"|'[^']+'|[^\s,|]+)?/,
    init: function(t, e, n) {
        this.nodelist = [],
        this.blocks = [],
        this.pushBlock("if", e),
        this._super(t, e, n)
    },
    unknownTag: function(t, e, n) {
        GurLiquid.extensions.arrayTools.include(["elsif", "else"], t) ? this.pushBlock(t, e) : this._super(t, e, n)
    },
    render: function(t) {
        var e = this
          , n = "";
        return t.stack(function() {
            for (var i = 0; i < e.blocks.length; i++) {
                var r = e.blocks[i];
                if (r.evaluate(t))
                    return void (n = e.renderAll(r.attachment, t))
            }
        }),
        GurLiquid.extensions.arrayTools.flatten([n]).join("")
    },
    pushBlock: function(t, e) {
        var n;
        if ("else" == t)
            n = new GurLiquid.ElseCondition;
        else {
            var i = e.split(/\b(and|or)\b/).reverse();
            if (!(o = i.shift().match(this.tagSyntax)))
                throw "Syntax Error in tag '" + t + "' - Valid syntax: " + t + " [expression]";
            for (var r = new GurLiquid.Condition(o[1],o[2],o[3]); i.length > 0; ) {
                var o, s = i.shift();
                if (!(o = i.shift().match(this.tagSyntax)))
                    throw "Syntax Error in tag '" + t + "' - Valid syntax: " + t + " [expression]";
                var a = new GurLiquid.Condition(o[1],o[2],o[3]);
                a[s](r),
                r = a
            }
            n = r
        }
        n.attach([]),
        this.blocks.push(n),
        this.nodelist = n.attachment
    }
})),
GurLiquid.Template.registerTag("ifchanged", GurLiquid.Block.extend({
    render: function(t) {
        var e = this
          , n = "";
        return t.stack(function() {
            var i = e.renderAll(e.nodelist, t).join("");
            i != t.registers.ifchanged && (n = i,
            t.registers.ifchanged = n)
        }),
        n
    }
})),
GurLiquid.Template.registerTag("include", GurLiquid.Tag.extend({
    tagSyntax: /((?:"[^"]+"|'[^']+'|[^\s,|]+)+)(\s+(?:with|for)\s+((?:"[^"]+"|'[^']+'|[^\s,|]+)+))?/,
    init: function(t, e, n) {
        var i = (e || "").match(this.tagSyntax);
        if (!i)
            throw "Error in tag 'include' - Valid syntax: include '[template]' (with|for) [object|collection]";
        this.templateName = i[1],
        this.templateNameVar = this.templateName.substring(1, this.templateName.length - 1),
        this.variableName = i[3],
        this.attributes = {};
        var r = e.match(/(\w*?)\s*\:\s*("[^"]+"|'[^']+'|[^\s,|]+)/g);
        r && GurLiquid.extensions.arrayTools.each(r, function(t) {
            t = t.split(":"),
            this.attributes[GurLiquid.extensions.stringTools.strip(t[0])] = GurLiquid.extensions.stringTools.strip(t[1])
        }, this),
        this._super(t, e, n)
    },
    render: function(t) {
        var e = this
          , n = GurLiquid.readTemplateFile(t.get(this.templateName))
          , i = GurLiquid.parse(n)
          , r = t.get(this.variableName || this.templateNameVar)
          , o = "";
        return t.stack(function() {
            e.attributes.each = hackObjectEach,
            e.attributes.each(function(e) {
                t.set(e.key, t.get(e.value))
            }),
            r instanceof Array ? o = GurLiquid.extensions.arrayTools.map(r, function(n) {
                return t.set(e.templateNameVar, n),
                i.render(t)
            }) : (t.set(e.templateNameVar, r),
            o = i.render(t))
        }),
        o = GurLiquid.extensions.arrayTools.flatten([o]).join("")
    }
})),
GurLiquid.Template.registerTag("unless", GurLiquid.Template.tags.if.extend({
    render: function(t) {
        var e = this
          , n = "";
        return t.stack(function() {
            if ((r = e.blocks[0]).evaluate(t))
                for (var i = 1; i < e.blocks.length; i++) {
                    var r;
                    if ((r = e.blocks[i]).evaluate(t))
                        return void (n = e.renderAll(r.attachment, t))
                }
            else
                n = e.renderAll(r.attachment, t)
        }),
        GurLiquid.extensions.arrayTools.flatten([n]).join("")
    }
})),
GurLiquid.Template.registerTag("raw", GurLiquid.Block.extend({
    parse: function(t) {
        this.nodelist || (this.nodelist = []),
        this.nodelist.length = 0;
        var e = t.shift();
        for (t.push(""); t.length; ) {
            if (/^\{\%/.test(e)) {
                var n = e.match(/^\{\%\s*(\w+)\s*(.*)?\%\}$/);
                if (n && this.blockDelimiter == n[1])
                    return void this.endTag()
            }
            this.nodelist.push(e || ""),
            e = t.shift()
        }
        this.assertMissingDelimitation()
    },
    render: function(t) {
        return this.nodelist.join("")
    }
})),
GurLiquid.Template.registerTag("increment", GurLiquid.Tag.extend({
    tagSyntax: /((?:\(?[\w\-\.\[\]]\)?)+)/,
    init: function(t, e, n) {
        var i = e.match(this.tagSyntax);
        if (console.log(t, e, n),
        console.log(i[1]),
        !i)
            throw "Syntax error in 'assign' - Valid syntax: increment [var]";
        this.name = i[1],
        this._super(t, e, n)
    },
    render: function(t) {
        var e, n = this.name;
        return t.registers.increment || (t.registers.increment = {}),
        t.registers.increment[n] || (t.registers.increment[n] = 0),
        e = String(t.registers.increment[n]),
        t.registers.increment[n]++,
        e
    }
})),
GurLiquid.Template.registerTag("decrement", GurLiquid.Tag.extend({
    tagSyntax: /((?:\(?[\w\-\.\[\]]\)?)+)/,
    init: function(t, e, n) {
        var i = e.match(this.tagSyntax);
        if (console.log(t, e, n),
        console.log(i[1]),
        !i)
            throw "Syntax error in 'assign' - Valid syntax: decrement [var]";
        this.name = i[1],
        this._super(t, e, n)
    },
    render: function(t) {
        var e, n = this.name;
        return t.registers.decrement || (t.registers.decrement = {}),
        t.registers.decrement[n] || (t.registers.decrement[n] = -1),
        e = String(t.registers.decrement[n]),
        t.registers.decrement[n]--,
        e
    }
})),
function(t) {
    var e = function(t, e) {
        function n(t, e) {
            return void 0 === t ? e : t
        }
        function i(t, e, i, r) {
            if (e = n(e, 2),
            i = n(i, ","),
            r = n(r, "."),
            isNaN(t) || null == t)
                return 0;
            var o = t;
            return Shopify && Shopify.currency && Shopify.currency.rate && 1 != parseFloat(Shopify.currency.rate) && (void 0 !== window.curCurrency && window.curCurrency == Shopify.currency.active || (o = Math.round(t * parseFloat(Shopify.currency.rate)))),
            (o = (o = parseFloat(o.toFixed(e)) / 100).toFixed(e).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? r + o[1] : "")
        }
        "string" == typeof t && (t = t.replace(".", ""));
        var r = ""
          , o = /\{\{\s*(\w+)\s*\}\}/
          , s = e;
        switch (s.match(o)[1]) {
        case "amount":
            r = i(t, 2);
            break;
        case "amount_no_decimals":
            r = i(t, 0);
            break;
        case "amount_with_comma_separator":
            r = i(t, 2, ".", ",");
            break;
        case "amount_with_space_separator":
            r = i(t, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            r = i(t, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            r = i(t, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            r = i(t, 0, ".", "");
            break;
        case "amount_with_space_separator":
            r = i(t, 2, ",", "");
            break;
        case "amount_with_apostrophe_separator":
            r = i(t, 2, "'", ".");
        default:
            r = i(t, 2)
        }
        return s.replace(o, r)
    };
    t.Template.registerFilter({
        _HTML_ESCAPE_MAP: {
            "&": "&amp;",
            ">": "&gt;",
            "<": "&lt;",
            '"': "&quot;",
            "'": "&#39;"
        },
        size: function(t) {
            return t.length ? t.length : 0
        },
        downcase: function(t) {
            return t.toString().toLowerCase()
        },
        upcase: function(t) {
            return t.toString().toUpperCase()
        },
        capitalize: function(e) {
            return t.extensions.stringTools.capitalize(e.toString())
        },
        handle: function(t) {
            return t.toLowerCase().replace(/("|'|\\|\(|\)|\[|\])/g, "").replace(/\W+/g, "-").replace(/^-+|-+$/g, "")
        },
        escape: function(t) {
            var e = this;
            return t.replace(/[&<>"']/g, function(t) {
                return e._HTML_ESCAPE_MAP[t]
            })
        },
        url_encode: function(t) {
            return encodeURIComponent(t)
        },
        h: function(t) {
            var e = this;
            return t.replace(/[&<>"']/g, function(t) {
                return e._HTML_ESCAPE_MAP[t]
            })
        },
        default: function(e, n) {
            return t.extensions.object.isEmpty(e) ? n : e
        },
        truncate: function(t, e, n) {
            return t && "" != t ? (e = e || 50,
            n = n || "...",
            t.slice(0, e),
            t.length > e ? t.slice(0, e) + n : t) : ""
        },
        replace: function(t, e, n) {
            if (!t || "" == t)
                return "";
            e = parseInt(e || 15),
            n = n || "...";
            var i = t.toString().split(" ")
              , r = Math.max(e, 0);
            return i.length > r ? i.slice(0, r).join(" ") + n : t
        },
        truncate_words: function(t, e, n) {
            if (!t || "" == t)
                return "";
            e = parseInt(e || 15),
            n = n || "...";
            var i = t.toString().split(" ")
              , r = Math.max(e, 0);
            return i.length > r ? i.slice(0, r).join(" ") + n : t
        },
        strip_html: function(t) {
            return t.toString().replace(/<.*?>/g, "")
        },
        strip_newlines: function(t) {
            return t.toString().replace(/\n/g, "")
        },
        join: function(t, e) {
            return e = e || " ",
            Array.isArray(t) ? t.join(e) : t
        },
        split: function(t, e) {
            return e = e || " ",
            t.split(e)
        },
        sort: function(t) {
            return t.sort()
        },
        custom_sort: function(t) {
            return t.sort(function(t, e) {
                return parseInt(t) - parseInt(e)
            })
        },
        reverse: function(t) {
            return t.reverse()
        },
        replace: function(t, e, n) {
            return n = n || "",
            t.toString().replace(new RegExp(e,"g"), n)
        },
        replace_first: function(t, e, n) {
            return n = n || "",
            t.toString().replace(new RegExp(e,""), n)
        },
        newline_to_br: function(t) {
            return t.toString().replace(/\n/g, "<br/>\n")
        },
        date: function(t, e) {
            var n;
            return t instanceof Date && (n = t),
            n instanceof Date || "now" != t || (n = new Date),
            n instanceof Date || "number" != typeof t || (n = new Date(1e3 * t)),
            n instanceof Date || "string" != typeof t || (n = new Date(Date.parse(t))),
            n instanceof Date ? "%s" == e ? Math.round(n.getTime() / 1e3) : n.strftime(e) : t
        },
        first: function(t) {
            return t[0]
        },
        last: function(t) {
            return (t = t)[t.length - 1]
        },
        minus: function(t, e) {
            return (Number(t) || 0) - (Number(e) || 0)
        },
        plus: function(t, e) {
            return (Number(t) || 0) + (Number(e) || 0)
        },
        times: function(t, e) {
            return (Number(t) || 0) * (Number(e) || 0)
        },
        divided_by: function(t, e) {
            return (Number(t) || 0) / (Number(e) || 0)
        },
        modulo: function(t, e) {
            return (Number(t) || 0) % (Number(e) || 0)
        },
        map: function(t, e) {
            t = t || [];
            for (var n = [], i = 0; i < t.length; i++)
                n.push(t[i][e]);
            return n
        },
        escape_once: function(t) {
            var e = this;
            return t.replace(/["><']|&(?!([a-zA-Z]+|(#\d+));)/g, function(t) {
                return e._HTML_ESCAPE_MAP[t]
            })
        },
        remove: function(t, e) {
            return t.toString().replace(new RegExp(e,"g"), "")
        },
        remove_first: function(t, e) {
            return t.toString().replace(e, "")
        },
        prepend: function(t, e) {
            return "" + (e || "").toString() + (t || "").toString()
        },
        append: function(t, e) {
            return "" + (t || "").toString() + (e || "").toString()
        },
        money: function(t) {
            return e(t, window.globoAlsoBoughtMoneyFormat ? window.globoAlsoBoughtMoneyFormat : window.moneyFormat)
        },
        money_with_currency: function(t) {
            return e(t, window.globoAlsoBoughtMoneyFormat ? window.globoAlsoBoughtMoneyFormat : window.moneyFormat)
        },
        money_without_trailing_zeros: function(t) {
            return e(t, window.globoAlsoBoughtMoneyFormat ? window.globoAlsoBoughtMoneyFormat : window.moneyFormat)
        },
        money_without_currency: function(t) {
            return e(t, window.globoAlsoBoughtMoneyFormat ? window.globoAlsoBoughtMoneyFormat : window.moneyFormat)
        },
        round: function(t) {
            return parseInt(Math.round(t))
        },
        floor: function(t) {
            return parseInt(Math.floor(t))
        },
        ceil: function(t) {
            return parseInt(Math.ceil(t))
        },
        img_url: function(t, e, n) {
            n = n || !1;
            var i = t.split(".").pop()
              , r = t.lastIndexOf(i) - 1;
            return t.slice(0, r) + "_" + e + t.slice(r)
        },
        img_ladyload_url: function(t, e) {
            e = e || !1;
            var n = t.split(".").pop()
              , i = t.lastIndexOf(n) - 1;
            return t.slice(0, i) + "_{width}x" + t.slice(i)
        },
        img_lazyload_url: function(t, e) {
            e = e || !1;
            var n = t.split(".").pop()
              , i = t.lastIndexOf(n) - 1;
            return t.slice(0, i) + "_{width}x" + t.slice(i)
        },
        file_img_url: function(t, e, n) {
            n = n || !1,
            n = t.split(".").pop();
            var i = t.lastIndexOf(n) - 1;
            return t = t.slice(0, i) + "_" + e + t.slice(i),
            window.filesUrl + t
        },
        crop: function(t, e) {
            var n = t.split(".").pop()
              , i = t.lastIndexOf(n) - 1;
            return t.slice(0, i) + "_crop_" + e + t.slice(i)
        },
        json: function(t) {
            return JSON.stringify(t)
        },
        parseJson: function(t) {
            return JSON.parse(t)
        },
        asset_img_url: function(t, e) {
            var n = t.split(".").pop()
              , i = t.lastIndexOf(n) - 1;
            return t = t.slice(0, i) + "_" + e + t.slice(i),
            window.assetsUrl + t
        },
        asset_url: function(t) {
            return window.assetsUrl + t
        }
    })
}(GurLiquid),
(new Date).strftime || (Date.ext = {},
Date.ext.util = {},
Date.ext.util.xPad = function(t, e, n) {
    for (void 0 === n && (n = 10); parseInt(t, 10) < n && n > 1; n /= 10)
        t = e.toString() + t;
    return t.toString()
}
,
Date.prototype.locale = "en-GB",
document.getElementsByTagName("html") && document.getElementsByTagName("html")[0].lang && (Date.prototype.locale = document.getElementsByTagName("html")[0].lang),
Date.ext.locales = {},
Date.ext.locales.en = {
    a: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    A: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    b: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    B: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    c: "%a %d %b %Y %T %Z",
    p: ["AM", "PM"],
    P: ["am", "pm"],
    x: "%d/%m/%y",
    X: "%T"
},
"undefined" != typeof JSON ? Date.ext.locales["en-US"] = JSON.parse(JSON.stringify(Date.ext.locales.en)) : Date.ext.locales["en-US"] = Date.ext.locales.en,
Date.ext.locales["en-US"].c = "%a %d %b %Y %r %Z",
Date.ext.locales["en-US"].x = "%D",
Date.ext.locales["en-US"].X = "%r",
Date.ext.locales["en-GB"] = Date.ext.locales.en,
Date.ext.locales["en-AU"] = Date.ext.locales["en-GB"],
Date.ext.formats = {
    a: function(t) {
        return Date.ext.locales[t.locale].a[t.getDay()]
    },
    A: function(t) {
        return Date.ext.locales[t.locale].A[t.getDay()]
    },
    b: function(t) {
        return Date.ext.locales[t.locale].b[t.getMonth()]
    },
    B: function(t) {
        return Date.ext.locales[t.locale].B[t.getMonth()]
    },
    c: "toLocaleString",
    C: function(t) {
        return Date.ext.util.xPad(parseInt(t.getFullYear() / 100, 10), 0)
    },
    d: ["getDate", "0"],
    e: ["getDate", " "],
    g: function(t) {
        return Date.ext.util.xPad(parseInt(Date.ext.util.G(t) / 100, 10), 0)
    },
    G: function(t) {
        var e = t.getFullYear()
          , n = parseInt(Date.ext.formats.V(t), 10)
          , i = parseInt(Date.ext.formats.W(t), 10);
        return i > n ? e++ : 0 === i && n >= 52 && e--,
        e
    },
    H: ["getHours", "0"],
    I: function(t) {
        var e = t.getHours() % 12;
        return Date.ext.util.xPad(0 === e ? 12 : e, 0)
    },
    j: function(t) {
        var e = t - new Date(t.getFullYear() + "/1/1 GMT");
        e += 6e4 * t.getTimezoneOffset();
        var n = parseInt(e / 6e4 / 60 / 24, 10) + 1;
        return Date.ext.util.xPad(n, 0, 100)
    },
    m: function(t) {
        return Date.ext.util.xPad(t.getMonth() + 1, 0)
    },
    M: ["getMinutes", "0"],
    p: function(t) {
        return Date.ext.locales[t.locale].p[t.getHours() >= 12 ? 1 : 0]
    },
    P: function(t) {
        return Date.ext.locales[t.locale].P[t.getHours() >= 12 ? 1 : 0]
    },
    S: ["getSeconds", "0"],
    u: function(t) {
        var e = t.getDay();
        return 0 === e ? 7 : e
    },
    U: function(t) {
        var e = parseInt(Date.ext.formats.j(t), 10)
          , n = 6 - t.getDay()
          , i = parseInt((e + n) / 7, 10);
        return Date.ext.util.xPad(i, 0)
    },
    V: function(t) {
        var e = parseInt(Date.ext.formats.W(t), 10)
          , n = new Date(t.getFullYear() + "/1/1").getDay()
          , i = e + (n > 4 || n <= 1 ? 0 : 1);
        return 53 == i && new Date(t.getFullYear() + "/12/31").getDay() < 4 ? i = 1 : 0 === i && (i = Date.ext.formats.V(new Date(t.getFullYear() - 1 + "/12/31"))),
        Date.ext.util.xPad(i, 0)
    },
    w: "getDay",
    W: function(t) {
        var e = parseInt(Date.ext.formats.j(t), 10)
          , n = 7 - Date.ext.formats.u(t)
          , i = parseInt((e + n) / 7, 10);
        return Date.ext.util.xPad(i, 0, 10)
    },
    y: function(t) {
        return Date.ext.util.xPad(t.getFullYear() % 100, 0)
    },
    Y: "getFullYear",
    z: function(t) {
        var e = t.getTimezoneOffset();
        return (e > 0 ? "-" : "+") + Date.ext.util.xPad(parseInt(Math.abs(e / 60), 10), 0) + Date.ext.util.xPad(e % 60, 0)
    },
    Z: function(t) {
        return t.toString().replace(/^.*\(([^)]+)\)$/, "$1")
    },
    "%": function(t) {
        return "%"
    }
},
Date.ext.aggregates = {
    c: "locale",
    D: "%m/%d/%y",
    h: "%b",
    n: "\n",
    r: "%I:%M:%S %p",
    R: "%H:%M",
    t: "\t",
    T: "%H:%M:%S",
    x: "locale",
    X: "locale"
},
Date.ext.aggregates.z = Date.ext.formats.z(new Date),
Date.ext.aggregates.Z = Date.ext.formats.Z(new Date),
Date.ext.unsupported = {},
Date.prototype.strftime = function(t) {
    this.locale in Date.ext.locales || (this.locale.replace(/-[a-zA-Z]+$/, "")in Date.ext.locales ? this.locale = this.locale.replace(/-[a-zA-Z]+$/, "") : this.locale = "en-GB");
    for (var e = this; t.match(/%[cDhnrRtTxXzZ]/); )
        t = t.replace(/%([cDhnrRtTxXzZ])/g, function(t, n) {
            var i = Date.ext.aggregates[n];
            return "locale" == i ? Date.ext.locales[e.locale][n] : i
        });
    var n = t.replace(/%([aAbBCdegGHIjmMpPSuUVwWyY%])/g, function(t, n) {
        var i = Date.ext.formats[n];
        return "string" == typeof i ? e[i]() : "function" == typeof i ? i.call(e, e) : "object" == typeof i && "string" == typeof i[0] ? Date.ext.util.xPad(e[i[0]](), i[1]) : n
    });
    return e = null,
    n
}
),
split = split || function(t) {
    var e, n = String.prototype.split, i = void 0 === /()??/.exec("")[1];
    return e = function(t, e, r) {
        if ("[object RegExp]" !== Object.prototype.toString.call(e))
            return n.call(t, e, r);
        var o, s, a, u, l = [], c = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.extended ? "x" : "") + (e.sticky ? "y" : ""), d = 0;
        for (e = new RegExp(e.source,c + "g"),
        t += "",
        i || (o = new RegExp("^" + e.source + "$(?!\\s)",c)),
        r = void 0 === r ? -1 >>> 0 : r >>> 0; (s = e.exec(t)) && !((a = s.index + s[0].length) > d && (l.push(t.slice(d, s.index)),
        !i && s.length > 1 && s[0].replace(o, function() {
            for (var t = 1; t < arguments.length - 2; t++)
                void 0 === arguments[t] && (s[t] = void 0)
        }),
        s.length > 1 && s.index < t.length && Array.prototype.push.apply(l, s.slice(1)),
        u = s[0].length,
        d = a,
        l.length >= r)); )
            e.lastIndex === s.index && e.lastIndex++;
        return d === t.length ? !u && e.test("") || l.push("") : l.push(t.slice(d)),
        l.length > r ? l.slice(0, r) : l
    }
    ,
    String.prototype.split = function(t, n) {
        return e(this, t, n)
    }
    ,
    e
}(),
"undefined" != typeof exports && ("undefined" != typeof module && module.exports && (exports = module.exports = GurLiquid),
exports.GurLiquid = GurLiquid),
function(t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    var e = /\+/g;
    function n(t) {
        return r.raw ? t : encodeURIComponent(t)
    }
    function i(n, i) {
        var o = r.raw ? n : function(t) {
            0 === t.indexOf('"') && (t = t.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
            try {
                return t = decodeURIComponent(t.replace(e, " ")),
                r.json ? JSON.parse(t) : t
            } catch (t) {}
        }(n);
        return t.isFunction(i) ? i(o) : o
    }
    var r = t.cookie = function(e, o, s) {
        if (1 < arguments.length && !t.isFunction(o)) {
            if ("number" == typeof (s = t.extend({}, r.defaults, s)).expires) {
                var a = s.expires
                  , u = s.expires = new Date;
                u.setMilliseconds(u.getMilliseconds() + 864e5 * a)
            }
            return document.cookie = [n(e), "=", function(t) {
                return n(r.json ? JSON.stringify(t) : String(t))
            }(o), s.expires ? "; expires=" + s.expires.toUTCString() : "", s.path ? "; path=" + s.path : "", s.domain ? "; domain=" + s.domain : "", s.secure ? "; secure" : ""].join("")
        }
        for (var l, c = e ? void 0 : {}, d = document.cookie ? document.cookie.split("; ") : [], h = 0, p = d.length; h < p; h++) {
            var f = d[h].split("=")
              , g = (l = f.shift(),
            r.raw ? l : decodeURIComponent(l))
              , m = f.join("=");
            if (e === g) {
                c = i(m, o);
                break
            }
            e || void 0 === (m = i(m)) || (c[g] = m)
        }
        return c
    }
    ;
    r.defaults = {},
    t.removeCookie = function(e, n) {
        return t.cookie(e, "", t.extend({}, n, {
            expires: -1
        })),
        !t.cookie(e)
    }
}),
function(gab) {
    globoAlsoBought = function(t) {
        this.apiUrl = t.apiUrl,
        this.shop = t.shop,
        this.domain = t.domain,
        this.manualRecommendations = t.manualRecommendations,
        this.view_name = t.view_name,
        this.redirect = t.redirect,
        this.discount = t.discount,
        this.exclude_tags = t.exclude_tags,
        this.carousel_items = t.carousel_items,
        this.carousel_autoplay = t.carousel_autoplay,
        this.moneyFormat = t.moneyFormat,
        this.productBoughtTogether = t.productBoughtTogether,
        this.productRelated = t.productRelated,
        this.cart = t.cart,
        this.limit = Math.max(this.cart.limit, this.productRelated.limit, this.productBoughtTogether.limit),
        this.product = t.product || null,
        this.no_image_url = t.no_image_url,
        this.relatedProducts = {}
    }
    ,
    globoAlsoBought.prototype.init = function() {
        (new Date).getTime();
        var t = this
          , e = t.getPageType()
          , n = !1
          , i = [];
        if (gab("script").each(function() {
            -1 != gab(this).text().indexOf("globo.alsobought.init.js?") && -1 != gab(this).text().indexOf("asyncLoad") && -1 == gab(this).text().indexOf("initSchema") && (n = !0)
        }),
        n && ("product" == e || "cart" == e)) {
            var r = {
                ids: [],
                tags: [],
                vendors: [],
                types: [],
                collections: []
            };
            if ("product" == e ? (r.ids = [t.product.id],
            r.tags = t.product.tags,
            null != t.product.vendor && "" != t.product.vendor && (r.vendors = [t.product.vendor]),
            null != t.product.product_type && "" != t.product.product_type && (r.types = [t.product.product_type]),
            null != t.product.collection && (r.collections = [t.product.collection]),
            t.productBoughtTogether.enable && gab.each(t.productBoughtTogether.conditions, function(t, e) {
                -1 == i.indexOf(e) && i.push(e)
            }),
            t.productRelated.enable && gab.each(t.productRelated.conditions, function(t, e) {
                -1 == i.indexOf(e) && i.push(e)
            })) : "cart" == e && t.cart.enable && (r.ids = t.cart.products.map(t=>t.id),
            r.ids = [...new Set(r.ids)],
            gab.each(t.cart.products, function(t, e) {
                r.tags = r.tags.concat(e.tags)
            }),
            r.tags = [...new Set(r.tags)],
            gab.each(t.cart.conditions, function(t, e) {
                -1 == i.indexOf(e) && i.push(e)
            })),
            i.length) {
                var o = t.getDeferredStuff(i, r);
                gab.when.apply(null, o).done(function() {
                    if ("product" == e) {
                        if (t.productBoughtTogether.enable)
                            if ((u = t.getBoxProducts(t.productBoughtTogether.conditions, t.productBoughtTogether.limit, t.productBoughtTogether.random, 1 != t.productBoughtTogether.template, r)).products.length) {
                                if (t.productBoughtTogether.thisItem && 1 != t.productBoughtTogether.template && t.product.available) {
                                    u.products.unshift(t.product);
                                    var n = t.product.variants.find(t=>t.available);
                                    u.totalPrice += n.price
                                }
                                var i = GurLiquid.parse(gab("#product_bought_together-template").html().replace(/scripttag/g, "script")).render({
                                    products: u.products,
                                    total_price: u.totalPrice,
                                    cur_product_id: t.product.id,
                                    no_image_url: t.no_image_url
                                })
                                  , o = function(e) {
                                    if (gab("#productBoughtTogether, .productBoughtTogether").length ? gab("#productBoughtTogether, .productBoughtTogether").html(e) : gab('form[action*="/cart/add"]:visible:first, form[action*="/checkout"]:visible:first').length ? (gab('<div id="productBoughtTogether"></div>').insertAfter('form[action*="/cart/add"]:visible:first, form[action*="/checkout"]:visible:first'),
                                    gab("#productBoughtTogether").html(e)) : (gab('<div id="productBoughtTogether"></div>').insertBefore("#globoRelatedProducts"),
                                    gab("#productBoughtTogether").html(e)),
                                    1 == t.productBoughtTogether.template) {
                                        var n = {
                                            items: t.carousel_items,
                                            responsive: {
                                                0: {
                                                    items: t.carousel_items <= 2 ? t.carousel_items : 2
                                                },
                                                576: {
                                                    items: t.carousel_items <= 3 ? t.carousel_items : 3
                                                },
                                                768: {
                                                    items: t.carousel_items <= 4 ? t.carousel_items : 4
                                                },
                                                992: {
                                                    items: t.carousel_items <= 5 ? t.carousel_items : 5
                                                },
                                                1200: {
                                                    items: t.carousel_items <= 6 ? t.carousel_items : 6
                                                }
                                            },
                                            responsiveBaseElement: "#ga-product_bought_together",
                                            nav: !0,
                                            dots: !1,
                                            loop: !1,
                                            navText: ['<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16" fill-rule="evenodd"></path></svg>', '<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16" fill-rule="evenodd"></path></svg>'],
                                            onInitialized: t.owlCarouselFix(),
                                            onResized: t.owlCarouselFix()
                                        };
                                        t.carousel_autoplay && (n.autoplay = !0,
                                        n.autoplayTimeout = 3e3,
                                        n.autoplaySpeed = 1e3,
                                        n.autoplayHoverPause = !0),
                                        gab("#ga-product_bought_together .ga-carousel").gFOwlCarousel(n)
                                    } else
                                        !window.productBoughtTogetherUncheck || 2 != t.productBoughtTogether.template && 3 != t.productBoughtTogether.template || (gab(".selectedItem").prop("checked", !1),
                                        gab(".ga-products-box").each(function() {
                                            t.calcBoxTotal(gab(this))
                                        }));
                                    window.dispatchEvent(new Event("resize"))
                                };
                                "complete" == document.readyState ? o(i) : gab(document).ready(function() {
                                    o(i)
                                })
                            }
                        if (t.productRelated.enable)
                            if ((u = t.getBoxProducts(t.productRelated.conditions, t.productRelated.limit, t.productRelated.random, 1 != t.productRelated.template, r)).products.length) {
                                if (t.productRelated.thisItem && 1 != t.productRelated.template && t.product.available) {
                                    u.products.unshift(t.product);
                                    n = t.product.variants.find(t=>t.available);
                                    u.totalPrice += n.price
                                }
                                var s = GurLiquid.parse(gab("#product_related-template").html().replace(/scripttag/g, "script")).render({
                                    products: u.products,
                                    total_price: u.totalPrice,
                                    cur_product_id: t.product.id,
                                    no_image_url: t.no_image_url
                                })
                                  , a = function(e) {
                                    if (gab("#globoRelatedProductsCustom, .globoRelatedProductsCustom").length ? gab("#globoRelatedProductsCustom, .globoRelatedProductsCustom").html(e) : gab("#globoRelatedProducts").html(e),
                                    1 == t.productRelated.template) {
                                        var n = {
                                            items: t.carousel_items,
                                            responsive: {
                                                0: {
                                                    items: t.carousel_items <= 2 ? t.carousel_items : 2
                                                },
                                                576: {
                                                    items: t.carousel_items <= 3 ? t.carousel_items : 3
                                                },
                                                768: {
                                                    items: t.carousel_items <= 4 ? t.carousel_items : 4
                                                },
                                                992: {
                                                    items: t.carousel_items <= 5 ? t.carousel_items : 5
                                                },
                                                1200: {
                                                    items: t.carousel_items <= 6 ? t.carousel_items : 6
                                                }
                                            },
                                            responsiveBaseElement: "#ga-product_related",
                                            nav: !0,
                                            dots: !1,
                                            loop: !1,
                                            navText: ['<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16" fill-rule="evenodd"></path></svg>', '<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16" fill-rule="evenodd"></path></svg>'],
                                            onInitialized: t.owlCarouselFix(),
                                            onResized: t.owlCarouselFix()
                                        };
                                        t.carousel_autoplay && (n.autoplay = !0,
                                        n.autoplayTimeout = 3e3,
                                        n.autoplaySpeed = 1e3,
                                        n.autoplayHoverPause = !0),
                                        gab("#ga-product_related .ga-carousel").gFOwlCarousel(n)
                                    } else
                                        !window.productRelatedProductsUncheck || 2 != t.productRelated.template && 3 != t.productRelated.template || (gab(".selectedItem").prop("checked", !1),
                                        gab(".ga-products-box").each(function() {
                                            t.calcBoxTotal(gab(this))
                                        }));
                                    window.dispatchEvent(new Event("resize")),
                                    window.dispatchEvent(new Event("globoFilterRenderCompleted"))
                                };
                                "complete" == document.readyState ? a(s) : gab(document).ready(function() {
                                    a(s)
                                })
                            }
                        t.initEvents()
                    } else if ("cart" == e && t.cart.enable) {
                        var u;
                        if ((u = t.getBoxProducts(t.cart.conditions, t.cart.limit, t.cart.random, 1 != t.cart.template, r)).products.length) {
                            var l = GurLiquid.parse(gab("#cart-template").html().replace(/scripttag/g, "script")).render({
                                products: u.products,
                                total_price: u.totalPrice,
                                cur_product_id: 0,
                                no_image_url: t.no_image_url
                            })
                              , c = function(e) {
                                if (gab("#globoRelatedProductsCustom").length ? gab("#globoRelatedProductsCustom").html(e) : gab("#globoRelatedProducts").html(e),
                                1 == t.cart.template) {
                                    var n = {
                                        items: t.carousel_items,
                                        responsive: {
                                            0: {
                                                items: t.carousel_items <= 2 ? t.carousel_items : 2
                                            },
                                            576: {
                                                items: t.carousel_items <= 3 ? t.carousel_items : 3
                                            },
                                            768: {
                                                items: t.carousel_items <= 4 ? t.carousel_items : 4
                                            },
                                            992: {
                                                items: t.carousel_items <= 5 ? t.carousel_items : 5
                                            },
                                            1200: {
                                                items: t.carousel_items <= 6 ? t.carousel_items : 6
                                            }
                                        },
                                        responsiveBaseElement: "#ga-cart",
                                        nav: !0,
                                        dots: !1,
                                        loop: !1,
                                        navText: ['<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16" fill-rule="evenodd"></path></svg>', '<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16" fill-rule="evenodd"></path></svg>'],
                                        onInitialized: t.owlCarouselFix(),
                                        onResized: t.owlCarouselFix()
                                    };
                                    t.carousel_autoplay && (n.autoplay = !0,
                                    n.autoplayTimeout = 3e3,
                                    n.autoplaySpeed = 1e3,
                                    n.autoplayHoverPause = !0),
                                    gab("#ga-cart .ga-carousel").gFOwlCarousel(n)
                                } else
                                    !window.cartUncheck || 2 != t.cart.template && 3 != t.cart.template || (gab(".selectedItem").prop("checked", !1),
                                    gab(".ga-products-box").each(function() {
                                        t.calcBoxTotal(gab(this))
                                    }));
                                window.dispatchEvent(new Event("resize")),
                                window.dispatchEvent(new Event("globoFilterRenderCompleted"))
                            };
                            "complete" == document.readyState ? c(l) : gab(document).ready(function() {
                                c(l)
                            })
                        }
                        t.initEvents()
                    }
                })
            }
        }
    }
    ,
    globoAlsoBought.prototype.getParameterByName = function(t, e) {
        e = e || window.location.href,
        t = t.replace(/[\[\]]/g, "\\$&");
        var n = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
        return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "" : null
    }
    ,
    globoAlsoBought.prototype.updateCart = function(t) {
        var e = this;
        gab.ajax({
            url: "/cart.js",
            type: "get",
            dataType: "json",
            success: function(n) {
                var i = n.items.map(t=>t.product_id.toString())
                  , r = [];
                if (r = (r = n.attributes && n.attributes["Globo Related Products"] ? n.attributes["Globo Related Products"].split(",").concat(t) : t).filter((t,e,n)=>-1 == i.indexOf(t) && n.indexOf(t) === e),
                gab.ajax({
                    url: "/cart/update.js",
                    type: "post",
                    dataType: "json",
                    data: {
                        attributes: {
                            "Globo Related Products": r.join(",")
                        }
                    }
                }),
                e.discount) {
                    var o = gab.cookie("discountCode")
                      , s = n.items.filter(t=>-1 != r.indexOf(t.variant_id.toString())).map(t=>t.product_id)
                      , a = Math.round((new Date).getTime() / 1e3)
                      , u = s.reduce((t,e)=>Number(t) + Number(e), 0);
                    u = Number(u) + Number(a);
                    var l = {
                        ids: s,
                        shop: e.shop,
                        signature: u,
                        timestamp: a
                    };
                    o && (l.code = o),
                    gab.ajax({
                        url: e.apiUrl + "/createDiscountCode",
                        method: "GET",
                        dataType: "jsonp",
                        data: l,
                        success: function(i) {
                            i.success ? (gab.cookie("discountCode", i.code, {
                                expires: 7
                            }),
                            e.redirect ? window.location.replace(window.location.origin + "/discount/" + i.code + "?redirect=/cart") : gab.ajax({
                                url: "/discount/" + i.code + "?redirect=" + window.location.href,
                                complete: function() {
                                    window.dispatchEvent(new CustomEvent("globoRelatedProductsUpdateCart",{
                                        detail: {
                                            cart: n,
                                            ids: t
                                        }
                                    }))
                                }
                            })) : e.redirect ? window.location.replace(window.location.origin + "/cart") : window.dispatchEvent(new CustomEvent("globoRelatedProductsUpdateCart",{
                                detail: {
                                    cart: n,
                                    ids: t
                                }
                            }))
                        }
                    })
                } else
                    e.redirect ? window.location.replace(window.location.origin + "/cart") : window.dispatchEvent(new CustomEvent("globoRelatedProductsUpdateCart",{
                        detail: {
                            cart: n,
                            ids: t
                        }
                    }))
            }
        })
    }
    ,
    globoAlsoBought.prototype.owlCarouselFix = function() {
        var t = this
          , e = window.pageYOffset
          , n = e + gab(window).innerHeight();
        gab(".ga-carousel").each(function() {
            var i = gab(this);
            if (t.carousel_autoplay) {
                var r = i.offset().top
                  , o = i.offset().top + i.outerHeight();
                n > r && e < o ? i.trigger("play.owl.autoplay") : i.trigger("stop.owl.autoplay")
            }
            var s = 0
              , a = 0;
            i.find(".ga-product_title, .ga-product_price-container").css({
                height: "auto",
                "min-height": "0"
            }),
            i.find(".ga-product_title").each(function() {
                s = gab(this).height() > s ? gab(this).height() : s
            }),
            i.find(".ga-product_title").css("min-height", s + "px"),
            i.find(".ga-product_price-container").each(function() {
                a = gab(this).height() > a ? gab(this).height() : a
            }),
            i.find(".ga-product_price-container").css("min-height", a + "px"),
            i.find(".ga-product_variant_select:not(.ga-hide)").length > 0 && i.find(".ga-product_variant_select.ga-hide").addClass("ga-hidden")
        })
    }
    ,
    globoAlsoBought.prototype.calcBoxTotal = function(t) {
        t.find(".selectedItem").each(function() {
            var e = gab(this);
            e.is(":checked") ? (e.closest("li").removeClass("ga-deactive").find(".ga-product_variant_select").prop("disabled", !1),
            t.find("#ga-product_" + e.val()).removeClass("ga-hide")) : (e.closest("li").addClass("ga-deactive").find(".ga-product_variant_select").prop("disabled", !0),
            t.find("#ga-product_" + e.val()).addClass("ga-hide"))
        }),
        0 == t.find(".selectedItem:checked").length ? t.find(".ga-product-form").hide() : t.find(".ga-product-form").show();
        var e = 0;
        t.find(".ga-product_variant_select:enabled").each(function() {
            e += gab(this).is("input") ? gab(this).data("price") : parseFloat(gab(this).find("option:selected").data("price"))
        });
        var n = GurLiquid.parse("{{ total_price | money }}").render({
            total_price: e
        });
        t.find(".ga-product_totalprice").html(n),
        this.initEventCallback()
    }
    ,
    globoAlsoBought.prototype.initEventCallback = function() {
        "undefined" != typeof DoublyGlobalCurrency && gab("select.currency-switcher").length && DoublyGlobalCurrency.convertAll(gab("select.currency-switcher").val())
    }
    ,
    globoAlsoBought.prototype.initEvents = function() {
        var app = this;
        gab(document).on("change", ".selectedItem", function(t) {
            var e = gab(t.target);
            e.hasClass("thisProduct") && e.prop("checked", !0);
            var n = e.closest(".ga-products-box");
            app.calcBoxTotal(n)
        }),
        gab(document).on("change", ".ga-product_variant_select", function(t) {
            var e = gab(t.target)
              , n = parseFloat(e.find("option:selected").attr("data-price"))
              , i = parseFloat(e.find("option:selected").attr("data-compare_at_price"))
              , r = e.closest(".ga-products-box")
              , o = e.closest("li")
              , s = o.data("product-id")
              , a = e.find("option:selected").data("image");
            if (r.find("img#ga-product_image_" + s).attr("src", a),
            o.find("div#ga-product_image_" + s).css("background-image", "url(" + a + ")"),
            o.find(".ga-product_price").html(GurLiquid.parse("{{ price | money }}").render({
                price: n
            })),
            i > 0 && i > n) {
                var u = GurLiquid.parse("{{ compare_at_price | money }}").render({
                    compare_at_price: i
                });
                o.find(".ga-product_oldprice").length > 0 ? o.find(".ga-product_oldprice").html(u) : o.find(".ga-product_price-container").append('<s class="ga-product_oldprice">' + u + "</s>")
            } else
                o.find(".ga-product_oldprice").remove();
            var l = 0;
            r.find(".ga-product_variant_select:enabled").each(function() {
                l += gab(this).is("input") ? gab(this).data("price") : parseFloat(gab(this).find("option:selected").data("price"))
            });
            u = GurLiquid.parse("{{ total_price | money }}").render({
                total_price: l
            });
            r.find(".ga-product_totalprice").html(u),
            app.initEventCallback()
        }),
        gab(document).on("click", ".ga-addalltocart", function(event) {
            var button = gab(event.target)
              , ids = [];
            button.closest(".ga-products-box").find(".ga-product_variant_select:enabled").each(function() {
                ids.push(gab(this).val())
            }),
            gab.ajax({
                url: "/cart/add.js",
                type: "post",
                dataType: "json",
                data: {
                    id: ids
                },
                beforeSend: function(t, e) {
                    button.prop("disabled", !0)
                },
                success: function(t) {
                    button.text(button.data("added")),
                    window.dispatchEvent(new Event("globoRelatedProductsAddedProductsToCart")),
                    app.updateCart(ids)
                },
                error: function error(XMLHttpRequest, textStatus) {
                    var data = eval("(" + XMLHttpRequest.responseText + ")");
                    data.message && (alert(data.message + ": " + data.description),
                    button.prop("disabled", !1))
                },
                complete: function() {
                    button.prop("disabled", !1)
                }
            })
        }),
        gab(document).on("click", ".ga-product_addtocart", function(event) {
            var button = gab(event.target)
              , id = button.closest(".ga-product").find(".ga-product_variant_select").val()
              , data = {
                quantity: 1,
                id: id
            };
            button.closest("form").length && (data = button.closest("form").serialize()),
            gab.ajax({
                url: "/cart/add.js",
                type: "post",
                dataType: "json",
                data: data,
                beforeSend: function(t, e) {
                    button.prop("disabled", !0)
                },
                success: function(t) {
                    button.text(button.data("added")),
                    window.dispatchEvent(new Event("globoRelatedProductsAddedProductsToCart")),
                    app.updateCart([id])
                },
                error: function error(XMLHttpRequest, textStatus) {
                    var data = eval("(" + XMLHttpRequest.responseText + ")");
                    data.message && alert(data.message + ": " + data.description),
                    button.prop("disabled", !1)
                },
                complete: function() {
                    button.prop("disabled", !1)
                }
            })
        });
        var variantIdSelector = gab('form[action*="/cart/add"]:visible:first [name="id"], form[action*="/checkout"]:visible:first [name="id"]');
        "product" == app.getPageType() && variantIdSelector.length && gab('[data-product-id="' + app.product.id + '"]').length && (gab('.ga-products-box [data-product-id="' + app.product.id + '"] .ga-product_variant_select').val(variantIdSelector.val()).change(),
        gab(document).on("change", 'form[action*="/cart/add"]:visible:first input, form[action*="/checkout"]:visible:first input, form[action*="/cart/add"]:visible:first select:not(.ga-product_variant_select), form[action*="/checkout"]:visible:first select:not(.ga-product_variant_select)', function() {
            gab('.ga-products-box [data-product-id="' + app.product.id + '"] .ga-product_variant_select').val(variantIdSelector.val()).change()
        })),
        gab(window).scroll(function() {
            app.owlCarouselFix(!0, !1)
        }),
        app.initEventCallback()
    }
    ,
    globoAlsoBought.prototype.getBoxProducts = function(t, e, n, i=!1, r={}) {
        var o = this
          , s = []
          , a = []
          , u = 0
          , l = o.getPageType();
        return gab.each(t, function(t, i) {
            "product" == l && "manual" == i && o.product.id && o.manualRecommendations[o.product.id] ? gab.each(o.manualRecommendations[o.product.id], function(t, u) {
                gab.each(o.relatedProducts[i], function(t, i) {
                    if (!n && a.length >= e || n && a.length >= 4 * e)
                        return !1;
                    Number(u) == Number(i.id) && -1 == a.indexOf(Number(i.id)) && -1 == r.ids.indexOf(Number(i.id)) && (a.push(Number(i.id)),
                    s.push(i))
                })
            }) : o.relatedProducts[i] && gab.each(o.relatedProducts[i], function(t, i) {
                if (!n && a.length >= e || n && a.length >= 4 * e)
                    return !1;
                -1 != a.indexOf(Number(i.id)) || -1 != r.ids.indexOf(Number(i.id)) || "product" == l && Number(i.id) == Number(o.product.id) || (a.push(Number(i.id)),
                s.push(i))
            })
        }),
        s = n ? o.shuffle(s).slice(0, e) : s.slice(0, e),
        i && gab.each(s, function(t, e) {
            gab.each(e.variants, function(t, e) {
                if (e.available)
                    return u += e.price,
                    !1
            })
        }),
        {
            products: s,
            totalPrice: u
        }
    }
    ,
    globoAlsoBought.prototype.getDeferredStuff = function(t, e) {
        var n = this
          , i = (n.getPageType(),
        [])
          , r = n.exclude_tags.length ? n.exclude_tags.map(t=>' AND -tag:"' + t + '"').join("") : "";
        return gab.each(t, function(t, o) {
            if ("vendor" == o) {
                if (e.vendors.length) {
                    var s = e.vendors.map(t=>'vendor:"' + t + '"');
                    i.push(gab.ajax({
                        url: window.location.origin + window.globoAlsoBoughtRootUrl + "/search",
                        method: "POST",
                        dataType: "json",
                        data: {
                            q: s.join(" OR ") + r,
                            view: n.view_name,
                            type: "product"
                        },
                        success: function(t) {
                            n.relatedProducts[o] = t
                        }
                    }))
                }
            } else if ("manual" == o) {
                if (e.ids.length) {
                    var a = [];
                    if (gab.each(e.ids, function(t, e) {
                        var i = n.manualRecommendations[e] || [];
                        a = a.concat(i)
                    }),
                    a.length) {
                        var u = a.map(t=>'id:"' + t + '"');
                        i.push(gab.ajax({
                            url: window.location.origin + window.globoAlsoBoughtRootUrl + "/search",
                            method: "POST",
                            dataType: "json",
                            data: {
                                q: u.join(" OR ") + r,
                                view: n.view_name,
                                type: "product"
                            },
                            success: function(t) {
                                var e = [];
                                gab.each(a, function(n, i) {
                                    gab.each(t, function(t, n) {
                                        n.id == i && e.push(n)
                                    })
                                }),
                                n.relatedProducts[o] = e
                            }
                        }))
                    }
                }
            } else if ("bought_together" == o)
                e.ids.length && i.push(gab.ajax({
                    url: n.apiUrl + "/getBoughtTogetherProducts",
                    method: "GET",
                    dataType: "json",
                    data: {
                        shop: n.shop,
                        root_url: window.globoAlsoBoughtRootUrl,
                        product_ids: e.ids,
                        view: n.view_name,
                        limit: 4 * n.limit
                    },
                    success: function(t) {
                        t.success && t.data && t.data.length && (n.relatedProducts[o] = t.data)
                    }
                }));
            else if ("type" == o) {
                if (e.types.length) {
                    var l = e.types.map(t=>'product_type:"' + t + '"');
                    i.push(gab.ajax({
                        url: window.location.origin + window.globoAlsoBoughtRootUrl + "/search",
                        method: "POST",
                        dataType: "json",
                        data: {
                            q: l.join(" OR ") + r,
                            view: n.view_name,
                            type: "product"
                        },
                        success: function(t) {
                            n.relatedProducts[o] = t
                        }
                    }))
                }
            } else if ("collection" == o)
                e.collections.length && i.push(gab.ajax({
                    url: window.location.origin + window.globoAlsoBoughtRootUrl + "/collections/" + e.collections[0] + "?view=" + n.view_name,
                    method: "GET",
                    dataType: "html",
                    success: function(t) {
                        n.relatedProducts[o] = JSON.parse(t)
                    }
                }));
            else if ("tags" == o) {
                if (e.tags.length) {
                    var c;
                    if ((c = e.tags.map(t=>'tag:"' + t + '"')).length < 6)
                        (c = n.combine(c, 1)).reverse(),
                        c = c.map(t=>t.length > 1 ? "(" + t.join(" AND ") + ")" : t.join(" AND "));
                    i.push(gab.ajax({
                        url: window.location.origin + window.globoAlsoBoughtRootUrl + "/search",
                        method: "POST",
                        dataType: "json",
                        data: {
                            q: c.join(" OR ") + r,
                            view: n.view_name,
                            type: "product"
                        },
                        success: function(t) {
                            n.relatedProducts[o] = t
                        }
                    }))
                }
            } else
                "global" == o ? i.push(gab.ajax({
                    url: window.location.origin + window.globoAlsoBoughtRootUrl + "/search",
                    method: "POST",
                    dataType: "json",
                    data: {
                        q: 'tag:"Recommendation" OR tag:"recommendation"' + r,
                        view: n.view_name,
                        type: "product"
                    },
                    success: function(t) {
                        n.relatedProducts[o] = t
                    }
                })) : "random" == o && i.push(gab.ajax({
                    url: window.location.origin + window.globoAlsoBoughtRootUrl + "/collections/all?sort_by=created-descending&view=" + n.view_name,
                    method: "GET",
                    dataType: "html",
                    success: function(t) {
                        n.relatedProducts[o] = n.shuffle(JSON.parse(t))
                    }
                }))
        }),
        i
    }
    ,
    globoAlsoBought.prototype.combine = function(t, e) {
        for (var n = function(t, e, i, r) {
            if (0 != t)
                for (var o = 0; o < e.length; o++)
                    n(t - 1, e.slice(o + 1), i.concat([e[o]]), r);
            else
                i.length > 0 && (r[r.length] = i)
        }, i = [], r = e; r < t.length; r++)
            n(r, t, [], i);
        return i.push(t),
        i
    }
    ,
    globoAlsoBought.prototype.shuffle = function(t) {
        var e, n, i;
        for (i = t.length - 1; i > 0; i--)
            e = Math.floor(Math.random() * (i + 1)),
            n = t[i],
            t[i] = t[e],
            t[e] = n;
        return t
    }
    ,
    globoAlsoBought.prototype.checkUTMSource = function() {
        var t = window.location.toString()
          , e = new RegExp(this.cart_properties_name + "=" + this.cart_properties_value);
        return null !== t.match(e)
    }
    ,
    globoAlsoBought.prototype.getPageType = function() {
        var t = window.location.toString();
        return null !== t.match(/\/products\//) || null !== t.match(/\/products_preview/) ? "product" : null !== t.match(/\/cart/) ? "cart" : void 0
    }
}(jQuery);
